(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_ndev-ax26-clean-and-corners"] && !Shopify.designMode) return;
  try {
    (function () {
    'use strict';

    const NS = 'ndev-ax26-clean-and-corners';
    const ROOT_SELECTOR = '[data-ndev-ax26-clean-and-corners]';
    const INIT_ATTR = 'data-' + NS + '-initialized';

    const registryKey = '__ndevBlockControllers__';
    if (!window[registryKey]) window[registryKey] = {};
    if (!window[registryKey][NS]) window[registryKey][NS] = new WeakMap();
    const controllers = window[registryKey][NS];

    function queryCards(root) {
      return root ? root.querySelectorAll('.ndev-ax26-clean-and-corners-card') : [];
    }

    function destroyOne(root) {
      const controller = root ? controllers.get(root) : null;
      if (controller && typeof controller.destroy === 'function') controller.destroy();
      if (root) controllers.delete(root);
    }

    function initOne(root) {
      if (!root) return;

      destroyOne(root);
      root.setAttribute(INIT_ATTR, '1');

      const cards = queryCards(root);
      if (!cards.length) return;

      const paginationEl = root.querySelector('[data-ndev-ax26-clean-and-corners-pagination]');
      const paginationPrevBtn = paginationEl
        ? paginationEl.querySelector('.ndev-ax26-clean-and-corners__pagination-button--prev')
        : null;
      const paginationNextBtn = paginationEl
        ? paginationEl.querySelector('.ndev-ax26-clean-and-corners__pagination-button--next')
        : null;
      const ringHost = paginationNextBtn
        ? paginationNextBtn.querySelector('[data-ndev-ax26-clean-and-corners-ring-host]')
        : null;

      let ringAnimId = null;

      function cancelRingAnim() {
        if (ringAnimId) {
          cancelAnimationFrame(ringAnimId);
          ringAnimId = null;
        }
      }

      function startRingAnim(ring, duration) {
        if (!ring) return;
        cancelRingAnim();
        ring.style.strokeDashoffset = '113.1';
        let startTime = performance.now();
        function step(now) {
          let elapsed = now - startTime;
          let progress = Math.min(elapsed / duration, 1);
          ring.style.strokeDashoffset = String(113.1 * (1 - progress));
          if (progress < 1) {
            ringAnimId = requestAnimationFrame(step);
          }
        }
        ringAnimId = requestAnimationFrame(step);
      }

      const allSwitchItems = [];

      for (let c = 0; c < cards.length; c++) {
        const switchEl = cards[c].querySelector('.ndev-ax26-clean-and-corners-card__switch');
        if (!switchEl) continue;

        while (switchEl.firstChild) {
          switchEl.removeChild(switchEl.firstChild);
        }

        for (let i = 0; i < cards.length; i++) {
          const title = (cards[i].getAttribute('data-title') || '').trim();
          const item = document.createElement('div');
          item.classList.add('ndev-ax26-clean-and-corners-card__switch-item');
          item.textContent = title;
          item.dataset.index = String(i);
          item.addEventListener('click', function (e) {
            e.stopPropagation();
            const idx = parseInt(this.dataset.index, 10);
            setActive(idx);
            startTimer();
          });
          switchEl.appendChild(item);
          allSwitchItems.push(item);
        }

        switchEl.classList.add('ndev-ax26-clean-and-corners-card__switch--ready');
      }

      let autoplayOn = root.getAttribute('data-autoplay') === 'true';
      const autoplayMs = parseInt(root.getAttribute('data-autoplay-speed'), 10) || 4000;
      const autoplayInView = (root.getAttribute('data-autoplay-start') || 'immediate').trim() === 'in_view';

      let index = 0;
      let timer = null;
      let io = null;
      let reducedMotion = false;
      let inViewKickTimer = null;

      try {
        reducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      } catch (e) {}

      autoplayOn = autoplayOn && !reducedMotion;

      if (autoplayOn && ringHost) {
        while (ringHost.firstChild) {
          ringHost.removeChild(ringHost.firstChild);
        }
        const ringSvg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
        ringSvg.setAttribute('class', 'ndev-ax26-clean-and-corners__progress-ring-svg');
        ringSvg.setAttribute('viewBox', '0 0 40 40');
        const ringCircle = document.createElementNS('http://www.w3.org/2000/svg', 'circle');
        ringCircle.setAttribute('class', 'ndev-ax26-clean-and-corners__progress-ring');
        ringCircle.setAttribute('cx', '20');
        ringCircle.setAttribute('cy', '20');
        ringCircle.setAttribute('r', '18');
        ringSvg.appendChild(ringCircle);
        ringHost.appendChild(ringSvg);
      }

      function getProgressRing() {
        return paginationEl ? paginationEl.querySelector('.ndev-ax26-clean-and-corners__progress-ring') : null;
      }

      function updatePaginationDisabled() {
        if (!paginationPrevBtn || !paginationNextBtn) return;
        const lock = cards.length <= 1;
        paginationPrevBtn.disabled = lock;
        paginationNextBtn.disabled = lock;
      }

      function setClasses(n) {
        index = n;
        for (let c = 0; c < cards.length; c++) {
          cards[c].classList.toggle('actived', c === n);
        }
        for (let s = 0; s < allSwitchItems.length; s++) {
          let itemIdx = parseInt(allSwitchItems[s].dataset.index, 10);
          allSwitchItems[s].classList.toggle('ndev-ax26-clean-and-corners-card__switch-item--active', itemIdx === n);
        }
        updatePaginationDisabled();
      }

      function setActive(i) {
        if (!cards.length) return;
        const n = ((i % cards.length) + cards.length) % cards.length;
        setClasses(n);
      }

      function next() {
        setActive(index + 1);
        startRingAnim(getProgressRing(), autoplayMs);
      }

      function stopTimer() {
        if (timer) {
          clearInterval(timer);
          timer = null;
        }
      }

      function startTimer() {
        stopTimer();
        if (!autoplayOn || cards.length < 2) return;
        timer = setInterval(next, autoplayMs);
        startRingAnim(getProgressRing(), autoplayMs);
      }

      function inViewport() {
        const r = root.getBoundingClientRect();
        const vh = window.innerHeight || document.documentElement.clientHeight || 0;
        const vw = window.innerWidth || document.documentElement.clientWidth || 0;
        return r.bottom > 0 && r.top < vh && r.right > 0 && r.left < vw;
      }

      function setupAutoplay() {
        if (!autoplayOn) return;

        const mobileMq = window.matchMedia('(max-width: 1023px)');

        function startIfMobile() {
          if (!mobileMq.matches) {
            stopTimer();
            cancelRingAnim();
            return;
          }
          if (autoplayInView && !inViewport()) return;
          startTimer();
        }

        mobileMq.addEventListener('change', startIfMobile);

        if (autoplayInView && typeof IntersectionObserver !== 'undefined') {
          io = new IntersectionObserver(
            function (entries) {
              if (!mobileMq.matches) return;
              const ok = entries.some(function (en) {
                return en.isIntersecting;
              });
              if (ok) {
                startTimer();
              } else {
                stopTimer();
                cancelRingAnim();
              }
            },
            { root: null, threshold: 0 }
          );
          io.observe(root);
          if (mobileMq.matches) {
            inViewKickTimer = setTimeout(function () {
              inViewKickTimer = null;
              if (inViewport()) startTimer();
            }, 50);
          }
        } else {
          startIfMobile();
        }
      }

      function onCardClick(e) {
        let target = e.target;
        while (target && target !== root) {
          if (target.classList && target.classList.contains('ndev-ax26-clean-and-corners-card')) {
            for (let i = 0; i < cards.length; i++) {
              if (cards[i] === target) {
                setActive(i);
                startTimer();
                return;
              }
            }
          }
          target = target.parentElement;
        }
      }

      function onPaginationClick(e) {
        if (!paginationEl) return;
        let target = e.target;
        while (target && target !== paginationEl) {
          if (target.classList && target.classList.contains('ndev-ax26-clean-and-corners__pagination-button--prev')) {
            setActive(index - 1);
            startTimer();
            return;
          }
          if (target.classList && target.classList.contains('ndev-ax26-clean-and-corners__pagination-button--next')) {
            setActive(index + 1);
            startTimer();
            return;
          }
          target = target.parentElement;
        }
      }

      updatePaginationDisabled();
      root.addEventListener('click', onCardClick);
      if (paginationEl) {
        paginationEl.addEventListener('click', onPaginationClick);
      }

      setupAutoplay();

      root.classList.add(NS + '--ready');
      setClasses(0);

      controllers.set(root, {
        root: root,
        destroy: function () {
          stopTimer();
          cancelRingAnim();
          if (inViewKickTimer) clearTimeout(inViewKickTimer);
          root.removeEventListener('click', onCardClick);
          if (paginationEl) {
            paginationEl.removeEventListener('click', onPaginationClick);
          }
          if (io) {
            io.disconnect();
            io = null;
          }
          try { root.removeAttribute(INIT_ATTR); } catch (e) {}
          try { root.classList.remove(NS + '--ready'); } catch (e) {}
        }
      });
    }

    function initAll(scope) {
      const base = (scope && scope.querySelectorAll) ? scope : document;
      const list = base.querySelectorAll(ROOT_SELECTOR);
      for (let i = 0; i < list.length; i++) initOne(list[i]);
    }

    function destroyAll(scope) {
      const base = (scope && scope.querySelectorAll) ? scope : document;
      const list = base.querySelectorAll(ROOT_SELECTOR);
      for (let i = 0; i < list.length; i++) destroyOne(list[i]);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { initAll(); });
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', function (event) {
      let target = event && event.target ? event.target : null;
      if (target) {
        requestAnimationFrame(function () {
          initAll(target);
        });
      }
    });

    document.addEventListener('shopify:section:unload', function (event) {
      destroyAll(event && event.target ? event.target : null);
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_ndev-ax26-flip-card"] && !Shopify.designMode) return;
  try {
    (function () {
    'use strict';

    const NS = 'ndev-ax26-flip-card';
    const ROOT_SELECTOR = '[data-ndev-ax26-flip-card]';
    const TRACK_SELECTOR = '[data-ndev-ax26-flip-card-track]';
    const INIT_ATTR = 'data-' + NS + '-initialized';
    const TAB_COMMENT_PREFIX = 'ndev-ax26-flip-tab|';
    /** PC 视口（与主题二级断点一致）：传给 matchMedia 的查询字符串，不是布尔值 */
    const MQ_PC = '(min-width: 1024px)';

    function querySlideFaceElements(root) {
      const wrap = root.querySelector('.ndev-ax26-flip-card__slides');
      if (!wrap) return [];
      const out = [];
      const nodes = wrap.children;
      for (let i = 0; i < nodes.length; i++) {
        const el = nodes[i];
        if (!el || el.nodeType !== 1) continue;
        const tag = el.tagName;
        if (tag === 'STYLE' || tag === 'SCRIPT') continue;
        if (el.hasAttribute && el.hasAttribute('data-ndev-ax26-flip-card-slide-face')) {
          out.push(el);
        }
      }
      return out;
    }

    function readTrigger(root, attr) {
      const v = root.getAttribute(attr);
      return v === 'tabs' ? 'tabs' : 'scroll';
    }

    function getEffectiveTrigger(root) {
      const desktop = window.matchMedia && window.matchMedia(MQ_PC).matches;
      return desktop ? readTrigger(root, 'data-pc-trigger') : readTrigger(root, 'data-mb-trigger');
    }

    function readTabLabelFromWrapper(wrap) {
      if (!wrap || typeof wrap.getAttribute !== 'function') return '';
      const ds = wrap.getAttribute('data-ndev-ax26-flip-card-tab-label');
      if (ds != null && String(ds).trim() !== '') return String(ds).trim();
      const nodes = wrap.childNodes;
      for (let i = 0; i < nodes.length; i++) {
        const n = nodes[i];
        if (n && n.nodeType === 8) {
          const t = (n.textContent || '').trim();
          if (t.indexOf(TAB_COMMENT_PREFIX) === 0) return t.slice(TAB_COMMENT_PREFIX.length).trim();
        }
      }
      return '';
    }

    function clearTabList(tabList) {
      if (!tabList) return;
      while (tabList.firstChild) {
        tabList.removeChild(tabList.firstChild);
      }
    }

    function buildTabs(slides, tabList) {
      clearTabList(tabList);
      const labels = document.createElement('div');
      labels.className = 'ndev-ax26-flip-card__tabs-labels';
      labels.setAttribute('role', 'tablist');
      labels.setAttribute('aria-label', 'Slide tabs');

      const btns = [];
      const n = slides.length;
      for (let i = 0; i < n; i++) {
        const face = slides[i];
        let label = readTabLabelFromWrapper(face);
        if (!label) label = 'Tab ' + (i + 1);
        const b = document.createElement('button');
        b.type = 'button';
        b.className = 'ndev-ax26-flip-card__tab';
        b.setAttribute('role', 'tab');
        b.setAttribute('data-tab-index', String(i));
        b.setAttribute('aria-selected', i === 0 ? 'true' : 'false');
        b.setAttribute('tabindex', i === 0 ? '0' : '-1');
        b.textContent = label;
        labels.appendChild(b);
        btns.push(b);
      }

      const track = document.createElement('div');
      track.className = 'ndev-ax26-flip-card__tabs-track';
      track.setAttribute('aria-hidden', 'true');
      const count = Math.max(n, 1);
      track.style.setProperty('--ndev-ax26-flip-tab-count', String(count));
      track.style.setProperty('--ndev-ax26-flip-tab-active', '0');

      const line = document.createElement('div');
      line.className = 'ndev-ax26-flip-card__tabs-line';
      const indicator = document.createElement('div');
      indicator.className = 'ndev-ax26-flip-card__tabs-indicator';
      track.appendChild(line);
      track.appendChild(indicator);

      const tabCaption = document.createElement('div');
      tabCaption.className = 'ndev-ax26-flip-card__tab-caption';
      tabCaption.setAttribute('data-ndev-ax26-flip-card-tab-caption', '');
      tabCaption.setAttribute('hidden', '');

      tabList.appendChild(labels);
      tabList.appendChild(track);
      tabList.appendChild(tabCaption);

      return btns;
    }

    function syncTabAria(tabButtons, idx, root) {
      if (!tabButtons || !tabButtons.length) return;
      for (let i = 0; i < tabButtons.length; i++) {
        tabButtons[i].setAttribute('aria-selected', i === idx ? 'true' : 'false');
        tabButtons[i].setAttribute('tabindex', i === idx ? '0' : '-1');
      }
      if (!root || typeof root.querySelector !== 'function') return;
      const track = root.querySelector('.ndev-ax26-flip-card__tabs-track');
      if (!track) return;
      track.style.setProperty('--ndev-ax26-flip-tab-count', String(tabButtons.length));
      track.style.setProperty('--ndev-ax26-flip-tab-active', String(idx));
    }

    function syncTabCaption(root, slides, idx) {
      if (!root || !slides || !slides.length) return;
      const cap = root.querySelector('[data-ndev-ax26-flip-card-tab-caption]');
      if (!cap) return;
      while (cap.firstChild) cap.removeChild(cap.firstChild);
      if (getEffectiveTrigger(root) !== 'tabs') {
        cap.setAttribute('hidden', '');
        return;
      }
      const slide = slides[idx];
      const src =
        slide && slide.querySelector ? slide.querySelector('[data-ndev-ax26-flip-card-media-caption]') : null;
      if (!src) {
        cap.setAttribute('hidden', '');
        return;
      }
      const nodes = src.childNodes;
      for (let i = 0; i < nodes.length; i++) {
        const n = nodes[i];
        if (!n) continue;
        cap.appendChild(n.cloneNode(true));
      }
      const text = (cap.textContent || '').trim();
      if (text) {
        cap.removeAttribute('hidden');
      } else {
        while (cap.firstChild) cap.removeChild(cap.firstChild);
        cap.setAttribute('hidden', '');
      }
    }

    const registryKey = '__ndevBlockControllers__';
    if (!window[registryKey]) window[registryKey] = {};
    if (!window[registryKey][NS]) window[registryKey][NS] = new WeakMap();
    const controllers = window[registryKey][NS];

    function prefersReducedMotion() {
      return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    }

    function parseFlipMs(root) {
      const raw = root.getAttribute('data-flip-ms');
      const n = parseInt(raw, 10);
      return n > 0 ? n : 600;
    }

    function clearFlipClasses(slide) {
      slide.classList.remove(
        'flip-out-fwd',
        'flip-out-back',
        'flip-in-from-fwd',
        'flip-in-to-fwd',
        'flip-in-from-back',
        'flip-in-to-back'
      );
    }

    function setSlidesIdle(slides, exceptIndex) {
      for (let i = 0; i < slides.length; i++) {
        const s = slides[i];
        clearFlipClasses(s);
        s.classList.remove('is-active');
        if (i === exceptIndex) {
          s.classList.add('is-active');
        }
      }
    }

    function pauseAllVideos(slides) {
      for (let i = 0; i < slides.length; i++) {
        const vids = slides[i].querySelectorAll('video');
        for (let j = 0; j < vids.length; j++) {
          try {
            vids[j].pause();
          } catch (e) {}
        }
      }
    }

    function playSlideVideos(slide) {
      if (!slide) return;
      const vids = slide.querySelectorAll('video');
      for (let j = 0; j < vids.length; j++) {
        const v = vids[j];
        try {
          if (!v.muted) v.muted = true;
          const p = v.play();
          if (p && typeof p.catch === 'function') p.catch(function () {});
        } catch (e) {}
      }
      const mediaRoot = slide.matches('[data-ndev-media]') ? slide : slide.querySelector('[data-ndev-media]');
      if (mediaRoot && typeof mediaRoot.__ndevMediaSync === 'function') {
        try {
          mediaRoot.__ndevMediaSync();
        } catch (e) {}
      }
    }

    function updateA11y(root, slides, index) {
      const status = root.querySelector('[data-ndev-ax26-flip-card-status]');
      if (!status || !slides.length) return;
      const cur = index + 1;
      const total = slides.length;
      status.textContent = 'Slide ' + cur + ' of ' + total;
    }

    function destroyOne(root) {
      const controller = root ? controllers.get(root) : null;
      if (controller && typeof controller.destroy === 'function') controller.destroy();
      if (root) controllers.delete(root);
    }

    function initOne(root) {
      if (!root) return;

      destroyOne(root);
      root.setAttribute(INIT_ATTR, '1');

      const track = root.querySelector(TRACK_SELECTOR);
      const slides = querySlideFaceElements(root);
      const flipMs = parseFlipMs(root);
      const tabList = root.querySelector('[data-ndev-ax26-flip-card-tabs]');

      if (!track || slides.length === 0) {
        controllers.set(root, {
          root: root,
          destroy: function () {
            try {
              root.removeAttribute(INIT_ATTR);
            } catch (e) {}
          },
        });
        return;
      }

      let displayedIndex = 0;
      let animating = false;
      let pendingTarget = null;
      let animTimer = null;
      let scrollRaf = 0;
      let scrollBound = false;
      let resizeObserver = null;
      let tabButtons = [];
      let onTabClickHandler = null;
      let mq = null;
      let onMqChangeHandler = null;

      /**
       * 视口竖直中线 vc 与 track 盒子 [top, bottom]：在卡片高度内均分 N 段（N = 张数）。
       * vc 在卡片上方 → 0；在卡片内 → floor((vc - top) / height * n)；在卡片下方 → n-1。
       */
      function readScrollIndex() {
        const rect = track.getBoundingClientRect();
        const n = slides.length;
        const vh = window.innerHeight || 1;
        if (n < 1) return 0;
        const vc = vh * 0.5;
        const top = rect.top;
        const bottom = rect.bottom;
        const h = rect.height || 1;

        if (vc <= top) return 0;
        if (vc >= bottom) return n - 1;

        const u = (vc - top) / h;
        let idx = Math.floor(u * n);
        if (idx < 0) idx = 0;
        if (idx >= n) idx = n - 1;
        return idx;
      }

      function applyInstantIndex(idx) {
        pauseAllVideos(slides);
        for (let i = 0; i < slides.length; i++) {
          clearFlipClasses(slides[i]);
          slides[i].classList.remove('is-active');
        }
        const s = slides[idx];
        if (s) s.classList.add('is-active');
        displayedIndex = idx;
        playSlideVideos(slides[idx]);
        updateA11y(root, slides, idx);
        syncTabAria(tabButtons, idx, root);
        syncTabCaption(root, slides, idx);
      }

      function finishAnimCleanup(oldIdx, newIdx) {
        const oldSlide = slides[oldIdx];
        const newSlide = slides[newIdx];
        if (oldSlide) {
          clearFlipClasses(oldSlide);
          oldSlide.classList.remove('is-active');
        }
        if (newSlide) {
          clearFlipClasses(newSlide);
          newSlide.classList.add('is-active');
        }
        animating = false;
        displayedIndex = newIdx;
        pauseAllVideos(slides);
        playSlideVideos(newSlide);
        updateA11y(root, slides, newIdx);
        syncTabAria(tabButtons, newIdx, root);

        if (pendingTarget !== null && pendingTarget !== displayedIndex) {
          const nextT = pendingTarget;
          pendingTarget = null;
          goToIndex(nextT, true);
        }
      }

      function goToIndex(targetIndex, force) {
        if (targetIndex === displayedIndex && !force) return;
        if (animating) {
          pendingTarget = targetIndex;
          syncTabAria(tabButtons, targetIndex, root);
          syncTabCaption(root, slides, targetIndex);
          return;
        }

        const oldIdx = displayedIndex;
        const newIdx = targetIndex;
        syncTabAria(tabButtons, newIdx, root);
        syncTabCaption(root, slides, newIdx);
        const forward = newIdx > oldIdx;

        if (prefersReducedMotion()) {
          pauseAllVideos(slides);
          setSlidesIdle(slides, newIdx);
          displayedIndex = newIdx;
          playSlideVideos(slides[newIdx]);
          updateA11y(root, slides, newIdx);
          syncTabCaption(root, slides, newIdx);
          return;
        }

        animating = true;
        pendingTarget = null;
        pauseAllVideos(slides);

        const oldSlide = slides[oldIdx];
        const newSlide = slides[newIdx];

        if (oldSlide) {
          oldSlide.classList.remove('is-active');
          oldSlide.classList.add('flip-out-fwd');
        }

        if (newSlide) {
          clearFlipClasses(newSlide);
          newSlide.classList.remove('is-active');
          newSlide.classList.add('flip-in-from-fwd');
        }

        if (animTimer) {
          clearTimeout(animTimer);
          animTimer = null;
        }

        window.requestAnimationFrame(function () {
          window.requestAnimationFrame(function () {
            if (newSlide) {
              newSlide.classList.remove('flip-in-from-fwd');
              newSlide.classList.add('flip-in-to-fwd');
            }
          });
        });

        animTimer = setTimeout(function () {
          animTimer = null;
          finishAnimCleanup(oldIdx, newIdx);
        }, flipMs + 40);
      }

      function onScrollRaf() {
        scrollRaf = 0;
        if (getEffectiveTrigger(root) !== 'scroll') return;
        const idx = readScrollIndex();
        if (idx !== displayedIndex && !animating) {
          goToIndex(idx, false);
        } else if (idx !== displayedIndex && animating) {
          pendingTarget = idx;
        }
      }

      function onScroll() {
        if (scrollRaf) return;
        scrollRaf = window.requestAnimationFrame(onScrollRaf);
      }

      function onResize() {
        onScroll();
      }

      function detachScrollMode() {
        if (!scrollBound) return;
        scrollBound = false;
        window.removeEventListener('scroll', onScroll, { passive: true });
        window.removeEventListener('resize', onResize, { passive: true });
        if (resizeObserver) {
          try {
            resizeObserver.disconnect();
          } catch (e) {}
          resizeObserver = null;
        }
      }

      function attachScrollMode() {
        if (scrollBound) return;
        scrollBound = true;
        window.addEventListener('scroll', onScroll, { passive: true });
        window.addEventListener('resize', onResize, { passive: true });
        if (typeof ResizeObserver === 'function') {
          resizeObserver = new ResizeObserver(onResize);
          resizeObserver.observe(track);
        }
      }

      function detachTabMode() {
        if (tabList && onTabClickHandler) {
          tabList.removeEventListener('click', onTabClickHandler);
        }
        onTabClickHandler = null;
        if (tabList) clearTabList(tabList);
        tabButtons = [];
      }

      function applyMode() {
        detachScrollMode();
        detachTabMode();
        const eff = getEffectiveTrigger(root);
        if (eff === 'scroll') {
          attachScrollMode();
          window.requestAnimationFrame(function () {
            const idx = readScrollIndex();
            if (idx !== displayedIndex) {
              applyInstantIndex(idx);
            }
            onScroll();
          });
        } else if (tabList) {
          tabButtons = buildTabs(slides, tabList);
          onTabClickHandler = function (ev) {
            const btn = ev.target && ev.target.closest && ev.target.closest('.ndev-ax26-flip-card__tab[data-tab-index]');
            if (!btn || !tabList.contains(btn)) return;
            const idx = parseInt(btn.getAttribute('data-tab-index'), 10);
            if (!isNaN(idx) && idx >= 0 && idx < slides.length) {
              goToIndex(idx, false);
            }
          };
          tabList.addEventListener('click', onTabClickHandler);
          syncTabAria(tabButtons, displayedIndex, root);
          syncTabCaption(root, slides, displayedIndex);
        }
      }

      applyInstantIndex(0);
      applyMode();

      if (window.matchMedia) {
        mq = window.matchMedia(MQ_PC);
        onMqChangeHandler = function () {
          applyMode();
        };
        if (mq.addEventListener) {
          mq.addEventListener('change', onMqChangeHandler);
        } else if (mq.addListener) {
          mq.addListener(onMqChangeHandler);
        }
      }

      controllers.set(root, {
        root: root,
        destroy: function () {
          detachScrollMode();
          detachTabMode();
          if (mq && onMqChangeHandler) {
            if (mq.removeEventListener) {
              mq.removeEventListener('change', onMqChangeHandler);
            } else if (mq.removeListener) {
              mq.removeListener(onMqChangeHandler);
            }
          }
          mq = null;
          onMqChangeHandler = null;
          if (animTimer) {
            clearTimeout(animTimer);
            animTimer = null;
          }
          pauseAllVideos(slides);
          try {
            root.removeAttribute(INIT_ATTR);
          } catch (e) {}
        },
      });
    }

    function initAll(scope) {
      const base = scope && scope.querySelectorAll ? scope : document;
      const list = base.querySelectorAll(ROOT_SELECTOR);
      for (let i = 0; i < list.length; i++) initOne(list[i]);
    }

    function destroyAll(scope) {
      const base = scope && scope.querySelectorAll ? scope : document;
      const list = base.querySelectorAll(ROOT_SELECTOR);
      for (let i = 0; i < list.length; i++) destroyOne(list[i]);
    }

    function handleBlockLoadEvent(event) {
      const t = event && event.target;
      if (!t || typeof t.closest !== 'function') {
        initAll();
        return;
      }
      const flipRoot = t.closest(ROOT_SELECTOR);
      if (flipRoot) {
        initOne(flipRoot);
        return;
      }
      initAll(t);
    }

    function handleBlockUnloadEvent(event) {
      const t = event && event.target;
      if (!t || typeof t.closest !== 'function') {
        destroyAll();
        return;
      }
      const flipRoot = t.closest(ROOT_SELECTOR);
      if (flipRoot) {
        destroyOne(flipRoot);
        if (document.body && document.body.contains(flipRoot)) {
          window.requestAnimationFrame(function () {
            if (document.body.contains(flipRoot)) initOne(flipRoot);
          });
        }
        return;
      }
      destroyAll(t);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        initAll();
      });
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', function (event) {
      initAll(event && event.target ? event.target : null);
    });

    document.addEventListener('shopify:section:unload', function (event) {
      destroyAll(event && event.target ? event.target : null);
    });

    document.addEventListener('shopify:section:load', handleBlockLoadEvent);

    document.addEventListener('shopify:section:unload', handleBlockUnloadEvent);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_ndev-chub-tab-faq"] && !Shopify.designMode) return;
  try {
    (() => {
    const ROOT_SELECTOR = '[data-ndev-chub-faq]';
    const INIT_ATTR = 'data-ndev-chub-faq-initialized';

    function initOne(root) {
      if (!root || root.getAttribute(INIT_ATTR) === '1') return;

      const singleOpen = root.getAttribute('data-single-open') === '1';
      const accordionName = root.getAttribute('data-accordion-name') || '';
      const triggers = Array.from(root.querySelectorAll('ui-tab[data-ndev-chub-faq-trigger][target]'));

      if (singleOpen && accordionName) {
        triggers.forEach((t) => t.setAttribute('name', accordionName));
      } else {
        triggers.forEach((t) => t.removeAttribute('name'));
      }

      // 无闪动：对初始带 open 的 trigger，同步面板 active
      triggers.forEach((t) => {
        if (!t.hasAttribute('open')) return;
        const id = t.getAttribute('target') || '';
        if (!id) return;
        const panel = root.querySelector(`#${CSS.escape(id)}`);
        panel?.classList?.add?.('active');
      });

      root.setAttribute(INIT_ATTR, '1');
    }

    function initAll(container = document) {
      container.querySelectorAll(ROOT_SELECTOR).forEach(initOne);
    }

    document.addEventListener('DOMContentLoaded', () => initAll());
    document.addEventListener('shopify:section:load', (event) => initAll(event.target));
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_ndev-chub-tabs"] && !Shopify.designMode) return;
  try {
    (() => {
    const ROOT_SELECTOR = '[data-ndev-community-hub-tabs]';
    const INIT_ATTR = 'data-ndev-community-hub-tabs-initialized';

    const instances = new WeakMap();

    const raf2 = (fn) => {
      if (typeof window.requestAnimationFrame !== 'function') {
        window.setTimeout(fn, 0);
        return;
      }
      window.requestAnimationFrame(() => window.requestAnimationFrame(fn));
    };

    function checkNavigationButtons(panel, swiper, swiperContainer, navButtons) {
      if (!panel || !swiper || !swiperContainer || !navButtons) return;
      const wrapper = swiperContainer.querySelector('.swiper-wrapper');
      if (!wrapper) return;

      const containerWidth = swiperContainer.offsetWidth;
      const contentWidth = wrapper.scrollWidth;

      if (contentWidth > containerWidth) {
        navButtons.classList.add('show');
        navButtons.setAttribute('aria-hidden', 'false');
      } else {
        navButtons.classList.remove('show');
        navButtons.setAttribute('aria-hidden', 'true');
      }
    }

    function initOne(root) {
      if (!root || root.getAttribute(INIT_ATTR) === '1') return;

      const panelToSwiper = new Map();
      const tabs = Array.from(root.querySelectorAll('.ndev-community-hub-tabs__titles ui-tab[target]'));
      const panels = Array.from(root.querySelectorAll('.ndev-community-hub-tabs__panel'));

      const getPanelById = (id) => {
        if (!id) return null;
        return root.querySelector(`#${CSS.escape(id)}`) || null;
      };

      const setActivePanel = (panel) => {
        if (!panel) return;
        panels.forEach((p) => p.classList.remove('is-active'));
        panel.classList.add('is-active');
      };

      const destroyPanelSwiper = (panel) => {
        const swiper = panelToSwiper.get(panel);
        if (!swiper) return;
        swiper?.destroy?.(true, true);
        panelToSwiper.delete(panel);
      };

      const ensurePanelSwiper = (panel) => {
        if (!panel) return;
        const swiperContainer = panel.querySelector('.swiper-container');
        if (!swiperContainer || typeof window.Swiper === 'undefined') return;

        let swiper = panelToSwiper.get(panel) || null;
        const navButtons = panel.querySelector('.ndev-community-hub__nav-buttons');

        const nextEl = panel.querySelector('.ndev-community-hub__nav-button--next');
        const prevEl = panel.querySelector('.ndev-community-hub__nav-button--prev');

        if (!swiper) {
          swiper = new window.Swiper(swiperContainer, {
            slidesPerView: 'auto',
            initialSlide: 0,
            spaceBetween: 0,
            navigation: {
              nextEl,
              prevEl,
              disabledClass: 'swiper-button-disabled',
            },
            on: {
              init: function () {
                window.setTimeout(() => checkNavigationButtons(panel, swiper, swiperContainer, navButtons), 100);
              },
            },
          });
          panelToSwiper.set(panel, swiper);
        }

        raf2(() => {
          swiper?.update?.();
          swiper?.slideTo?.(0, 0);
          checkNavigationButtons(panel, swiper, swiperContainer, navButtons);
        });
      };

      const onTabShow = (ev) => {
        const tab = ev?.target?.closest?.('ui-tab') || ev?.target;
        if (!tab || tab.tagName?.toLowerCase?.() !== 'ui-tab') return;
        // 只处理标题栏的主 tabs，避免面板内部（如 FAQ accordion）也使用 `<ui-tab>` 时误触发切换。
        if (!tab.closest?.('.ndev-community-hub-tabs__titles')) return;
        const targetId = tab.getAttribute('target') || '';
        const panel = getPanelById(targetId);
        if (!panel) return;

        setActivePanel(panel);

        raf2(() => ensurePanelSwiper(panel));
      };

      const initActive = () => {
        const activePanel = root.querySelector('.ndev-community-hub-tabs__panel.is-active');
        if (activePanel) {
          ensurePanelSwiper(activePanel);
          return;
        }

        // Prefer `<ui-tab open>`'s target, fallback to the first panel.
        const openTab = root.querySelector('ui-tab[open][target]');
        const targetPanel = openTab ? getPanelById(openTab.getAttribute('target')) : null;
        const firstPanel = root.querySelector('.ndev-community-hub-tabs__panel');
        const panel = targetPanel || firstPanel;
        if (!panel) return;

        setActivePanel(panel);
        ensurePanelSwiper(panel);
      };

      let resizeTimeout = 0;
      const onResize = () => {
        if (resizeTimeout) window.clearTimeout(resizeTimeout);
        resizeTimeout = window.setTimeout(() => {
          panelToSwiper.forEach((swiper, panel) => {
            const swiperContainer = panel.querySelector('.swiper-container');
            const navButtons = panel.querySelector('.ndev-community-hub__nav-buttons');
            swiper?.update?.();
            checkNavigationButtons(panel, swiper, swiperContainer, navButtons);
          });
        }, 250);
      };

      // `show/switch` 事件主要由 `<ui-tab>` 自身派发，不保证冒泡；这里同时做 tab 级监听 + 捕获监听，避免漏掉。
      tabs.forEach((tab) => {
        tab.addEventListener('show', onTabShow);
        tab.addEventListener('switch', onTabShow);
        tab.addEventListener('click', onTabShow);
      });
      root.addEventListener('show', onTabShow, true);
      root.addEventListener('switch', onTabShow, true);
      window.addEventListener('resize', onResize);

      initActive();

      root.setAttribute(INIT_ATTR, '1');
      instances.set(root, {
        destroy: () => {
          tabs.forEach((tab) => {
            tab.removeEventListener('show', onTabShow);
            tab.removeEventListener('switch', onTabShow);
            tab.removeEventListener('click', onTabShow);
          });
          root.removeEventListener('show', onTabShow, true);
          root.removeEventListener('switch', onTabShow, true);
          window.removeEventListener('resize', onResize);
          if (resizeTimeout) window.clearTimeout(resizeTimeout);
          Array.from(panelToSwiper.keys()).forEach(destroyPanelSwiper);
          root.removeAttribute(INIT_ATTR);
        },
      });
    }

    function destroyOne(root) {
      const inst = instances.get(root);
      if (!inst) return;
      inst.destroy();
      instances.delete(root);
    }

    function initAll(container = document) {
      container.querySelectorAll(ROOT_SELECTOR).forEach(initOne);
    }

    document.addEventListener('DOMContentLoaded', () => initAll());
    document.addEventListener('shopify:section:load', (event) => initAll(event.target));
    document.addEventListener('shopify:section:unload', (event) => {
      event.target.querySelectorAll(ROOT_SELECTOR).forEach(destroyOne);
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_ndev-event-calendar-list"] && !Shopify.designMode) return;
  try {
    class NdevEventCalendarList extends BaseElement {
    createdCallback() {}

    init() {
      this._cards = Array.from(this.querySelectorAll('.ndev-event-calendar-card'));
      if (!this._cards.length) return;

      this._total = this._cards.length;
      this._currentIndex = -1;
      this._phaseEls = [];
      this._cardsContainer = this.querySelector('.ndev-event-calendar-list__cards');

      this._boundOnCardClick = this._onCardClick.bind(this);

      for (let i = 0; i < this._cards.length; i++) {
        if (this._cards[i].classList.contains('is-current')) {
          this._currentIndex = i;
        }
        this._cards[i].addEventListener('click', this._boundOnCardClick);
      }

      if (this._currentIndex === -1) this._currentIndex = 0;

      this.style.setProperty('--seg-pct', 100 / this._total);

      this._buildPhases();
      this._syncTrack(100 / this._total);
      this._syncSidebar();
      this._observeResize();
    }

    _onCardClick(e) {
      const card = e.currentTarget;
      const idx = this._cards.indexOf(card);
      if (idx === -1 || idx === this._currentIndex) return;

      this._cards[this._currentIndex].classList.remove('is-current');
      card.classList.add('is-current');

      this._phaseEls[this._currentIndex].classList.remove('is-current');
      this._phaseEls[idx].classList.add('is-current');

      this._currentIndex = idx;

      this._syncTrack(100 / this._total);
      this._syncSidebar();
      this._scrollCardIntoView(card);
    }

    _scrollCardIntoView(card) {
      if (!this._mq.matches) return;
      if (!this._cardsContainer) return;

      const m = this._cardsContainer.style.transform?.match(/translateX\(([^)]+)/);
      const currentX = m ? parseFloat(m[1]) : 0;

      const listRect = this.getBoundingClientRect();
      const cardRect = card.getBoundingClientRect();
      const cardNaturalLeft = cardRect.left - listRect.left - currentX;

      let offset = listRect.width / 2 - cardNaturalLeft - cardRect.width / 2;
      if (offset > 0) offset = 0;

      const maxOffset = listRect.width - this._cardsContainer.scrollWidth;
      if (maxOffset >= 0) {
        offset = 0;
      } else {
        if (offset > 0) offset = 0;
        if (offset < maxOffset) offset = maxOffset;
      }

      this._cardsContainer.style.transform = `translateX(${offset}px)`;
    }

    _buildPhases() {
      const container = this.querySelector('.ndev-event-calendar-list__phases');
      if (!container) return;

      for (let i = 0; i < this._cards.length; i++) {
        const card = this._cards[i];
        const isCurrent = i === this._currentIndex;

        const el = document.createElement('div');
        el.className = 'ndev-event-calendar-list__phase' + (isCurrent ? ' is-current' : '');

        const date = document.createElement('span');
        date.className = 'ndev-event-calendar-list__phase-date';
        date.textContent = card.getAttribute('data-date-label') || '';

        const name = document.createElement('span');
        name.className = 'ndev-event-calendar-list__phase-name';
        name.textContent = card.getAttribute('data-phase-name') || '';

        el.appendChild(date);
        el.appendChild(name);
        container.appendChild(el);
        this._phaseEls.push(el);
      }
    }

    _syncTrack(segPct) {
      this.style.setProperty('--seg-pct', segPct);
      this.style.setProperty('--track-pos', this._currentIndex * segPct);
    }

    _syncSidebar() {
      const container = this._cardsContainer;
      if (!container) return;

      const totalH = container.offsetHeight;
      if (!totalH) return;

      this.style.setProperty('--sidebar-h', `${totalH}px`);

      const activeCard = this._cards[this._currentIndex];
      const containerTop = container.getBoundingClientRect().top;
      const cardTop = activeCard.getBoundingClientRect().top;
      const cardH = activeCard.getBoundingClientRect().height;

      const segPctS = (cardH / totalH) * 100;
      const sidebarPos = ((cardTop - containerTop) / totalH) * 100;

      this.style.setProperty('--seg-pct-s', segPctS);
      this.style.setProperty('--sidebar-pos', sidebarPos);
    }

    _observeResize() {
      if (!this._cardsContainer) return;
      if (typeof ResizeObserver !== 'undefined') {
        this._ro = new ResizeObserver(() => this._syncSidebar());
        this._ro.observe(this._cardsContainer);
      }
      this._mq.addEventListener('change', this._onMqChange = () => {
        this._cardsContainer.style.transform = '';
      });
    }

    dispose() {
      if (this._onMqChange) {
        this._mq.removeEventListener('change', this._onMqChange);
        this._onMqChange = null;
      }
      for (const card of this._cards) {
        card.removeEventListener('click', this._boundOnCardClick);
      }
      if (this._ro) {
        this._ro.disconnect();
        this._ro = null;
      }
      this._cards = null;
      this._phaseEls = null;
      this._cardsContainer = null;
    }

    static get observedAttributes() { return ['']; }
    attributeChangedCallback(name, oldValue, newValue) {}
  }

  if (!customElements.get('ndev-event-calendar-list')) {
    customElements.define('ndev-event-calendar-list', NdevEventCalendarList);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_ndev-v50-all-purpose-frame-item"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('ndev-v50-all-purpose-frame-item')) {
    class NdevV50AllPurposeFrameItem extends BaseElement {
      init() {
        this.startTime = this.readNumber('start-time', 0);
        this.endTime = this.readNumber('end-time', 0);
        this.frameRoot = this.closest('ndev-v50-all-purpose-frame-animation');
        this.sectionRoot = this.closest('ndev-v50-all-purpose');
        this.duration = this.frameRoot ? Math.max(1, this.readFrameNumber('timeline-duration-ms', 11000)) : 11000;
        this.isVisible = false;
        this.onProgress = this.handleProgress.bind(this);

        if (!this.frameRoot || !this.sectionRoot || this.startTime >= this.endTime) return;
        this.sectionRoot.addEventListener('ndev-v50-frame-progress', this.onProgress);
      }

      dispose() {
        if (this.sectionRoot) {
          this.sectionRoot.removeEventListener('ndev-v50-frame-progress', this.onProgress);
        }
        this.classList.remove('is-visible');
      }

      readNumber(name, fallback) {
        const value = Number(this.getAttribute(name));
        return Number.isFinite(value) ? value : fallback;
      }

      readFrameNumber(name, fallback) {
        const value = Number(this.frameRoot.getAttribute(name));
        return Number.isFinite(value) ? value : fallback;
      }

      handleProgress(event) {
        const detail = event.detail || {};
        const progress = Number(detail.progress);
        const safeProgress = Number.isFinite(progress) ? progress : 0;
        const currentTime = Math.min(this.duration, Math.max(0, safeProgress * this.duration));
        this.setVisible(Boolean(detail.active) && currentTime >= this.startTime && currentTime <= this.endTime);
      }

      setVisible(visible) {
        if (visible === this.isVisible) return;
        this.isVisible = visible;
        this.classList.toggle('is-visible', visible);
      }
    }

    customElements.define('ndev-v50-all-purpose-frame-item', NdevV50AllPurposeFrameItem);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_ndev-v50-media-overlay"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('ndev-v50-media-overlay')) {
    class NdevV50MediaOverlay extends BaseElement {
      init() {
        this.videos = Array.from(this.querySelectorAll('video'));
        this.preparedVideos = new WeakSet();
        this.isNearViewport = false;
        this.isInView = false;
        this.fallbackRaf = 0;
        this.preloadObserver = null;
        this.playbackObserver = null;
        this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

        this.onPreloadIntersection = this.handlePreloadIntersection.bind(this);
        this.onPlaybackIntersection = this.handlePlaybackIntersection.bind(this);
        this.onVisibilityChange = this.syncPlayback.bind(this);
        this.onBreakpointChange = this.handleBreakpointChange.bind(this);
        this.onReducedMotionChange = this.syncPlayback.bind(this);
        this.onFallbackViewportChange = this.handleFallbackViewportChange.bind(this);

        this.videos.forEach((video) => {
          video.autoplay = false;
          video.loop = true;
          video.muted = true;
          video.playsInline = true;
          video.preload = 'none';
          video.pause();
        });

        document.addEventListener('visibilitychange', this.onVisibilityChange);
        this.addMediaListener(this._mq, this.onBreakpointChange);
        this.addMediaListener(this.reducedMotion, this.onReducedMotionChange);
        this.setupViewportTracking();
      }

      dispose() {
        if (this.preloadObserver) this.preloadObserver.disconnect();
        if (this.playbackObserver) this.playbackObserver.disconnect();
        if (this.fallbackRaf) cancelAnimationFrame(this.fallbackRaf);

        document.removeEventListener('visibilitychange', this.onVisibilityChange);
        window.removeEventListener('scroll', this.onFallbackViewportChange);
        window.removeEventListener('resize', this.onFallbackViewportChange);
        this.removeMediaListener(this._mq, this.onBreakpointChange);
        this.removeMediaListener(this.reducedMotion, this.onReducedMotionChange);
        this.pauseAll();
      }

      setupViewportTracking() {
        if (!('IntersectionObserver' in window)) {
          window.addEventListener('scroll', this.onFallbackViewportChange, { passive: true });
          window.addEventListener('resize', this.onFallbackViewportChange);
          this.handleFallbackViewportChange();
          return;
        }

        this.preloadObserver = new IntersectionObserver(this.onPreloadIntersection, {
          root: null,
          rootMargin: '300px 0px',
          threshold: 0,
        });
        this.playbackObserver = new IntersectionObserver(this.onPlaybackIntersection, {
          root: null,
          rootMargin: '0px',
          threshold: 0.35,
        });
        this.preloadObserver.observe(this);
        this.playbackObserver.observe(this);
      }

      handlePreloadIntersection(entries) {
        const entry = entries[0];
        this.isNearViewport = Boolean(entry && entry.isIntersecting);
        if (this.isNearViewport) this.prepareVisibleVideo();
      }

      handlePlaybackIntersection(entries) {
        const entry = entries[0];
        this.isInView = Boolean(entry && entry.isIntersecting && entry.intersectionRatio >= 0.35);
        this.syncPlayback();
      }

      handleFallbackViewportChange() {
        if (this.fallbackRaf) return;
        this.fallbackRaf = requestAnimationFrame(() => {
          this.fallbackRaf = 0;
          const rect = this.getBoundingClientRect();
          const visibleHeight = Math.max(0, Math.min(rect.bottom, window.innerHeight) - Math.max(rect.top, 0));
          const visibleRatio = rect.height > 0 ? visibleHeight / rect.height : 0;
          this.isNearViewport = rect.bottom >= -300 && rect.top <= window.innerHeight + 300;
          this.isInView = visibleRatio >= 0.35;
          if (this.isNearViewport) this.prepareVisibleVideo();
          this.syncPlayback();
        });
      }

      handleBreakpointChange() {
        this.pauseAll();
        if (this.isNearViewport) this.prepareVisibleVideo();
        this.syncPlayback();
      }

      getVisibleVideo() {
        const selector = this._mq.matches
          ? '.ndev-v50-media-overlay__video.show-pc'
          : '.ndev-v50-media-overlay__video.show-mb';
        return this.querySelector(selector);
      }

      prepareVisibleVideo() {
        const video = this.getVisibleVideo();
        if (!video || this.preparedVideos.has(video)) return;
        this.preparedVideos.add(video);
        video.preload = 'metadata';
        video.load();
      }

      syncPlayback() {
        const visibleVideo = this.getVisibleVideo();
        this.videos.forEach((video) => {
          if (video !== visibleVideo) video.pause();
        });

        const shouldPlay =
          visibleVideo && this.isInView && !document.hidden && !this.reducedMotion.matches;
        if (!shouldPlay) {
          if (visibleVideo) visibleVideo.pause();
          return;
        }

        this.prepareVisibleVideo();
        try {
          const playPromise = visibleVideo.play();
          if (playPromise && typeof playPromise.catch === 'function') {
            playPromise.catch(() => {});
          }
        } catch (error) {
          visibleVideo.pause();
        }
      }

      pauseAll() {
        this.videos.forEach((video) => video.pause());
      }

      addMediaListener(mediaQuery, listener) {
        if (mediaQuery.addEventListener) mediaQuery.addEventListener('change', listener);
        else mediaQuery.addListener(listener);
      }

      removeMediaListener(mediaQuery, listener) {
        if (mediaQuery.removeEventListener) mediaQuery.removeEventListener('change', listener);
        else mediaQuery.removeListener(listener);
      }
    }

    customElements.define('ndev-v50-media-overlay', NdevV50MediaOverlay);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_ndev-v50-vacuum-comparison-carousel"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('ndev-v50-vacuum-comparison-carousel')) {
    class NdevV50VacuumComparisonCarousel extends BaseElement {
      init() {
        this.slides = Array.from(this.querySelectorAll('[data-v50-comparison-slide]'));
        this.navs = Array.from(this.querySelectorAll('[data-v50-comparison-nav]'));
        this.currentEl = this.querySelector('[data-v50-mobile-current]');
        this.prevButton = this.querySelector('[data-v50-mobile-prev]');
        this.nextButton = this.querySelector('[data-v50-mobile-next]');
        this.autoplay = this.getAttribute('autoplay') === 'true';
        this.delay = Math.max(1200, Number(this.getAttribute('autoplay-delay')) || 5000);
        this.playbackTrigger = this.getAttribute('playback-trigger') || 'in_view';
        this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.defaultIndex = this.findDefaultIndex();
        this.activeIndex = this.defaultIndex;
        this.isInView = this.playbackTrigger !== 'in_view';
        this.raf = 0;
        this.startTime = 0;
        this.observer = null;
        this.mobileProgressRing = this.querySelector('[data-v50-comparison-progress-ring="mobile"]');
        this.activeTimelineFill = null;
        this.activeProgressRing = null;

        this.onNavClick = this.onNavClick.bind(this);
        this.onPrevClick = this.onPrevClick.bind(this);
        this.onNextClick = this.onNextClick.bind(this);
        this.onIntersection = this.onIntersection.bind(this);
        this.tick = this.tick.bind(this);

        this.navs.forEach((nav) => nav.addEventListener('click', this.onNavClick));
        if (this.prevButton) this.prevButton.addEventListener('click', this.onPrevClick);
        if (this.nextButton) this.nextButton.addEventListener('click', this.onNextClick);

        this.activate(this.activeIndex, { resetProgress: true, restartAutoplay: false });
        this.setupPlayback();
        this.classList.add('is-ready');
      }

      dispose() {
        this.navs.forEach((nav) => nav.removeEventListener('click', this.onNavClick));
        if (this.prevButton) this.prevButton.removeEventListener('click', this.onPrevClick);
        if (this.nextButton) this.nextButton.removeEventListener('click', this.onNextClick);
        this.destroyObserver();
        this.stopAutoplay();
        this.classList.remove('is-ready');
      }

      findDefaultIndex() {
        const defaultIndex = this.slides.findIndex((slide) => slide.classList.contains('is-active'));
        return defaultIndex >= 0 ? defaultIndex : 0;
      }

      onNavClick(event) {
        const selection = window.getSelection();
        const selectedInsideNav =
          selection &&
          !selection.isCollapsed &&
          (event.currentTarget.contains(selection.anchorNode) || event.currentTarget.contains(selection.focusNode));
        if (event.detail > 0 && selectedInsideNav) return;

        const slide = event.currentTarget.closest('[data-v50-comparison-slide]');
        const index = this.slides.indexOf(slide);
        if (index >= 0) {
          this.activate(index, { resetProgress: true });
        }
      }

      onPrevClick() {
        if (!this.slides.length) return;
        const nextIndex = (this.activeIndex - 1 + this.slides.length) % this.slides.length;
        this.activate(nextIndex, { resetProgress: true });
      }

      onNextClick() {
        if (!this.slides.length) return;
        const nextIndex = (this.activeIndex + 1) % this.slides.length;
        this.activate(nextIndex, { resetProgress: true });
      }

      onIntersection(entries) {
        const entry = entries[0];
        const inView = Boolean(entry && entry.isIntersecting);
        if (inView === this.isInView) return;

        this.isInView = inView;
        if (inView) {
          this.resetProgress();
          this.startAutoplay();
        } else {
          this.resetToDefault();
        }
      }

      setupPlayback() {
        if (this.playbackTrigger !== 'in_view') {
          this.isInView = true;
          this.startAutoplay();
          return;
        }

        if (!('IntersectionObserver' in window)) {
          this.isInView = true;
          this.startAutoplay();
          return;
        }

        this.observer = new IntersectionObserver(this.onIntersection, { threshold: 0.35 });
        this.observer.observe(this);
      }

      destroyObserver() {
        if (!this.observer) return;
        this.observer.disconnect();
        this.observer = null;
      }

      activate(index, options) {
        if (!this.slides.length) return;
        const config = options || {};
        const nextIndex = Math.min(Math.max(index, 0), this.slides.length - 1);
        this.activeIndex = nextIndex;

        this.slides.forEach((slide, slideIndex) => {
          const active = slideIndex === nextIndex;
          slide.classList.toggle('is-active', active);
          this.resetSlideProgress(slide);
          slide.querySelectorAll('[data-v50-comparison-nav]').forEach((nav) => {
            nav.setAttribute('aria-expanded', active ? 'true' : 'false');
          });
          slide.querySelectorAll('.v50-comparison-slide__panel, .v50-comparison-slide__mobile-content').forEach((region) => {
            region.setAttribute('aria-hidden', active ? 'false' : 'true');
          });
        });

        this.updateMobileControls();
        this.updateProgressTargets();

        if (config.resetProgress !== false) {
          this.resetProgress();
          if (config.restartAutoplay !== false) this.startAutoplay();
        }
      }

      updateMobileControls() {
        if (this.currentEl) this.currentEl.textContent = String(this.activeIndex + 1).padStart(2, '0');
      }

      updateProgressTargets() {
        const activeSlide = this.slides[this.activeIndex];
        this.activeTimelineFill = activeSlide ? activeSlide.querySelector('.v50-comparison-timeline__fill') : null;
        this.activeProgressRing = activeSlide
          ? activeSlide.querySelector('[data-v50-comparison-progress-ring="desktop"]')
          : null;
      }

      resetSlideProgress(slide) {
        const fill = slide.querySelector('.v50-comparison-timeline__fill');
        const ring = slide.querySelector('[data-v50-comparison-progress-ring="desktop"]');
        if (fill) fill.style.transform = 'translateX(-50%) scaleY(0)';
        if (ring) ring.style.strokeDashoffset = '1';
      }

      resetToDefault() {
        this.stopAutoplay();
        this.activate(this.defaultIndex, { resetProgress: true, restartAutoplay: false });
      }

      resetProgress() {
        this.startTime = performance.now();
        this.writeProgress(0);
      }

      startAutoplay() {
        this.stopAutoplay();
        if (!this.canPlay()) return;
        this.raf = requestAnimationFrame(this.tick);
      }

      canPlay() {
        if (!this.autoplay || this.reducedMotion.matches || this.slides.length <= 1) return false;
        return this.playbackTrigger !== 'in_view' || this.isInView;
      }

      stopAutoplay() {
        if (this.raf) cancelAnimationFrame(this.raf);
        this.raf = 0;
      }

      tick(now) {
        if (!this.startTime) this.startTime = now;
        const progress = Math.min((now - this.startTime) / this.delay, 1);
        this.writeProgress(progress);

        if (progress >= 1) {
          const nextIndex = (this.activeIndex + 1) % this.slides.length;
          this.activate(nextIndex, { resetProgress: true });
          return;
        }

        this.raf = requestAnimationFrame(this.tick);
      }

      writeProgress(progress) {
        const safeProgress = Math.min(Math.max(progress, 0), 1);
        const dashOffset = String(1 - safeProgress);
        if (this.activeTimelineFill) {
          this.activeTimelineFill.style.transform = `translateX(-50%) scaleY(${safeProgress.toFixed(4)})`;
        }
        if (this.activeProgressRing) this.activeProgressRing.style.strokeDashoffset = dashOffset;
        if (this.mobileProgressRing) this.mobileProgressRing.style.strokeDashoffset = dashOffset;
      }
    }

    customElements.define('ndev-v50-vacuum-comparison-carousel', NdevV50VacuumComparisonCarousel);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_ndev-x30-appearance-overview"] && !Shopify.designMode) return;
  try {
    (function () {
    'use strict';

    const NS = 'ndev-x30-appearance-overview';
    const ROOT_SELECTOR = '[data-ndev-x30-appearance-overview]';
    const INIT_ATTR = 'data-' + NS + '-initialized';

    const registryKey = '__ndevBlockControllers__';
    if (!window[registryKey]) window[registryKey] = {};
    if (!window[registryKey][NS]) window[registryKey][NS] = new WeakMap();
    const controllers = window[registryKey][NS];

    function destroyOne(root) {
      const controller = root ? controllers.get(root) : null;
      if (controller && typeof controller.destroy === 'function') controller.destroy();
      if (root) controllers.delete(root);
    }

    function initOne(root) {
      if (!root) return;

      destroyOne(root);
      root.setAttribute(INIT_ATTR, '1');

      const overallEl = root.querySelector('[data-ndev-x30-appearance-overview-overall]');
      const endingEl = root.querySelector('[data-ndev-x30-appearance-overview-ending-wrap]');

      if (!overallEl || !endingEl) {
        controllers.set(root, { root: root, destroy: function () {} });
        return;
      }

      // 状态标记：ending 是否已显示
      let endingShown = false;

      // 显示 ending 的函数
      function showEnding() {
        if (endingShown) return;
        endingShown = true;
        endingEl.classList.add('is-visible');
        overallEl.classList.add('is-fading');
      }

      // 监听帧动画进度
      function handleProgress(event) {
        const percent = event.detail.percent;
        if (percent >= 98) {
          showEnding();
        }
      }

      // 绑定在 root 元素上，捕获所有冒泡上来的 ndev-sf-progress 事件
      root.addEventListener('ndev-sf-progress', handleProgress);

      // 额外监听 document 上的事件（防止事件冒泡被阻止的情况）
      function handleProgressGlobal(event) {
        if (root.contains(event.target)) {
          handleProgress(event);
        }
      }
      document.addEventListener('ndev-sf-progress', handleProgressGlobal);

      // 备用方案：轮询检查滚动进度
      // 当滚动到容器底部时，直接显示 ending
      let scrollCheckRaf = null;
      function checkScrollProgress() {
        if (endingShown) {
          scrollCheckRaf = null;
          return;
        }

        const rect = root.getBoundingClientRect();
        const containerHeight = root.offsetHeight;
        const scrolled = -rect.top; // 已滚过的距离
        const total = containerHeight - window.innerHeight; // 总可滚动距离

        if (total > 0) {
          const scrollPercent = (scrolled / total) * 100;
          if (scrollPercent >= 95) {
            showEnding();
            scrollCheckRaf = null;
            return;
          }
        }

        scrollCheckRaf = requestAnimationFrame(checkScrollProgress);
      }

      // 开始滚动检查
      function startScrollCheck() {
        if (scrollCheckRaf) return;
        scrollCheckRaf = requestAnimationFrame(checkScrollProgress);
      }

      // 监听滚动事件启动检查
      const handleScroll = function() {
        if (!endingShown) {
          startScrollCheck();
        }
      };
      window.addEventListener('scroll', handleScroll, { passive: true });

      // 初始化时也检查一次
      startScrollCheck();

      controllers.set(root, {
        root: root,
        destroy: function () {
          try {
            root.removeEventListener('ndev-sf-progress', handleProgress);
            document.removeEventListener('ndev-sf-progress', handleProgressGlobal);
            window.removeEventListener('scroll', handleScroll);
            if (scrollCheckRaf) {
              cancelAnimationFrame(scrollCheckRaf);
              scrollCheckRaf = null;
            }
            root.removeAttribute(INIT_ATTR);
          } catch (e) {}
        },
      });
    }

    function initAll(scope) {
      const base = scope?.querySelectorAll ? scope : document;
      const list = base.querySelectorAll(ROOT_SELECTOR);
      for (var i = 0; i < list.length; i++) initOne(list[i]);
    }

    function destroyAll(scope) {
      const base = scope?.querySelectorAll ? scope : document;
      const list = base.querySelectorAll(ROOT_SELECTOR);
      for (var i = 0; i < list.length; i++) destroyOne(list[i]);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        initAll();
      });
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', function (event) {
      initAll(event && event.target ? event.target : null);
    });

    document.addEventListener('shopify:section:unload', function (event) {
      destroyAll(event && event.target ? event.target : null);
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_ndev-x30-ermi-card-list"] && !Shopify.designMode) return;
  try {
    (function () {
    'use strict';

    const NS = 'ndev-x30-ermi-card-list';
    const ROOT_SELECTOR = '[data-ndev-x30-ermi-card-list]';
    const INIT_ATTR = 'data-' + NS + '-initialized';

    const registryKey = '__ndevBlockControllers__';
    if (!window[registryKey]) window[registryKey] = {};
    if (!window[registryKey][NS]) window[registryKey][NS] = new WeakMap();
    const controllers = window[registryKey][NS];

    function destroyOne(root) {
      const controller = root ? controllers.get(root) : null;
      if (controller && typeof controller.destroy === 'function') controller.destroy();
      if (root) controllers.delete(root);
    }

    function initOne(root) {
      if (!root) return;

      destroyOne(root);
      root.setAttribute(INIT_ATTR, '1');

      // 获取容器和卡片
      const cardsContainer = root.querySelector('.ndev-x30-ermi-card-list__cards');
      const thumbnailsContainer = root.querySelector('.ndev-x30-ermi-card-list__thumbnails');

      if (!cardsContainer || !thumbnailsContainer) return;

      const cards = cardsContainer.querySelectorAll('[data-ndev-ermi-card]');
      const thumbnails = thumbnailsContainer.querySelectorAll('[data-ndev-ermi-card]');

      // 清除所有激活状态
      function clearAllActived() {
        root.querySelectorAll('.actived').forEach(function (el) {
          el.classList.remove('actived');
        });
      }

      // 激活指定 card（双向同步）
      function activateCard(cardId) {
        clearAllActived();
        // 激活 __cards 中的 card
        const card = cardsContainer.querySelector(`[data-id="${cardId}"]`);
        if (card) card.classList.add('actived');
        // 激活 __thumbnails 中对应的 thumbnail
        const thumbnail = thumbnailsContainer.querySelector(`[data-id="${cardId}"]`);
        if (thumbnail) thumbnail.classList.add('actived');
      }

      // 处理鼠标进入（cards 悬浮）
      function handleCardsMouseEnter(e) {
        // 仅 PC 端生效
        if (window.innerWidth < 1024) return;
        const card = e.currentTarget;
        activateCard(card.dataset.id);
      }

      // 处理缩略图点击
      function handleThumbnailClick(e) {
        // 仅移动端生效
        if (window.innerWidth >= 1024) return;
        const thumbnail = e.currentTarget;
        activateCard(thumbnail.dataset.id);
      }

      // 绑定 cards 悬浮事件
      cards.forEach(function (card) {
        card.addEventListener('mouseenter', handleCardsMouseEnter);
      });

      // 绑定 thumbnails 点击事件
      thumbnails.forEach(function (thumbnail) {
        thumbnail.addEventListener('click', handleThumbnailClick);
      });

      controllers.set(root, {
        root: root,
        cards: cards,
        thumbnails: thumbnails,
        handleCardsMouseEnter: handleCardsMouseEnter,
        handleThumbnailClick: handleThumbnailClick,
        destroy: function () {
          // 清理 cards 事件监听器
          if (this.cards) {
            this.cards.forEach(function (card) {
              card.removeEventListener('mouseenter', this.handleCardsMouseEnter);
            }.bind(this));
          }
          // 清理 thumbnails 点击事件监听器
          if (this.thumbnails) {
            this.thumbnails.forEach(function (thumbnail) {
              thumbnail.removeEventListener('click', this.handleThumbnailClick);
            }.bind(this));
          }
          try { root.removeAttribute(INIT_ATTR); } catch (e) {}
        }
      });
    }

    function initAll(scope) {
      const base = (scope && scope.querySelectorAll) ? scope : document;
      const list = base.querySelectorAll(ROOT_SELECTOR);
      for (var i = 0; i < list.length; i++) initOne(list[i]);
    }

    function destroyAll(scope) {
      const base = (scope && scope.querySelectorAll) ? scope : document;
      const list = base.querySelectorAll(ROOT_SELECTOR);
      for (var i = 0; i < list.length; i++) destroyOne(list[i]);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { initAll(); });
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', function (event) {
      initAll(event && event.target ? event.target : null);
    });

    document.addEventListener('shopify:section:unload', function (event) {
      destroyAll(event && event.target ? event.target : null);
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_ndev-x30-everything-recognition-identity"] && !Shopify.designMode) return;
  try {
    (function () {
    'use strict';

    const NS = 'ndev-x30-everything-recognition-identity';
    const ROOT_SELECTOR = '[data-ndev-x30-everything-recognition-identity]';
    const IMAGE_SELECTOR = '[data-ndev-x30-identity-image]';
    const INIT_ATTR = 'data-' + NS + '-initialized';
    const PC_DONE_CLASS = 'pc-done';
    const MB_DONE_CLASS = 'mb-done';
    const MOBILE_BREAKPOINT = 1024;

    const registryKey = '__ndevBlockControllers__';
    if (!window[registryKey]) window[registryKey] = {};
    if (!window[registryKey][NS]) window[registryKey][NS] = new WeakMap();
    const controllers = window[registryKey][NS];

    // 滑出距离：100% 表示完全移出
    const SLIDE_OUT_DISTANCE = 110;

    /**
     * 计算图片在堆叠中的状态
     * @param {number} positionInStack - 在堆叠中的位置（0=最上面）
     * @param {number} offsetPercent - 堆叠偏移百分比
     * @param {number} scaleDecay - 缩放衰减系数
     * @param {number} remainingCount - 剩余图片数（包含正在滑出的）
     * @returns {Object} 状态对象 { translateY, scale, opacity, zIndex, overlayOpacity }
     */
    function computeStackPositionState(positionInStack, offsetPercent, scaleDecay, remainingCount) {
      const translateY = -((remainingCount - 1 - positionInStack) * offsetPercent);
      const scale = Math.pow(scaleDecay, positionInStack);
      const zIndex = remainingCount - positionInStack;
      let overlayOpacity = positionInStack === 0 ? 0 : 0.3 + positionInStack * 0.2;
      overlayOpacity = Math.min(overlayOpacity, 0.7);
      return { translateY: translateY, scale: scale, opacity: 1, zIndex: zIndex, overlayOpacity: overlayOpacity };
    }

    /**
     * 计算滑出图片的状态
     * @param {number} phaseProgress - 滑出进度 (0-1)
     * @param {number} offsetPercent - 堆叠偏移百分比
     * @param {number} scaleDecay - 缩放衰减系数
     * @param {number} remainingCount - 剩余图片数
     * @returns {Object} 状态对象
     */
    function computeSlideOutState(phaseProgress, offsetPercent, scaleDecay, remainingCount) {
      const baseState = computeStackPositionState(0, offsetPercent, scaleDecay, remainingCount);
      baseState.translateY = baseState.translateY - phaseProgress * SLIDE_OUT_DISTANCE;
      baseState.opacity = 1 - phaseProgress;
      return baseState;
    }

    /**
     * 计算已完全滑出图片的状态
     * @returns {Object} 状态对象
     */
    function computeSlidOutState() {
      return { translateY: -SLIDE_OUT_DISTANCE, scale: 1, opacity: 0, zIndex: 0, overlayOpacity: 0 };
    }

    function applyImageStyle(el, state) {
      if (!el || !el.style) return;
      el.style.transform = 'translateY(' + state.translateY + '%) scale(' + state.scale + ')';
      el.style.opacity = String(state.opacity);
      el.style.zIndex = String(state.zIndex);
      if (state.overlayOpacity !== undefined) {
        el.style.setProperty('--stack-overlay-opacity', state.overlayOpacity);
      }
    }

    function destroyOne(root) {
      const controller = root ? controllers.get(root) : null;
      if (controller && typeof controller.destroy === 'function') controller.destroy();
      if (root) controllers.delete(root);
    }

    function initOne(root) {
      if (!root) return;

      destroyOne(root);
      root.setAttribute(INIT_ATTR, '1');

      const nodeList = root.querySelector ? { 'scroll-container': root.querySelector('[node-name="scroll-container"]'), 'stack': root.querySelector('[node-name="stack"]'), 'stack-wrapper': root.querySelector('[node-name="stack-wrapper"]') } : {};
      const scrollContainer = nodeList['scroll-container'];
      const stack = nodeList['stack'];
      const stackWrapper = nodeList['stack-wrapper'];

      if (!scrollContainer || !stack) return;

      const imageEls = root.querySelectorAll(IMAGE_SELECTOR);
      const totalImages = imageEls.length;

      if (totalImages === 0) {
        controllers.set(root, { root: root, destroy: function() {} });
        return;
      }

      // 读取配置
      const initialWaitHeight = parseFloat(root.getAttribute('data-initial-wait-height')) || 50;
      const scrollHeightPerImage = parseFloat(root.getAttribute('data-scroll-height-per-image')) || 150;
      let offset = 14;
      let scaleDecay = 0.9;

      // 最后一张图片不滑出，所以总阶段数 = totalImages - 1
      const totalPhases = totalImages - 1;
      const totalScrollHeight = initialWaitHeight + totalPhases * scrollHeightPerImage;
      scrollContainer.style.height = totalScrollHeight + 'vh';

      // 获取图片高度并设置 stack 高度
      // 使用图片原始尺寸比例计算实际渲染高度，避免绝对定位元素 offsetHeight 不准确的问题

      // 获取当前显示的图片（PC 端选 pc-done，移动端选 mb-done）
      function getCurrentDisplayImage() {
        const isMobile = window.innerWidth < MOBILE_BREAKPOINT;
        for (const imageEl of imageEls) {
          const imgs = imageEl.querySelectorAll('img');
          if (imgs.length === 0) continue;

          const targetClass = isMobile ? MB_DONE_CLASS : PC_DONE_CLASS;
          let targetImg = imageEl.querySelector('img.' + targetClass);

          // 兜底：如果找不到对应 class，使用第一个图片
          if (!targetImg && imgs.length > 0) {
            targetImg = imgs[0];
          }
          return targetImg;
        }
        return null;
      }

      function updateStackHeight() {
        const targetImg = getCurrentDisplayImage();

        if (targetImg && targetImg.complete && targetImg.naturalHeight > 0 && targetImg.naturalWidth > 0) {
          // 用图片原始比例计算实际渲染高度
          // 图片渲染宽度 = stack 的实际宽度（图片 width: 100%）
          const stackWidth = stack.offsetWidth;
          const imgHeight = stackWidth * targetImg.naturalHeight / targetImg.naturalWidth;

          const stackHeight = imgHeight + (totalImages - 1) * offset;
          stack.style.height = stackHeight + 'px';

          const translateYPercent = (totalImages - 1) * offset;
          const marginTopPx = translateYPercent * imgHeight / 100;
          if (window.innerWidth < 1024 && stackWrapper) {
            stackWrapper.style.marginTop = marginTopPx + 'px';
          } else if (stackWrapper) {
            stackWrapper.style.marginTop = '';
          }
        }
      }

      // 读取 CSS 变量 - 提前定义，因为 updateStackHeight 需要调用它
      function readCssVars() {
        const cs = getComputedStyle(root);
        offset = parseFloat(cs.getPropertyValue('--stack-offset')) || 14;
        scaleDecay = parseFloat(cs.getPropertyValue('--scale-decay')) || 0.9;
      }

      // 初始计算 - 使用 requestAnimationFrame 确保 DOM 布局完成
      requestAnimationFrame(updateStackHeight);

      // 监听所有图片加载完成（PC 和 MB 都监听，确保 resize 切换端时能正确计算）
      const loadedImgs = [];
      function onLoadUpdateStackHeight() {
        requestAnimationFrame(updateStackHeight);
      }

      for (const imageEl of imageEls) {
        const imgs = imageEl.querySelectorAll('img');
        for (const img of imgs) {
          if (!img.complete) {
            img.addEventListener('load', onLoadUpdateStackHeight);
            loadedImgs.push(img);
          }
        }
      }

      /**
       * 核心动画更新函数 - 纯函数式，基于滚动进度计算每张图片状态
       * 不使用状态变量追踪，完全可重放
       * 注意：依赖外部已读取的 CSS 变量 (offset, scaleDecay)
       */
      function updateAnimation() {

        const rect = scrollContainer.getBoundingClientRect();
        const scrollHeight = scrollContainer.offsetHeight;
        const viewportHeight = window.innerHeight;

        const scrolled = -rect.top;
        const scrollableDistance = scrollHeight - viewportHeight;
        const progress = Math.max(0, Math.min(1, scrolled / scrollableDistance));

        const waitRatio = initialWaitHeight / totalScrollHeight;

        // 等待期：所有图片在初始堆叠位置
        if (progress < waitRatio) {
          for (let i = 0; i < totalImages; i++) {
            const state = computeStackPositionState(i, offset, scaleDecay, totalImages);
            applyImageStyle(imageEls[i], state);
          }
          return;
        }

        // 计算动画进度
        let animProgress = (progress - waitRatio) / (1 - waitRatio);
        animProgress = Math.max(0, Math.min(1, animProgress));

        // 计算当前阶段和阶段进度
        const rawPhase = animProgress * totalPhases;
        const currentPhase = Math.min(Math.floor(rawPhase), totalPhases);
        const phaseProgress = rawPhase - currentPhase;

        // 根据滚动进度直接计算每张图片的状态
        for (let i = 0; i < totalImages; i++) {
          if (i < currentPhase) {
            // 图片已完全滑出
            applyImageStyle(imageEls[i], computeSlidOutState());
          } else if (i === currentPhase) {
            // 当前正在滑出的图片（最后一张不滑出）
            if (i < totalImages - 1) {
              const remainingCount = totalImages - currentPhase;
              const state = computeSlideOutState(phaseProgress, offset, scaleDecay, remainingCount);
              applyImageStyle(imageEls[i], state);
            } else {
              // 最后一张图片保持显示
              applyImageStyle(imageEls[i], { translateY: 0, scale: 1, opacity: 1, zIndex: 1, overlayOpacity: 0 });
            }
          } else {
            // 图片仍在堆叠中
            const remainingCount = totalImages - currentPhase;
            // positionInStack: 当前图片在堆叠中的位置
            // 图片 i 是堆叠中第 (i - currentPhase) 张
            const positionInStack = i - currentPhase;
            const state = computeStackPositionState(positionInStack, offset, scaleDecay, remainingCount);
            applyImageStyle(imageEls[i], state);
          }
        }
      }

      let ticking = false;
      let resizeTicking = false;

      function onScroll() {
        if (!ticking) {
          requestAnimationFrame(function() {
            updateAnimation();
            ticking = false;
          });
          ticking = true;
        }
      }

      function onResize() {
        if (!resizeTicking) {
          requestAnimationFrame(function() {
            readCssVars();
            updateStackHeight();
            updateAnimation();
            resizeTicking = false;
          });
          resizeTicking = true;
        }
      }

      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onResize, { passive: true });

      // 初始化：读取 CSS 变量并启动动画
      readCssVars();
      updateAnimation();

      controllers.set(root, {
        root: root,
        destroy: function() {
          try {
            window.removeEventListener('scroll', onScroll, { passive: true });
            window.removeEventListener('resize', onResize, { passive: true });
            for (const img of loadedImgs) {
              img.removeEventListener('load', onLoadUpdateStackHeight);
            }
            scrollContainer.style.height = '';
            if (stackWrapper) {
              stackWrapper.style.marginTop = '';
            }
            root.removeAttribute(INIT_ATTR);
          } catch (e) {}
        }
      });
    }

    function initAll(scope) {
      const base = scope && scope.querySelectorAll ? scope : document;
      const list = base.querySelectorAll(ROOT_SELECTOR);
      for (let i = 0; i < list.length; i++) initOne(list[i]);
    }

    function destroyAll(scope) {
      const base = scope && scope.querySelectorAll ? scope : document;
      const list = base.querySelectorAll(ROOT_SELECTOR);
      for (let j = 0; j < list.length; j++) destroyOne(list[j]);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function() { initAll(); });
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', function(event) {
      initAll(event && event.target ? event.target : null);
    });

    document.addEventListener('shopify:section:unload', function(event) {
      destroyAll(event && event.target ? event.target : null);
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_ndev-x30-everything-recognition-maternity"] && !Shopify.designMode) return;
  try {
    (function () {
    'use strict';

    const NS = 'ndev-x30-maternity';
    const ROOT_SELECTOR = '[data-ndev-x30-maternity]';
    const INIT_ATTR = 'data-' + NS + '-initialized';

    const registryKey = '__ndevBlockControllers__';
    if (!window[registryKey]) window[registryKey] = {};
    if (!window[registryKey][NS]) window[registryKey][NS] = new WeakMap();
    const controllers = window[registryKey][NS];

    function isMobile() {
      return window.matchMedia && window.matchMedia('(max-width: 1023px)').matches;
    }

    function getVisibleVideo(root) {
      var selector = isMobile() ? '.mb-done video' : '.pc-done video';
      var video = root.querySelector(selector);
      return video || root.querySelector('video');
    }

    function destroyOne(root) {
      var controller = root ? controllers.get(root) : null;
      if (controller && typeof controller.destroy === 'function') controller.destroy();
      if (root) controllers.delete(root);
    }

    function initOne(root) {
      if (!root) return;

      destroyOne(root);
      root.setAttribute(INIT_ATTR, '1');

      var nodeList = {
        videoWrapper: root.querySelector('[node-name="video-wrapper"]'),
        progress: root.querySelector('[node-name="progress"]'),
        progressBar: root.querySelector('[node-name="progress-bar"]'),
        volumeBtn: root.querySelector('[data-volume-btn]'),
        iconMuted: root.querySelector('.ndev-x30-maternity__volume-icon--muted'),
        iconUnmuted: root.querySelector('.ndev-x30-maternity__volume-icon--unmuted'),
        textMuted: root.querySelector('[data-btn-text-muted]'),
        textUnmuted: root.querySelector('[data-btn-text-unmuted]')
      };

      var video = null;
      var isMuted = true;

      // 更新图标和文案显示状态
      function updateDisplay() {
        if (isMuted) {
          // 静音状态：显示静音图标和静音文案
          if (nodeList.iconMuted) nodeList.iconMuted.style.display = '';
          if (nodeList.iconUnmuted) nodeList.iconUnmuted.style.display = 'none';
          if (nodeList.textMuted) nodeList.textMuted.style.display = '';
          if (nodeList.textUnmuted) nodeList.textUnmuted.style.display = 'none';
        } else {
          // 有声音状态：显示有声音图标和非静音文案
          if (nodeList.iconMuted) nodeList.iconMuted.style.display = 'none';
          if (nodeList.iconUnmuted) nodeList.iconUnmuted.style.display = '';
          if (nodeList.textMuted) nodeList.textMuted.style.display = 'none';
          if (nodeList.textUnmuted) nodeList.textUnmuted.style.display = '';
        }
      }

      // 初始化视频进度条
      function initProgress() {
        if (!nodeList.videoWrapper) return;

        video = getVisibleVideo(nodeList.videoWrapper);
        if (!video) return;

        // 监听视频时间更新
        if (nodeList.progress && nodeList.progressBar) {
          video.addEventListener('timeupdate', onTimeUpdate);
        }
      }

      function onTimeUpdate() {
        if (!video || !nodeList.progressBar || !nodeList.progress) return;

        if (video.duration > 0) {
          var progress = (video.currentTime / video.duration) * 100;
          nodeList.progressBar.style.width = progress + '%';
          nodeList.progress.setAttribute('aria-valuenow', Math.round(progress));
        }
      }

      // 音量切换
      function onVolumeClick(e) {
        e.preventDefault();

        // 获取当前可见的视频
        video = getVisibleVideo(nodeList.videoWrapper);
        if (!video) return;

        isMuted = !isMuted;

        if (isMuted) {
          video.muted = true;
        } else {
          video.muted = false;
          video.volume = 1;
        }

        // 更新按钮无障碍状态
        if (nodeList.volumeBtn) {
          nodeList.volumeBtn.setAttribute('aria-pressed', isMuted ? 'false' : 'true');
        }

        // 更新图标和文案显示
        updateDisplay();
      }

      // 用户偏好减少动画检测
      var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (prefersReducedMotion && nodeList.progressBar) {
        nodeList.progressBar.style.transition = 'none';
      }

      // 绑定按钮点击事件
      if (nodeList.volumeBtn) {
        nodeList.volumeBtn.addEventListener('click', onVolumeClick);
      }

      // 初始化图标和文案显示（默认静音状态）
      updateDisplay();

      // 延迟初始化进度条（等待视频加载）
      setTimeout(initProgress, 100);

      controllers.set(root, {
        root: root,
        destroy: function () {
          if (video) {
            video.removeEventListener('timeupdate', onTimeUpdate);
          }
          if (nodeList.volumeBtn) {
            nodeList.volumeBtn.removeEventListener('click', onVolumeClick);
          }
          try { root.removeAttribute(INIT_ATTR); } catch (e) {}
        }
      });
    }

    function initAll(scope) {
      var base = (scope && scope.querySelectorAll) ? scope : document;
      var list = base.querySelectorAll(ROOT_SELECTOR);
      for (var i = 0; i < list.length; i++) initOne(list[i]);
    }

    function destroyAll(scope) {
      var base = (scope && scope.querySelectorAll) ? scope : document;
      var list = base.querySelectorAll(ROOT_SELECTOR);
      for (var j = 0; j < list.length; j++) destroyOne(list[j]);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { initAll(); });
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', function (event) {
      initAll(event && event.target ? event.target : null);
    });

    document.addEventListener('shopify:section:unload', function (event) {
      destroyAll(event && event.target ? event.target : null);
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_ndev-x30-everything-recognition-privacy"] && !Shopify.designMode) return;
  try {
    (function () {
    'use strict';

    const NS = 'ndev-x30-everything-recognition-privacy';
    const ROOT_SELECTOR = '[data-ndev-x30-everything-recognition-privacy]';
    const INIT_ATTR = 'data-' + NS + '-initialized';

    const registryKey = '__ndevBlockControllers__';
    if (!window[registryKey]) window[registryKey] = {};
    if (!window[registryKey][NS]) window[registryKey][NS] = new WeakMap();
    const controllers = window[registryKey][NS];

    function lerp(start, end, t) {
      return start + (end - start) * t;
    }

    function clamp(value, min, max) {
      return Math.max(min, Math.min(max, value));
    }

    function destroyOne(root) {
      const controller = root ? controllers.get(root) : null;
      if (controller && typeof controller.destroy === 'function') controller.destroy();
      if (root) controllers.delete(root);
    }

    function initOne(root) {
      if (!root || root.hasAttribute(INIT_ATTR)) return;

      root.setAttribute(INIT_ATTR, '1');

      const scrollContainer = root.querySelector('[data-scroll-container]');
      const media = root.querySelector('[data-media]');
      const text = root.querySelector('[data-text]');

      if (!scrollContainer || !media) return;

      let cssVarsCache = null;

      function getCssVars() {
        if (cssVarsCache) return cssVarsCache;
        const computedStyle = getComputedStyle(root);
        cssVarsCache = {
          enterScaleStart: parseFloat(computedStyle.getPropertyValue('--enter-scale-start')) || 0.9,
          enterRadiusStart: parseFloat(computedStyle.getPropertyValue('--enter-radius-start')) || 48,
          blurMax: parseFloat(computedStyle.getPropertyValue('--blur-max')) || 100,
        };
        return cssVarsCache;
      }

      function clearStyles() {
        if (media) {
          media.style.transform = '';
          media.style.borderRadius = '';
          media.style.filter = '';
          media.style.opacity = '';
        }
        if (text) {
          text.style.transform = '';
          text.style.opacity = '';
        }
      }

      function applyAnimation(progress) {
        const { enterProgress, stickyProgress, exitProgress } = progress;
        const cssVars = getCssVars();
        const { enterScaleStart, enterRadiusStart, blurMax } = cssVars;

        // 进场动画
        if (enterProgress < 1) {
          const scale = lerp(enterScaleStart, 1, enterProgress);
          const radius = lerp(enterRadiusStart, 0, enterProgress);
          media.style.transform = `scale(${scale})`;
          media.style.borderRadius = `${radius}px`;
        } else {
          media.style.transform = 'scale(1)';
          media.style.borderRadius = '0px';
        }

        // 背景模糊：sticky 进度 0-0.5
        const blurProgress = clamp(stickyProgress * 2, 0, 1);
        const blur = lerp(0, blurMax, blurProgress);
        media.style.filter = `blur(${blur}px)`;

        // 文字出现：sticky 进度 0.5-0.75
        let textY = 100;
        let textOpacity = 0;

        if (stickyProgress >= 0.5 && stickyProgress < 0.75) {
          const textProgress = (stickyProgress - 0.5) / 0.25;
          textY = lerp(100, 0, textProgress);
          textOpacity = lerp(0, 1, textProgress);
        } else if (stickyProgress >= 0.75) {
          textY = 0;
          textOpacity = 1;
        }

        if (text) {
          text.style.transform = `translate(-50%, calc(-50% + ${textY}%))`;
          text.style.opacity = String(textOpacity);
        }

        // 离场透明度
        if (exitProgress > 0) {
          const opacity = lerp(1, 0, exitProgress);
          media.style.opacity = String(opacity);
        } else {
          media.style.opacity = '1';
        }
      }

      let ticking = false;

      function onScroll() {
        if (ticking) return;
        ticking = true;

        requestAnimationFrame(function () {
          ticking = false;

          const rect = scrollContainer.getBoundingClientRect();
          const containerHeight = scrollContainer.offsetHeight;
          const viewportHeight = window.innerHeight;

          const scrollableDistance = containerHeight - viewportHeight;

          if (scrollableDistance <= 0) {
            applyAnimation({ enterProgress: 0, stickyProgress: 0, exitProgress: 0 });
            return;
          }

          // scrollTop: sticky 元素顶边距离视口顶边的距离
          const scrollTop = -rect.top;

          // 进场进度：scrollTop 从 -viewportHeight 到 0
          // -viewportHeight = 元素底部刚进入视口底部
          // 0 = 元素顶部到达视口顶部（sticky 生效）
          let enterProgress = 0;
          if (scrollTop <= -viewportHeight) {
            // 元素还在视口下方，未开始进场
            enterProgress = 0;
          } else if (scrollTop < 0) {
            // 进场中：从 0 渐变到 1
            enterProgress = 1 + scrollTop / viewportHeight;
          } else {
            // sticky 已生效
            enterProgress = 1;
          }

          // Sticky 进度：scrollTop >= 0
          let stickyProgress = 0;
          if (scrollTop >= 0 && scrollTop <= scrollableDistance) {
            stickyProgress = clamp(scrollTop / scrollableDistance, 0, 1);
          } else if (scrollTop > scrollableDistance) {
            stickyProgress = 1;
          }

          // 离场进度：scrollTop > scrollableDistance
          let exitProgress = 0;
          if (scrollTop > scrollableDistance) {
            exitProgress = clamp((scrollTop - scrollableDistance) / viewportHeight, 0, 1);
          }

          applyAnimation({ enterProgress, stickyProgress, exitProgress });
        });
      }

      function onResize() {
        cssVarsCache = null;
        onScroll();
      }

      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onResize, { passive: true });

      onScroll();

      controllers.set(root, {
        root: root,
        destroy: function () {
          try {
            window.removeEventListener('scroll', onScroll);
            window.removeEventListener('resize', onResize);
            clearStyles();
            root.removeAttribute(INIT_ATTR);
          } catch (e) {}
        },
      });
    }

    function initAll(scope) {
      const base = scope && scope.querySelectorAll ? scope : document;
      const list = base.querySelectorAll(ROOT_SELECTOR);
      for (let i = 0; i < list.length; i++) initOne(list[i]);
    }

    function destroyAll(scope) {
      const base = scope && scope.querySelectorAll ? scope : document;
      const list = base.querySelectorAll(ROOT_SELECTOR);
      for (let i = 0; i < list.length; i++) destroyOne(list[i]);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', function (event) {
      initAll(event && event.target ? event.target : null);
    });

    document.addEventListener('shopify:section:unload', function (event) {
      destroyAll(event && event.target ? event.target : null);
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_ndev-x30-glowing"] && !Shopify.designMode) return;
  try {
    (function () {
    'use strict';

    var NS = 'ndev-x30-glowing';
    var ROOT_SELECTOR = '[data-ndev-x30-glowing]';
    var INIT_ATTR = 'data-' + NS + '-initialized';

    var registryKey = '__ndevBlockControllers__';
    if (!window[registryKey]) window[registryKey] = {};
    if (!window[registryKey][NS]) window[registryKey][NS] = new WeakMap();
    var controllers = window[registryKey][NS];

    function queryCards(track) {
      return track ? track.querySelectorAll('.ndev-x30-glowing-card') : [];
    }

    function formatPageNum(num) {
      return num < 10 ? '0' + num : '' + num;
    }

    /** 与 CSS stroke-dasharray 一致：r=18 时周长约 113.1 */
    var PROGRESS_RING_LENGTH = 113.1;

    function readTrackTranslateX(track) {
      try {
        var s = window.getComputedStyle(track).transform;
        if (!s || s === 'none') return 0;
        var m = new DOMMatrixReadOnly(s);
        return m.m41;
      } catch (eTx) {
        return 0;
      }
    }

    /** frame 内容区（与 clientWidth 一致）：勿用 fr.width 当可视宽度（border-box），与 offsetWidth 比较会错位 */
    function getFrameContentBox(frame) {
      var fr = frame.getBoundingClientRect();
      var st = window.getComputedStyle(frame);
      var bl = parseFloat(st.borderLeftWidth) || 0;
      var br = parseFloat(st.borderRightWidth) || 0;
      var pl = parseFloat(st.paddingLeft) || 0;
      var pr = parseFloat(st.paddingRight) || 0;
      var W = frame.clientWidth;
      if (W <= 0 && fr.width > 0) {
        W = Math.max(0, fr.width - bl - br - pl - pr);
      }
      var left = fr.left + bl + pl;
      return { left: left, width: W, right: left + W, mid: left + W / 2 };
    }

    /**
     * 计算轨道最终 translateX（px）。
     * 可视宽度：frame.clientWidth；对齐/夹紧：内容区 left/right（含 border+padding）。
     * 轨道总宽：track.offsetWidth（布局宽度，不受 transform 影响），不用 scrollWidth 与父 clientWidth 混比。
     */
    function computeTrackTranslateX(frame, track, card) {
      var box = getFrameContentBox(frame);
      var W = box.width;
      if (W <= 0) return 0;
      var cr = card.getBoundingClientRect();
      var tr = track.getBoundingClientRect();
      var T = track.offsetWidth;
      var txCur = readTrackTranslateX(track);

      var d = box.mid - (cr.left + cr.width / 2);

      var dCardLo = box.left - cr.left;
      var dCardHi = box.right - cr.right;
      d = Math.max(dCardLo, Math.min(d, dCardHi));

      if (T > W + 0.5) {
        var dTrackLo = box.right - tr.right;
        var dTrackHi = box.left - tr.left;
        d = Math.max(dTrackLo, Math.min(dTrackHi, d));
      }

      return txCur + d;
    }

    function destroyOne(root) {
      var controller = root ? controllers.get(root) : null;
      if (controller && typeof controller.destroy === 'function') controller.destroy();
      if (root) controllers.delete(root);
    }

    function initOne(root) {
      if (!root) return;

      destroyOne(root);

      var frame = root.querySelector('[data-ndev-x30-glowing-frame]');
      var track = root.querySelector('[data-ndev-x30-glowing-track]');
      if (!frame || !track) return;

      var cards = queryCards(track);
      if (!cards.length) return;

      var paginationEl = root.querySelector('[data-ndev-x30-glowing-pagination]');
      var paginationCurrentEl = paginationEl
        ? paginationEl.querySelector('[data-ndev-x30-glowing-pagination-current]')
        : null;
      var paginationTotalEl = paginationEl
        ? paginationEl.querySelector('[data-ndev-x30-glowing-pagination-total]')
        : null;
      var paginationPrevBtn = paginationEl
        ? paginationEl.querySelector('.ndev-x30-glowing__pagination-button--prev')
        : null;
      var paginationNextBtn = paginationEl
        ? paginationEl.querySelector('.ndev-x30-glowing__pagination-button--next')
        : null;
      var ringHost = paginationNextBtn
        ? paginationNextBtn.querySelector('[data-ndev-x30-glowing-ring-host]')
        : null;
      var hidePaginationOnePage = root.getAttribute('data-hide-pagination-one-page') !== 'false';

      root.setAttribute(INIT_ATTR, '1');

      var index = 0;
      var timer = null;
      var ro = null;
      var io = null;
      var reducedMotion = false;
      var resumeTimer = null;
      var inViewKickTimer = null;
      var ringRafId = null;

      try {
        reducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      } catch (e) {}

      var autoplayOn = root.getAttribute('data-autoplay') === 'true' && !reducedMotion;
      var autoplayMs = parseInt(root.getAttribute('data-autoplay-speed'), 10) || 3000;
      var autoplayInView = (root.getAttribute('data-autoplay-start') || 'immediate').trim() === 'in_view';

      if (autoplayOn && ringHost) {
        while (ringHost.firstChild) {
          ringHost.removeChild(ringHost.firstChild);
        }
        var ringSvg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
        ringSvg.setAttribute('class', 'ndev-x30-glowing__progress-ring-svg');
        ringSvg.setAttribute('viewBox', '0 0 40 40');
        var ringCircle = document.createElementNS('http://www.w3.org/2000/svg', 'circle');
        ringCircle.setAttribute('class', 'ndev-x30-glowing__progress-ring');
        ringCircle.setAttribute('cx', '20');
        ringCircle.setAttribute('cy', '20');
        ringCircle.setAttribute('r', '18');
        ringSvg.appendChild(ringCircle);
        ringHost.appendChild(ringSvg);
      }

      function getProgressRing() {
        return paginationEl ? paginationEl.querySelector('.ndev-x30-glowing__progress-ring') : null;
      }

      function stopProgressRingAnim() {
        if (ringRafId !== null) {
          cancelAnimationFrame(ringRafId);
          ringRafId = null;
        }
      }

      function setRingDashOffset(ring, value) {
        if (!ring || !ring.style) return;
        ring.style.strokeDashoffset = String(value);
      }

      function resetProgressRingIdle(ring) {
        if (!ring) return;
        stopProgressRingAnim();
        setRingDashOffset(ring, PROGRESS_RING_LENGTH);
      }

      function startProgressRingAnim(ring) {
        if (!ring || !autoplayOn) return;
        stopProgressRingAnim();
        var duration = autoplayMs;
        if (duration <= 0) return;
        setRingDashOffset(ring, PROGRESS_RING_LENGTH);
        var t0 = typeof performance !== 'undefined' && performance.now ? performance.now() : Date.now();
        function step(now) {
          var t1 = typeof performance !== 'undefined' && performance.now ? performance.now() : Date.now();
          var elapsed = t1 - t0;
          if (elapsed >= duration) {
            setRingDashOffset(ring, 0);
            ringRafId = null;
            return;
          }
          setRingDashOffset(ring, PROGRESS_RING_LENGTH * (1 - elapsed / duration));
          ringRafId = requestAnimationFrame(step);
        }
        ringRafId = requestAnimationFrame(step);
      }

      function refreshPaginationVisibility() {
        if (!paginationEl) return;
        var lock = hidePaginationOnePage && cards.length <= 1;
        paginationEl.classList.toggle('ndev-x30-glowing__pagination--lock', lock);
        try {
          paginationEl.setAttribute('aria-hidden', lock ? 'true' : 'false');
        } catch (eRing) {}
      }

      function updatePaginationNumbers() {
        if (!paginationCurrentEl || !paginationTotalEl) return;
        paginationCurrentEl.textContent = formatPageNum(index + 1);
        paginationTotalEl.textContent = '/' + formatPageNum(cards.length);
      }

      /** 多页时首尾循环：首张可点「上一张」到末张，末张可点「下一张」到首张，故不禁用按钮 */
      function updatePaginationDisabled() {
        if (!paginationPrevBtn || !paginationNextBtn) return;
        var lock = cards.length <= 1;
        paginationPrevBtn.disabled = lock;
        paginationNextBtn.disabled = lock;
      }

      function setClasses(n) {
        var prevIdx = index;
        index = n;
        for (var c = 0; c < cards.length; c++) {
          cards[c].classList.toggle('actived', c === n);
        }
        updatePaginationNumbers();
        updatePaginationDisabled();
        if (autoplayOn && prevIdx !== n) {
          startProgressRingAnim(getProgressRing());
        }
      }

      function scrollToCard(n, smooth) {
        var card = cards[n];
        if (!card) return;
        var tx = computeTrackTranslateX(frame, track, card);
        var useMotion = smooth && !reducedMotion;
        if (useMotion) {
          track.classList.remove('ndev-x30-glowing__track--instant');
        } else {
          track.classList.add('ndev-x30-glowing__track--instant');
        }
        track.style.transform = 'translate3d(' + tx + 'px,0,0)';
        if (!useMotion) {
          void track.offsetWidth;
          track.classList.remove('ndev-x30-glowing__track--instant');
        }
      }

      function setActive(i, instant) {
        if (!cards.length) return;
        var n = ((i % cards.length) + cards.length) % cards.length;
        setClasses(n);
        scrollToCard(n, !instant);
      }

      function next() {
        setActive(index + 1);
      }

      function stopTimer() {
        if (timer) {
          clearInterval(timer);
          timer = null;
        }
      }

      function startTimer() {
        stopTimer();
        if (!autoplayOn || cards.length < 2) return;
        timer = setInterval(next, autoplayMs);
        startProgressRingAnim(getProgressRing());
      }

      function inViewport() {
        var r = root.getBoundingClientRect();
        var vh = window.innerHeight || document.documentElement.clientHeight || 0;
        var vw = window.innerWidth || document.documentElement.clientWidth || 0;
        return r.bottom > 0 && r.top < vh && r.right > 0 && r.left < vw;
      }

      function pauseInteraction() {
        stopTimer();
        if (resumeTimer) {
          clearTimeout(resumeTimer);
          resumeTimer = null;
        }
        resetProgressRingIdle(getProgressRing());
      }

      function scheduleResume() {
        if (!autoplayOn) return;
        resumeTimer = setTimeout(function () {
          resumeTimer = null;
          if (autoplayInView && !inViewport()) return;
          startTimer();
        }, 2200);
      }

      function bindResize() {
        if (typeof ResizeObserver === 'undefined') {
          window.addEventListener('resize', relayout);
          return;
        }
        ro = new ResizeObserver(relayout);
        ro.observe(frame);
      }

      function unbindResize() {
        if (ro) {
          ro.disconnect();
          ro = null;
        }
        window.removeEventListener('resize', relayout);
      }

      function relayout() {
        scrollToCard(index, false);
      }

      bindResize();

      function setupAutoplay() {
        if (!autoplayOn) return;
        root.addEventListener('touchstart', pauseInteraction, { passive: true });
        root.addEventListener('touchend', scheduleResume, { passive: true });
        if (autoplayInView && typeof IntersectionObserver !== 'undefined') {
          io = new IntersectionObserver(
            function (entries) {
              var ok = entries.some(function (en) {
                return en.isIntersecting;
              });
              if (ok) {
                startTimer();
              } else {
                stopTimer();
                resetProgressRingIdle(getProgressRing());
              }
            },
            { root: null, threshold: 0 }
          );
          io.observe(root);
          inViewKickTimer = setTimeout(function () {
            inViewKickTimer = null;
            if (inViewport()) startTimer();
          }, 50);
        } else {
          startTimer();
        }
      }

      function onCardClick(e) {
        var target = e.target;
        while (target && target !== track) {
          if (target.classList && target.classList.contains('ndev-x30-glowing-card')) {
            for (var i = 0; i < cards.length; i++) {
              if (cards[i] === target) {
                setActive(i);
                startTimer();
                return;
              }
            }
          }
          target = target.parentElement;
        }
      }

      function onPaginationClick(e) {
        if (!paginationEl) return;
        var target = e.target;
        while (target && target !== paginationEl) {
          if (target.classList && target.classList.contains('ndev-x30-glowing__pagination-button--prev')) {
            pauseInteraction();
            setActive(index - 1);
            scheduleResume();
            return;
          }
          if (target.classList && target.classList.contains('ndev-x30-glowing__pagination-button--next')) {
            pauseInteraction();
            setActive(index + 1);
            scheduleResume();
            return;
          }
          target = target.parentElement;
        }
      }

      refreshPaginationVisibility();
      updatePaginationNumbers();
      updatePaginationDisabled();
      track.addEventListener('click', onCardClick);
      if (paginationEl) {
        paginationEl.addEventListener('click', onPaginationClick);
      }

      function kick() {
        setActive(0, true);
        setupAutoplay();
      }

      if (typeof requestAnimationFrame === 'function') {
        requestAnimationFrame(kick);
      } else {
        kick();
      }

      controllers.set(root, {
        root: root,
        destroy: function () {
          stopTimer();
          stopProgressRingAnim();
          if (resumeTimer) clearTimeout(resumeTimer);
          if (inViewKickTimer) clearTimeout(inViewKickTimer);
          unbindResize();
          track.removeEventListener('click', onCardClick);
          if (paginationEl) {
            paginationEl.removeEventListener('click', onPaginationClick);
          }
          if (autoplayOn) {
            root.removeEventListener('touchstart', pauseInteraction);
            root.removeEventListener('touchend', scheduleResume);
          }
          try {
            track.classList.add('ndev-x30-glowing__track--instant');
            track.style.transform = '';
            track.classList.remove('ndev-x30-glowing__track--instant');
          } catch (eTrack) {}
          if (io) {
            io.disconnect();
            io = null;
          }
          try {
            root.removeAttribute(INIT_ATTR);
          } catch (e2) {}
        }
      });
    }

    function initAll(scope) {
      var base = scope && scope.querySelectorAll ? scope : document;
      var list = base.querySelectorAll(ROOT_SELECTOR);
      for (var i = 0; i < list.length; i++) initOne(list[i]);
    }

    function destroyAll(scope) {
      var base = scope && scope.querySelectorAll ? scope : document;
      var list = base.querySelectorAll(ROOT_SELECTOR);
      for (var j = 0; j < list.length; j++) destroyOne(list[j]);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        initAll();
      });
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', function (event) {
      initAll(event && event.target ? event.target : null);
    });

    document.addEventListener('shopify:section:unload', function (event) {
      destroyAll(event && event.target ? event.target : null);
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_ndev-x30-mopping-overview"] && !Shopify.designMode) return;
  try {
    (function () {
    'use strict';

    const NS = 'ndev-x30-mopping-overview';
    const ROOT_SELECTOR = '[data-ndev-x30-mopping-overview]';
    const INIT_ATTR = 'data-' + NS + '-initialized';

    // 每个 slide 的滚动高度配置 (vh)
    // 第一个 slide: 250vh (100vh 完整展示 + 150vh 停留)
    // 其他 slide: 150vh
    const FIRST_SLIDE_VH = 250;
    const OTHER_SLIDE_VH = 150;

    const registryKey = '__ndevBlockControllers__';
    if (!window[registryKey]) window[registryKey] = {};
    if (!window[registryKey][NS]) window[registryKey][NS] = new WeakMap();
    const controllers = window[registryKey][NS];

    function destroyOne(root) {
      const controller = root ? controllers.get(root) : null;
      if (controller && typeof controller.destroy === 'function') controller.destroy();
      if (root) controllers.delete(root);
    }

    function initOne(root) {
      if (!root) return;
      if (root.hasAttribute(INIT_ATTR)) return;

      destroyOne(root);
      root.setAttribute(INIT_ATTR, '1');

      const slides = root.querySelectorAll('.ndev-x30-mopping-overview-slide');
      const totalSlides = slides.length;

      if (totalSlides === 0) {
        controllers.set(root, { root: root, destroy: function () {} });
        return;
      }

      // 计算每个 slide 的滚动高度和累计高度
      const slideHeights = [];
      const cumulativeHeights = [0]; // 累计高度起点
      let totalHeight = 0;

      for (let i = 0; i < totalSlides; i++) {
        const vh = (i === 0) ? FIRST_SLIDE_VH : OTHER_SLIDE_VH;
        slideHeights.push(vh);
        totalHeight += vh;
        cumulativeHeights.push(totalHeight);
      }

      // 设置容器总高度
      root.style.height = totalHeight + 'vh';
      slides[0].classList.add('is-active');

      let currentSlide = 0;
      let ticking = false;

      function updateSlide() {
        const rect = root.getBoundingClientRect();
        const viewportHeight = window.innerHeight;
        const scrollableHeight = root.offsetHeight - viewportHeight;
        const scrolled = Math.max(0, -rect.top);
        const scrollProgress = scrolled / scrollableHeight;

        // 计算当前应该显示的 slide
        let newSlide = 0;
        for (let i = 0; i < totalSlides; i++) {
          const slideStart = cumulativeHeights[i] / totalHeight;
          const slideEnd = cumulativeHeights[i + 1] / totalHeight;

          if (scrollProgress >= slideStart && scrollProgress < slideEnd) {
            // 在当前 slide 范围内
            const progressInSlide = (scrollProgress - slideStart) / (slideEnd - slideStart);
            // 当滚动到 slide 的 80% 时切换到下一个
            if (progressInSlide >= 0.8 && i < totalSlides - 1) {
              newSlide = i + 1;
            } else {
              newSlide = i;
            }
            break;
          }
          newSlide = i;
        }

        // 确保最后一个 slide 正确显示
        if (scrollProgress >= 0.99) {
          newSlide = totalSlides - 1;
        }

        newSlide = Math.max(0, Math.min(newSlide, totalSlides - 1));

        if (newSlide !== currentSlide) {
          slides[currentSlide].classList.remove('is-active');
          slides[newSlide].classList.add('is-active');
          currentSlide = newSlide;
        }
      }

      function onScroll() {
        if (!ticking) {
          requestAnimationFrame(function () {
            updateSlide();
            ticking = false;
          });
          ticking = true;
        }
      }

      window.addEventListener('scroll', onScroll, { passive: true });
      updateSlide();

      controllers.set(root, {
        root: root,
        destroy: function () {
          window.removeEventListener('scroll', onScroll, { passive: true });
          try { root.removeAttribute(INIT_ATTR); } catch (e) {}
        }
      });
    }

    function initAll(scope) {
      var base = (scope && scope.querySelectorAll) ? scope : document;
      var list = base.querySelectorAll(ROOT_SELECTOR);
      for (var i = 0; i < list.length; i++) initOne(list[i]);
    }

    function destroyAll(scope) {
      var base = (scope && scope.querySelectorAll) ? scope : document;
      var list = base.querySelectorAll(ROOT_SELECTOR);
      for (var i = 0; i < list.length; i++) destroyOne(list[i]);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { initAll(); });
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', function (event) {
      initAll(event && event.target ? event.target : null);
    });

    document.addEventListener('shopify:section:unload', function (event) {
      destroyAll(event && event.target ? event.target : null);
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_ndev-x30-sweep-coverage"] && !Shopify.designMode) return;
  try {
    (function () {
    'use strict';

    const NS = 'ndev-x30-sweep-coverage';
    const ROOT_SELECTOR = '[data-ndev-x30-sweep-coverage]';
    const INIT_ATTR = 'data-' + NS + '-initialized';

    const registryKey = '__ndevBlockControllers__';
    if (!window[registryKey]) window[registryKey] = {};
    if (!window[registryKey][NS]) window[registryKey][NS] = new WeakMap();
    const controllers = window[registryKey][NS];

    // 工具函数
    function lerp(start, end, t) {
      return start + (end - start) * t;
    }

    function clamp(value, min, max) {
      return Math.max(min, Math.min(max, value));
    }

    function destroyOne(root) {
      const controller = root ? controllers.get(root) : null;
      if (controller && typeof controller.destroy === 'function') controller.destroy();
      if (root) controllers.delete(root);
    }

    function initOne(root) {
      if (!root) return;

      destroyOne(root);
      root.setAttribute(INIT_ATTR, '1');

      // 获取节点
      const scrollContainer = root.querySelector('[node-name="scroll-container"]');
      const bg = root.querySelector('[node-name="bg"]');
      const maskTop = root.querySelector('[node-name="mask-top"]');
      const maskBottom = root.querySelector('[node-name="mask-bottom"]');
      const line = root.querySelector('[node-name="line"]');
      // PC/M 端标题
      const titlePc = root.querySelector('[node-name="title"]');
      const titleMb = root.querySelector('[node-name="title-mb"]');
      const footer = root.querySelector('[node-name="footer"]');

      if (!scrollContainer) return;

      // 缓存 CSS 变量值，仅在 resize 时更新
      let cssVarsCache = null;

      function getCssVars() {
        if (cssVarsCache) return cssVarsCache;
        const computedStyle = getComputedStyle(root);
        const finalWidthVw = parseFloat(computedStyle.getPropertyValue('--final-width')) || 56.67;
        const finalMaxWidth = parseFloat(computedStyle.getPropertyValue('--final-max-width')) || 960;

        // 计算实际宽度（考虑 max-width 限制）
        const vwWidth = finalWidthVw / 100 * window.innerWidth;
        const actualWidth = Math.min(vwWidth, finalMaxWidth);
        const actualWidthPercent = actualWidth / window.innerWidth * 100;

        // 计算图片左边缘位置（居中）
        const leftOffsetPercent = (100 - actualWidthPercent) / 2;

        cssVarsCache = {
          finalWidthPercent: actualWidthPercent,
          leftOffsetPercent: leftOffsetPercent,
          finalRadius: parseFloat(computedStyle.getPropertyValue('--final-radius')) || 24,
          contentOffset: parseFloat(computedStyle.getPropertyValue('--content-offset')) || 32,
          aspectRatio: parseFloat(computedStyle.getPropertyValue('--aspect-ratio')) || 1.777
        };
        return cssVarsCache;
      }

      // 计算图片高度占视口的比例
      function getImageHeightRatio(finalWidthPercent, aspectRatio) {
        // finalWidthPercent 是百分比，如 56.67 表示 56.67%
        // 图片高度/视口高度 = (图片宽度 * 图片宽高比) / 视口高度
        // = (finalWidthPercent/100 * viewportWidth / aspectRatio) / viewportHeight
        // = finalWidthPercent/100 / aspectRatio * (viewportWidth/viewportHeight)
        const vwToVhRatio = window.innerWidth / window.innerHeight;
        return (finalWidthPercent / 100) / aspectRatio * vwToVhRatio;
      }

      // 重置所有样式到初始状态
      function resetStyles() {
        if (line) {
          line.style.transform = 'translateX(-100%)';
          line.style.opacity = '1';
        }
        if (bg) {
          bg.style.opacity = '0';
          bg.style.width = '100%';
          bg.style.borderRadius = '0';
          bg.style.left = '0';
        }
        if (maskTop) maskTop.style.height = '50vh';
        if (maskBottom) maskBottom.style.height = '50vh';
        // PC 端标题
        if (titlePc) {
          titlePc.style.opacity = '0';
          titlePc.style.left = '100%';
          titlePc.style.top = 'calc(50% - 32px)';
          titlePc.style.transform = 'translateX(-100%) translateY(-100%)';
        }
        // 移动端标题
        if (titleMb) {
          titleMb.style.opacity = '0';
          titleMb.style.left = '100%';
          titleMb.style.top = 'calc(50% - 32px)';
          titleMb.style.transform = 'translateX(-100%) translateY(-100%)';
        }
        if (footer) {
          footer.style.opacity = '0';
          footer.style.left = '100%';
          footer.style.top = 'calc(50% + 32px)';
          footer.style.transform = 'translateX(-100%) translateY(0)';
        }
      }

      // 应用动画状态
      function applyAnimation(fps) {
        const cssVars = getCssVars();
        const { finalWidthPercent, leftOffsetPercent, finalRadius, contentOffset, aspectRatio } = cssVars;
        const viewportHeight = window.innerHeight;

        // 计算图片高度占视口的比例（用于多个阶段）
        const imageHeightRatio = getImageHeightRatio(finalWidthPercent, aspectRatio);

        // 根据进度计算各属性的最终值（确保每个阶段都完整设置所有属性）
        let lineTransform, lineOpacity;
        let bgOpacity, bgWidth, bgRadius, bgLeft;
        let maskHeight;
        let titleOpacity, titleLeft, titleTop, titleTransform;
        let footerOpacity, footerLeft, footerTop, footerTransform;

        // Phase 1: 线条延伸 + 标题/底部区域淡入并移动 (0-25%)
        if (fps <= 0.25) {
          const t = fps / 0.25;

          // 线条：从左延伸到右
          const lineTranslate = lerp(100, 0, t);
          lineTransform = `translateX(-${lineTranslate}%)`;
          lineOpacity = 1;

          // 背景：隐藏
          bgOpacity = 0;
          bgWidth = 100;
          bgRadius = 0;
          bgLeft = 0;

          // 遮罩：全屏
          maskHeight = 50;

          // 标题：从右往左淡入
          titleOpacity = lerp(0, 1, t);
          titleLeft = lerp(100, leftOffsetPercent, t);
          titleTop = 'calc(50% - 32px)';
          const titleTranslateX = lerp(-100, 0, t);
          titleTransform = `translateX(${titleTranslateX}%) translateY(-100%)`;

          // 底部区域：从右往左淡入
          footerOpacity = lerp(0, 1, t);
          footerLeft = lerp(100, leftOffsetPercent, t);
          footerTop = 'calc(50% + 32px)';
          const footerTranslateX = lerp(-100, 0, t);
          footerTransform = `translateX(${footerTranslateX}%) translateY(0)`;
        }

        // Phase 2: 线条透明 + 背景显现 (25-50%)
        else if (fps <= 0.5) {
          const t = (fps - 0.25) / 0.25;

          // 线条：淡出
          lineTransform = 'translateX(0)';
          lineOpacity = lerp(1, 0, t);

          // 背景：淡入
          bgOpacity = lerp(0, 1, t);
          bgWidth = 100;
          bgRadius = 0;
          bgLeft = 0;

          // 遮罩：全屏
          maskHeight = 50;

          // 标题：保持最终位置
          titleOpacity = 1;
          titleLeft = leftOffsetPercent;
          titleTop = 'calc(50% - 32px)';
          titleTransform = 'translateX(0) translateY(-100%)';

          // 底部区域：保持最终位置
          footerOpacity = 1;
          footerLeft = leftOffsetPercent;
          footerTop = 'calc(50% + 32px)';
          footerTransform = 'translateX(0) translateY(0)';
        }

        // Phase 3: 遮罩开幕 + 背景缩放 + 标题移动到图片上方 (50-85%)
        else if (fps <= 0.85) {
          const t = clamp((fps - 0.5) / 0.35, 0, 1);

          // 线条：完全透明
          lineTransform = 'translateX(0)';
          lineOpacity = 0;

          // 背景：缩放到最终尺寸
          bgOpacity = 1;
          bgWidth = lerp(100, finalWidthPercent, t);
          bgRadius = lerp(0, finalRadius, t);
          bgLeft = lerp(0, leftOffsetPercent, t);

          // 遮罩：减小到图片边缘
          const maskFinalHeight = 50 - imageHeightRatio * 50;
          maskHeight = lerp(50, maskFinalHeight, t);

          // 内容偏移（标题和底部区域共用）
          const contentOffsetVh = contentOffset / viewportHeight * 100;

          // 标题：从线条上方移动到图片上方
          titleOpacity = 1;
          titleLeft = leftOffsetPercent;
          const imageTopVh = 50 - imageHeightRatio * 50;
          const titleFinalPx = (imageTopVh - contentOffsetVh) / 100 * viewportHeight;
          const titleStartPx = viewportHeight / 2 - 32;
          titleTop = lerp(titleStartPx, titleFinalPx, t);
          titleTransform = 'translateX(0) translateY(-100%)';

          // 底部区域：从线条下方移动到图片下方
          footerOpacity = 1;
          footerLeft = leftOffsetPercent;
          const imageBottomVh = 50 + imageHeightRatio * 50;
          const footerFinalPx = (imageBottomVh + contentOffsetVh) / 100 * viewportHeight;
          const footerStartPx = viewportHeight / 2 + 32;
          footerTop = lerp(footerStartPx, footerFinalPx, t);
          footerTransform = 'translateX(0) translateY(0)';
        }

        // Phase 4: 保持最终状态 (85-100%)
        else {
          // 线条：完全透明
          lineTransform = 'translateX(0)';
          lineOpacity = 0;

          // 背景：最终尺寸
          bgOpacity = 1;
          bgWidth = finalWidthPercent;
          bgRadius = finalRadius;
          bgLeft = leftOffsetPercent;

          // 遮罩：最终高度
          const maskFinalHeight = 50 - imageHeightRatio * 50;
          maskHeight = maskFinalHeight;

          // 内容偏移（标题和底部区域共用）
          const contentOffsetVh = contentOffset / viewportHeight * 100;

          // 标题：最终位置
          titleOpacity = 1;
          titleLeft = leftOffsetPercent;
          const imageTopVh = 50 - imageHeightRatio * 50;
          titleTop = (imageTopVh - contentOffsetVh) / 100 * viewportHeight;
          titleTransform = 'translateX(0) translateY(-100%)';

          // 底部区域：最终位置
          footerOpacity = 1;
          footerLeft = leftOffsetPercent;
          const imageBottomVh = 50 + imageHeightRatio * 50;
          footerTop = (imageBottomVh + contentOffsetVh) / 100 * viewportHeight;
          footerTransform = 'translateX(0) translateY(0)';
        }

        // 统一应用所有样式（确保每个属性都有明确值）
        if (line) {
          line.style.transform = lineTransform;
          line.style.opacity = String(lineOpacity);
        }
        if (bg) {
          bg.style.opacity = String(bgOpacity);
          bg.style.width = `${bgWidth}%`;
          bg.style.borderRadius = `${bgRadius}px`;
          bg.style.left = `${bgLeft}%`;
        }
        if (maskTop) maskTop.style.height = `${maskHeight}vh`;
        if (maskBottom) maskBottom.style.height = `${maskHeight}vh`;
        // PC 端标题
        if (titlePc) {
          titlePc.style.opacity = String(titleOpacity);
          titlePc.style.left = `${titleLeft}%`;
          titlePc.style.top = typeof titleTop === 'number' ? `${titleTop}px` : titleTop;
          titlePc.style.transform = titleTransform;
        }
        // 移动端标题
        if (titleMb) {
          titleMb.style.opacity = String(titleOpacity);
          titleMb.style.left = `${titleLeft}%`;
          titleMb.style.top = typeof titleTop === 'number' ? `${titleTop}px` : titleTop;
          titleMb.style.transform = titleTransform;
        }
        if (footer) {
          footer.style.opacity = String(footerOpacity);
          footer.style.left = `${footerLeft}%`;
          footer.style.top = typeof footerTop === 'number' ? `${footerTop}px` : footerTop;
          footer.style.transform = footerTransform;
        }
      }

      // 滚动处理
      let ticking = false;

      function onScroll() {
        if (ticking) return;
        ticking = true;

        requestAnimationFrame(function() {
          ticking = false;

          const rect = scrollContainer.getBoundingClientRect();
          const containerHeight = scrollContainer.offsetHeight;
          const viewportHeight = window.innerHeight;

          // 计算滚动进度
          // 当元素顶部到达视口顶部时，progress = 0
          // 当元素底部到达视口底部时，progress = 1
          const scrollRange = containerHeight - viewportHeight;

          if (scrollRange <= 0) {
            applyAnimation(0);
            return;
          }

          // scrollTop: 元素已经滚过了多少（负值表示还在视口下方）
          const scrollTop = -rect.top;
          const progress = clamp(scrollTop / scrollRange, 0, 1);

          applyAnimation(progress);
        });
      }

      function onResize() {
        cssVarsCache = null; // 清除缓存，重新读取 CSS 变量
        onScroll();
      }

      // 绑定事件
      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onResize, { passive: true });

      // 初始化
      resetStyles();
      onScroll();

      // 存储控制器
      controllers.set(root, {
        root: root,
        destroy: function() {
          try {
            window.removeEventListener('scroll', onScroll);
            window.removeEventListener('resize', onResize);
            resetStyles();
            root.removeAttribute(INIT_ATTR);
          } catch (e) {}
        }
      });
    }

    function initAll(scope) {
      const base = (scope && scope.querySelectorAll) ? scope : document;
      const list = base.querySelectorAll(ROOT_SELECTOR);
      for (let i = 0; i < list.length; i++) initOne(list[i]);
    }

    function destroyAll(scope) {
      const base = (scope && scope.querySelectorAll) ? scope : document;
      const list = base.querySelectorAll(ROOT_SELECTOR);
      for (let i = 0; i < list.length; i++) destroyOne(list[i]);
    }

    // 初始化
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }

    // Shopify 生命周期
    document.addEventListener('shopify:section:load', function(event) {
      initAll(event && event.target ? event.target : null);
    });

    document.addEventListener('shopify:section:unload', function(event) {
      destroyAll(event && event.target ? event.target : null);
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_ndev-x30-sweep-overview"] && !Shopify.designMode) return;
  try {
    (function () {
    'use strict';

    const NS = 'ndev-x30-sweep-overview';
    const ROOT_SELECTOR = '[data-' + NS + ']';
    const SCENE_SELECTOR = '[data-ndev-x30-sweep-overview-scene]';
    const INIT_ATTR = 'data-' + NS + '-initialized';

    const registryKey = '__ndevBlockControllers__';
    if (!window[registryKey]) window[registryKey] = {};
    if (!window[registryKey][NS]) window[registryKey][NS] = new WeakMap();
    const controllers = window[registryKey][NS];

    function destroyOne(root) {
      const controller = root ? controllers.get(root) : null;
      if (controller && typeof controller.destroy === 'function') controller.destroy();
      if (root) controllers.delete(root);
    }

    function initOne(root) {
      if (!root) return;

      destroyOne(root);
      root.setAttribute(INIT_ATTR, '1');

      const scenes = root.querySelectorAll(SCENE_SELECTOR);
      const sceneCount = scenes.length;

      if (sceneCount === 0) {
        controllers.set(root, { root: root, destroy: function () {} });
        return;
      }

      // 高度分布逻辑：
      // - 总滚动高度：400vh（可通过 CSS 变量配置）
      // - 首尾各预留 50vh 缓冲，共 100vh
      // - 剩余高度由所有场景平分
      // - 第一个场景额外获得 50vh，用于平滑进入过渡
      const ENTER_EXIT_BUFFER_VH = 100;
      const FIRST_SCENE_EXTRA_VH = 50;

      const heightStyle = getComputedStyle(root).getPropertyValue('--height').trim();
      let totalVh = 400;
      if (heightStyle) {
        const match = heightStyle.match(/(\d+)/);
        if (match) totalVh = parseInt(match[1], 10) || totalVh;
      }

      const scenesDurationVh = totalVh - ENTER_EXIT_BUFFER_VH;
      const baseSceneDurationVh = scenesDurationVh / sceneCount;
      const firstSceneDurationVh = baseSceneDurationVh + FIRST_SCENE_EXTRA_VH;
      const otherSceneDurationVh = baseSceneDurationVh;

      let ticking = false;
      let lastActiveIndex = -1;
      let pendingTimers = [];
      let lastScrollTop = 0;

      /**
       * 清理未完成的动画定时器
       */
      function clearPendingTimers() {
        pendingTimers.forEach(function (id) {
          clearTimeout(id);
        });
        pendingTimers = [];
      }

      /**
       * 清理场景的动画状态类
       */
      function clearAnimationStates(scene) {
        scene.classList.remove(
          'is-leaving-up', 'is-leaving-down',
          'is-entering-up', 'is-entering-down',
          'is-entered'
        );
      }

      /**
       * 清理所有场景的动画状态（快速滚动时使用）
       */
      function clearAllAnimationStates() {
        scenes.forEach(function (scene) {
          clearAnimationStates(scene);
        });
      }

      // 初始化：激活第一个场景，并标记为已进场（跳过进场动画）
      scenes[0].classList.add('is-active', 'is-entered');
      lastActiveIndex = 0;

      /**
       * 计算像素高度（基于当前视口）
       */
      function getHeights() {
        const viewportHeight = window.innerHeight;
        return {
          firstSceneHeightPx: (firstSceneDurationVh / 100) * viewportHeight,
          perSceneHeightPx: (otherSceneDurationVh / 100) * viewportHeight
        };
      }

      function updateActiveScene() {
        const heights = getHeights();
        const rect = root.getBoundingClientRect();
        const scrollTop = -rect.top;

        // 计算当前应该激活的场景索引
        let activeIndex = 0;
        if (scrollTop >= heights.firstSceneHeightPx) {
          const remainingScroll = scrollTop - heights.firstSceneHeightPx;
          const sceneIndex = Math.floor(remainingScroll / heights.perSceneHeightPx) + 1;
          activeIndex = Math.min(sceneIndex, sceneCount - 1);
        }

        if (activeIndex !== lastActiveIndex) {
          // 清理未完成的动画定时器和状态
          clearPendingTimers();
          clearAllAnimationStates();

          const oldScene = scenes[lastActiveIndex];
          const newScene = scenes[activeIndex];
          const isScrollingDown = scrollTop > lastScrollTop;

          // 离场动画
          oldScene.classList.add(isScrollingDown ? 'is-leaving-up' : 'is-leaving-down');

          // 150ms 后触发 opacity 过渡 + 进场动画（同时开始）
          pendingTimers.push(setTimeout(function () {
            oldScene.classList.remove('is-active');
            newScene.classList.add('is-active');
            // 进场动画和 opacity 过渡同时触发，跳变在 opacity=0 时不可见
            newScene.classList.add(isScrollingDown ? 'is-entering-down' : 'is-entering-up');

            // 150ms 后清理动画类，标记进场完成
            pendingTimers.push(setTimeout(function () {
              clearAnimationStates(newScene);
              newScene.classList.add('is-entered');
            }, 150));
          }, 150));

          lastActiveIndex = activeIndex;
          lastScrollTop = scrollTop;
        }
      }

      let resizeTicking = false;

      function onResize() {
        if (!resizeTicking) {
          requestAnimationFrame(function () {
            resizeTicking = false;
          });
          resizeTicking = true;
        }
      }

      function onScroll() {
        if (!ticking) {
          requestAnimationFrame(function () {
            updateActiveScene();
            ticking = false;
          });
          ticking = true;
        }
      }

      updateActiveScene();
      window.addEventListener('resize', onResize, { passive: true });
      window.addEventListener('scroll', onScroll, { passive: true });

      controllers.set(root, {
        root: root,
        destroy: function () {
          clearPendingTimers();
          window.removeEventListener('resize', onResize, { passive: true });
          window.removeEventListener('scroll', onScroll, { passive: true });
          try { root.removeAttribute(INIT_ATTR); } catch (e) {}
        }
      });
    }

    function initAll(scope) {
      const base = (scope && scope.querySelectorAll) ? scope : document;
      const list = base.querySelectorAll(ROOT_SELECTOR);
      for (var i = 0; i < list.length; i++) initOne(list[i]);
    }

    function destroyAll(scope) {
      const base = (scope && scope.querySelectorAll) ? scope : document;
      const list = base.querySelectorAll(ROOT_SELECTOR);
      for (var i = 0; i < list.length; i++) destroyOne(list[i]);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { initAll(); });
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', function (event) {
      initAll(event && event.target ? event.target : null);
    });

    document.addEventListener('shopify:section:unload', function (event) {
      destroyAll(event && event.target ? event.target : null);
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_ndev-x30-sweep-tabs"] && !Shopify.designMode) return;
  try {
    (function () {
    'use strict';

    const NS = 'ndev-x30-sweep-tabs';
    const ROOT_SELECTOR = '[data-' + NS + ']';
    const INIT_ATTR = 'data-' + NS + '-initialized';
    const PROGRESS_BAR_SELECTOR = '[class*="__progress-bar"]';
    const PROGRESS_RING_SELECTOR = '[class*="__progress-ring-circle"]';
    const PROGRESS_SELECTOR = '[class*="__progress"]';
    const CSS_VAR_DURATION = '--autoplay-duration';

    const registryKey = '__ndevBlockControllers__';
    if (!window[registryKey]) window[registryKey] = {};
    if (!window[registryKey][NS]) window[registryKey][NS] = new WeakMap();
    const controllers = window[registryKey][NS];

    // Tab 状态管理
    const tabStates = new Map();
    let lastUpdateTime = 0;
    const THROTTLE_INTERVAL = 100;

    function isMobile() {
      return window.innerWidth < 1024;
    }

    function safePause(video, resetProgress) {
      if (!video) return;
      try { video.pause(); } catch (e) {}
      if (resetProgress) {
        try { video.currentTime = 0; } catch (e) {}
      }
    }

    function safePlay(video) {
      if (!video) return;
      try {
        if (!video.muted) video.muted = true;
        var p = video.play();
        if (p && typeof p.catch === 'function') p.catch(function () {});
      } catch (e) {}
    }

    function updateProgressBar(tab, progress) {
      const state = tabStates.get(tab);
      if (!state) return;

      const { progressBar, progressRing } = state;
      const mobile = isMobile();

      // 指示器样式 - 垂直进度条
      if (progressBar) {
        progressBar.style.setProperty('--progress-bar-height', progress + '%');
      }

      // 手风琴样式 - 环形进度条（仅 PC 端）
      if (progressRing && !mobile) {
        const circumference = 113.1;
        const offset = circumference - (progress / 100) * circumference;
        progressRing.style.setProperty('--progress-ring-offset', offset);
      }
    }

    function resetProgressBar(tab) {
      const state = tabStates.get(tab);
      if (!state) return;

      const { progressBar, progressRing } = state;
      if (progressBar) progressBar.style.setProperty('--progress-bar-height', '0%');
      if (progressRing) progressRing.style.setProperty('--progress-ring-offset', '113.1');
    }

    function setupVideoListeners(tab, state) {
      const { video, mediaKind } = state;
      if (!video || mediaKind !== 'video' || state.isListening) return;

      const handleTimeUpdate = function () {
        if (!video.duration) return;
        const now = Date.now();
        if (now - lastUpdateTime < THROTTLE_INTERVAL) return;
        lastUpdateTime = now;

        const progress = (video.currentTime / video.duration) * 100;
        updateProgressBar(tab, progress);
      };

      const handleEnded = function () {
        const tabs = Array.from(tab.parentElement.querySelectorAll('ui-tab'));
        const currentIndex = tabs.indexOf(tab);
        const nextIndex = (currentIndex + 1) % tabs.length;
        tabs[nextIndex].click();
      };

      video.addEventListener('timeupdate', handleTimeUpdate);
      video.addEventListener('ended', handleEnded);

      state.isListening = true;
      state.timeUpdateHandler = handleTimeUpdate;
      state.endedHandler = handleEnded;
    }

    function removeVideoListeners(state) {
      if (!state.video || !state.isListening) return;
      if (state.timeUpdateHandler) state.video.removeEventListener('timeupdate', state.timeUpdateHandler);
      if (state.endedHandler) state.video.removeEventListener('ended', state.endedHandler);
      state.isListening = false;
    }

    function initOne(root) {
      if (!root) return;

      destroyOne(root);
      root.setAttribute(INIT_ATTR, '1');

      const tabs = root.querySelectorAll('ui-tab');
      if (tabs.length === 0) {
        controllers.set(root, { root: root, destroy: function () {} });
        return;
      }

      let activeTab = null;
      let autoplayTimer = null;
      let lastIsMobile = isMobile();

      // 初始化每个 Tab 的状态
      tabs.forEach(function (tab) {
        const mediaKind = tab.getAttribute('data-media-kind') || 'image';
        const targetId = tab.getAttribute('target');
        const panel = targetId ? document.getElementById(targetId) : null;
        const video = panel ? panel.querySelector('video') : null;
        const progressBar = tab.querySelector(PROGRESS_BAR_SELECTOR);
        const progressRing = tab.querySelector(PROGRESS_RING_SELECTOR);

        tabStates.set(tab, {
          mediaKind: mediaKind,
          video: video,
          panel: panel,
          progressBar: progressBar,
          progressRing: progressRing,
          isListening: false
        });

        if (tab.hasAttribute('open')) activeTab = tab;
      });

      function shouldAutoplay() {
        const autoplayPc = root.getAttribute('data-autoplay-pc') !== 'false';
        const autoplayMb = root.getAttribute('data-autoplay-mb') === 'true';
        return isMobile() ? autoplayMb : autoplayPc;
      }

      function shouldAnimateProgress() {
        const animatePc = root.getAttribute('data-progress-animation-pc') !== 'false';
        const animateMb = root.getAttribute('data-progress-animation-mb') === 'true';
        return isMobile() ? animateMb : animatePc;
      }

      function getDuration(tab) {
        const state = tabStates.get(tab);
        if (state && state.video && state.video.duration) {
          return state.video.duration * 1000;
        }
        const progress = tab.querySelector(PROGRESS_SELECTOR);
        if (!progress) return 5000;
        const style = getComputedStyle(progress);
        const val = style.getPropertyValue(CSS_VAR_DURATION).trim();
        return parseInt(val || '5000', 10);
      }

      function startAutoplay() {
        stopAutoplay();
        if (!activeTab) return;
        const state = tabStates.get(activeTab);
        if (state && state.mediaKind === 'video') return; // 视频模式不用定时器

        if (!shouldAutoplay()) return;
        const duration = getDuration(activeTab);
        autoplayTimer = setTimeout(function () {
          const tabsArray = Array.prototype.slice.call(tabs);
          const currentIndex = tabsArray.indexOf(activeTab);
          const nextIndex = (currentIndex + 1) % tabsArray.length;
          tabs[nextIndex].click();
        }, duration);
      }

      function stopAutoplay() {
        if (autoplayTimer) {
          clearTimeout(autoplayTimer);
          autoplayTimer = null;
        }
      }

      function resetAnimation(el) {
        el.style.animation = 'none';
        void el.offsetHeight;
        el.style.animation = '';
      }

      function handleShow(e) {
        const tab = e.target;
        const state = tabStates.get(tab);
        if (!state) return;

        // 清理上一个 Tab
        if (activeTab && activeTab !== tab) {
          const prevState = tabStates.get(activeTab);
          if (prevState) {
            if (prevState.video) {
              safePause(prevState.video, prevState.mediaKind === 'video' ? false : true);
            }
            resetProgressBar(activeTab);
          }
        }

        activeTab = tab;

        // 更新移动端描述
        const tabIndex = Array.prototype.indexOf.call(tabs, tab);
        const mobileDescs = root.querySelectorAll('.ndev-x30-sweep-tabs__mobile-desc');
        mobileDescs.forEach(function(desc, index) {
          desc.classList.toggle('active', index === tabIndex);
        });

        // 根据媒体类型决定行为
        if (state.mediaKind === 'video' && state.video) {
          stopAutoplay();
          setupVideoListeners(tab, state);
          safePlay(state.video);
        } else {
          // 图片模式
          if (shouldAnimateProgress()) {
            const progressRing = tab.querySelector(PROGRESS_RING_SELECTOR);
            if (progressRing) {
              progressRing.classList.remove('ndev-x30-sweep-tabs-accordion__progress-ring-circle--anim');
              void progressRing.offsetWidth;
              progressRing.classList.add('ndev-x30-sweep-tabs-accordion__progress-ring-circle--anim');
            }
            const progressBar = tab.querySelector(PROGRESS_BAR_SELECTOR);
            if (progressBar) resetAnimation(progressBar);
          }
          startAutoplay();
        }
      }

      function handleResize() {
        const currentIsMobile = isMobile();
        if (currentIsMobile !== lastIsMobile) {
          lastIsMobile = currentIsMobile;
          startAutoplay();
        }
      }

      let resizeTimer = null;
      function handleResizeThrottled() {
        if (resizeTimer) return;
        resizeTimer = setTimeout(function () {
          resizeTimer = null;
          handleResize();
        }, 100);
      }

      tabs.forEach(function (tab) {
        tab.addEventListener('show', handleShow);
      });

      window.addEventListener('resize', handleResizeThrottled);

      // 初始化
      if (activeTab) {
        const state = tabStates.get(activeTab);
        if (state && state.mediaKind === 'video' && state.video) {
          setupVideoListeners(activeTab, state);
          safePlay(state.video);
        } else {
          if (shouldAnimateProgress()) {
            const progressRing = activeTab.querySelector(PROGRESS_RING_SELECTOR);
            if (progressRing) {
              progressRing.classList.add('ndev-x30-sweep-tabs-accordion__progress-ring-circle--anim');
            }
          }
          startAutoplay();
        }
      }

      controllers.set(root, {
        root: root,
        destroy: function () {
          stopAutoplay();
          if (resizeTimer) clearTimeout(resizeTimer);
          tabs.forEach(function (tab) {
            tab.removeEventListener('show', handleShow);
            const state = tabStates.get(tab);
            if (state) removeVideoListeners(state);
          });
          window.removeEventListener('resize', handleResizeThrottled);
          tabStates.clear();
          try { root.removeAttribute(INIT_ATTR); } catch (e) {}
        },
      });
    }

    function destroyOne(root) {
      const controller = root ? controllers.get(root) : null;
      if (controller && typeof controller.destroy === 'function') controller.destroy();
      if (root) controllers.delete(root);
    }

    function initAll(scope) {
      const base = scope && scope.querySelectorAll ? scope : document;
      const list = base.querySelectorAll(ROOT_SELECTOR);
      for (var i = 0; i < list.length; i++) initOne(list[i]);
    }

    function destroyAll(scope) {
      const base = scope && scope.querySelectorAll ? scope : document;
      const list = base.querySelectorAll(ROOT_SELECTOR);
      for (var i = 0; i < list.length; i++) destroyOne(list[i]);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { initAll(); });
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', function (event) {
      initAll(event && event.target ? event.target : null);
    });

    document.addEventListener('shopify:section:unload', function (event) {
      destroyAll(event && event.target ? event.target : null);
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_ndev-x30-video-fps-item"] && !Shopify.designMode) return;
  try {
    (function () {
    'use strict';

    const NS = 'ndev-x30-video-fps-item';
    const ROOT_SELECTOR = '[data-ndev-x30-video-fps-item]';
    const FPS_ROOT_SELECTOR = '[data-ndev-sf]';
    const INIT_ATTR = 'data-' + NS + '-initialized';

    const registryKey = '__ndevBlockControllers__';
    if (!window[registryKey]) window[registryKey] = {};
    if (!window[registryKey][NS]) window[registryKey][NS] = new WeakMap();
    const controllers = window[registryKey][NS];

    function destroyOne(root) {
      const controller = root ? controllers.get(root) : null;
      if (controller && typeof controller.destroy === 'function') controller.destroy();
      if (root) controllers.delete(root);
    }

    function initOne(root) {
      if (!root) return;
      if (root.hasAttribute(INIT_ATTR)) return;

      destroyOne(root);
      root.setAttribute(INIT_ATTR, '1');

      const startTime = parseFloat(root.dataset.startTime) || 0;
      const endTime = parseFloat(root.dataset.endTime) || 0;

      if (startTime >= endTime) {
        controllers.set(root, { root: root, destroy: function () {} });
        return;
      }

      // 找到父级帧动画容器
      const fpsRoot = root.closest(FPS_ROOT_SELECTOR);
      if (!fpsRoot) {
        controllers.set(root, { root: root, destroy: function () {} });
        return;
      }

      let isVisible = false;

      function onProgress(event) {
        const detail = event.detail || {};
        const progress = detail.progress || 0;
        const duration = detail.duration || 0;

        if (duration <= 0) return;

        const currentTime = progress * duration;
        const shouldShow = currentTime >= startTime && currentTime <= endTime;

        if (shouldShow !== isVisible) {
          isVisible = shouldShow;
          root.classList.toggle('is-visible', shouldShow);
        }
      }

      fpsRoot.addEventListener('ndev-sf-progress', onProgress);

      controllers.set(root, {
        root: root,
        fpsRoot: fpsRoot,
        destroy: function () {
          fpsRoot.removeEventListener('ndev-sf-progress', onProgress);
          try { root.removeAttribute(INIT_ATTR); } catch (e) {}
          root.classList.remove('is-visible');
        }
      });
    }

    function initAll(scope) {
      var base = (scope && scope.querySelectorAll) ? scope : document;
      var list = base.querySelectorAll(ROOT_SELECTOR);
      for (var i = 0; i < list.length; i++) initOne(list[i]);
    }

    function destroyAll(scope) {
      var base = (scope && scope.querySelectorAll) ? scope : document;
      var list = base.querySelectorAll(ROOT_SELECTOR);
      for (var i = 0; i < list.length; i++) destroyOne(list[i]);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { initAll(); });
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', function (event) {
      initAll(event && event.target ? event.target : null);
    });

    document.addEventListener('shopify:section:unload', function (event) {
      destroyAll(event && event.target ? event.target : null);
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_ndev-x30-video-seek-item"] && !Shopify.designMode) return;
  try {
    (function () {
    'use strict';

    const NS = 'ndev-x30-video-seek-item';
    const ROOT_SELECTOR = '[data-ndev-x30-video-seek-item]';
    const VSEEK_ROOT_SELECTOR = '[data-ndev-video-seek]';
    const INIT_ATTR = 'data-' + NS + '-initialized';

    const registryKey = '__ndevBlockControllers__';
    if (!window[registryKey]) window[registryKey] = {};
    if (!window[registryKey][NS]) window[registryKey][NS] = new WeakMap();
    const controllers = window[registryKey][NS];

    function destroyOne(root) {
      const controller = root ? controllers.get(root) : null;
      if (controller && typeof controller.destroy === 'function') controller.destroy();
      if (root) controllers.delete(root);
    }

    function initOne(root) {
      if (!root) return;
      if (root.hasAttribute(INIT_ATTR)) return;

      destroyOne(root);
      root.setAttribute(INIT_ATTR, '1');

      const startTime = parseFloat(root.dataset.startTime) || 0;
      const endTime = parseFloat(root.dataset.endTime) || 0;

      if (startTime >= endTime) {
        controllers.set(root, { root: root, destroy: function () {} });
        return;
      }

      // 找到父级视频 seek 容器
      const vseekRoot = root.closest(VSEEK_ROOT_SELECTOR);
      if (!vseekRoot) {
        controllers.set(root, { root: root, destroy: function () {} });
        return;
      }

      let isVisible = false;

      function onProgress(event) {
        const detail = event.detail || {};
        const currentTime = detail.currentTime || 0;

        const shouldShow = currentTime >= startTime && currentTime <= endTime;

        if (shouldShow !== isVisible) {
          isVisible = shouldShow;
          root.classList.toggle('is-visible', shouldShow);
        }
      }

      vseekRoot.addEventListener('ndev-video-seek-progress', onProgress);

      controllers.set(root, {
        root: root,
        vseekRoot: vseekRoot,
        destroy: function () {
          vseekRoot.removeEventListener('ndev-video-seek-progress', onProgress);
          try { root.removeAttribute(INIT_ATTR); } catch (e) {}
          root.classList.remove('is-visible');
        }
      });
    }

    function initAll(scope) {
      var base = (scope && scope.querySelectorAll) ? scope : document;
      var list = base.querySelectorAll(ROOT_SELECTOR);
      for (var i = 0; i < list.length; i++) initOne(list[i]);
    }

    function destroyAll(scope) {
      var base = (scope && scope.querySelectorAll) ? scope : document;
      var list = base.querySelectorAll(ROOT_SELECTOR);
      for (var i = 0; i < list.length; i++) destroyOne(list[i]);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { initAll(); });
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', function (event) {
      initAll(event && event.target ? event.target : null);
    });

    document.addEventListener('shopify:section:unload', function (event) {
      destroyAll(event && event.target ? event.target : null);
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_product-buy-box-accessories"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('product-buy-box-accessories')) {
    class ProductBuyBoxAccessories extends BaseElement {
      init() {
        this._root = this.closest('product-buy-box');
        this._selected = {};

        this._onRootVariantChange = (e) => {
          if (e.detail.available) {
            this._restoreCards();
          } else {
            this._disableAllCards();
          }
        };

        this._onCheckboxChange = (e) => {
          const detail = e.detail || {};
          const target = detail.element || e.target;
          const card = target.closest('.product-buy-box-accessories__card');
          if (!card || !this.contains(card)) return;
          this._handleCheckbox(card, target.checked);
        };

        this._onQuantityChange = (e) => {
          const detail = e.detail || {};
          const el = detail.selector || e.target;
          const card = el.closest('.product-buy-box-accessories__card');
          if (!card || !this.contains(card)) return;
          if (detail.newQuantity !== undefined) {
            this._handleQuantity(card, detail.newQuantity);
          }
        };

        this._onCardClick = (e) => {
          const card = e.target.closest('.product-buy-box-accessories__card');
          if (!card || !this.contains(card)) return;
          if (card.classList.contains('is-disabled')) return;
          if (e.target.closest('.ndev-checkbox-wrapper')) return;
          if (e.target.closest('.ndev-quantity-selector')) return;

          const chk = card.querySelector('.ndev-checkbox-input');
          if (chk && !chk.disabled) {
            chk.checked = !chk.checked;
            chk.dispatchEvent(new Event('change', { bubbles: true }));
          }
        };

        this.addEventListener('click', this._onCardClick);
        this.addEventListener('checkbox:change', this._onCheckboxChange);
        this.addEventListener('quantity:change', this._onQuantityChange);
        this._root?.addEventListener('product-buy-box:variant-change', this._onRootVariantChange);

        const rootAvailable = this.getAttribute('data-root-variant-available');
        if (rootAvailable === 'false') {
          this._disableAllCards();
        }

        this._emitSourceChange();
      }

      dispose() {
        this.removeEventListener('click', this._onCardClick);
        this.removeEventListener('checkbox:change', this._onCheckboxChange);
        this.removeEventListener('quantity:change', this._onQuantityChange);
        this._root?.removeEventListener('product-buy-box:variant-change', this._onRootVariantChange);
      }

      _disableAllCards() {
        const cards = this.querySelectorAll('.product-buy-box-accessories__card');
        for (let i = 0; i < cards.length; i++) {
          const card = cards[i];
          card.classList.add('is-disabled');
          card.classList.remove('is-selected');
          const chk = card.querySelector('.ndev-checkbox-input');
          if (chk) {
            chk.checked = false;
            chk.disabled = true;
          }
          this._setCheckboxDisabled(card, true);
          this._setQuantityValue(card, 0);
          this._setQuantityDisabled(card, true);
        }
        this._selected = {};
        this._emitSourceChange();
      }

      _restoreCards() {
        const cards = this.querySelectorAll('.product-buy-box-accessories__card');
        for (let i = 0; i < cards.length; i++) {
          const card = cards[i];
          const cardAvailable = card.getAttribute('data-available');
          if (cardAvailable !== 'false') {
            card.classList.remove('is-disabled');
            const chk = card.querySelector('.ndev-checkbox-input');
            if (chk) chk.disabled = false;
            this._setCheckboxDisabled(card, false);
            this._setQuantityDisabled(card, false);
          } else {
            card.classList.add('is-disabled');
            card.classList.remove('is-selected');
            const chk = card.querySelector('.ndev-checkbox-input');
            if (chk) {
              chk.checked = false;
              chk.disabled = true;
            }
            this._setCheckboxDisabled(card, true);
            this._setQuantityValue(card, 0);
            this._setQuantityDisabled(card, true);
          }
        }
      }

      _setCheckboxDisabled(card, disabled) {
        const wrapper = card.querySelector('.ndev-checkbox-wrapper');
        if (wrapper) wrapper.classList.toggle('is-disabled', disabled);
      }

      _setQuantityDisabled(card, disabled) {
        const qty = card.querySelector('.ndev-quantity-selector');
        if (!qty) return;
        const input = qty.querySelector('.ndev-quantity-selector__input');
        const buttons = qty.querySelectorAll('.ndev-quantity-selector__btn');
        if (input) input.disabled = disabled;
        buttons.forEach((btn) => {
          btn.disabled = disabled || this._isQuantityButtonAtLimit(qty, btn);
        });
      }

      _setQuantityValue(card, value) {
        const qty = card.querySelector('.ndev-quantity-selector');
        if (!qty) return;
        const input = qty.querySelector('.ndev-quantity-selector__input');
        if (!input) return;
        input.value = value;
        input.defaultValue = value;
        this._syncQuantityButtons(qty);
      }

      _syncQuantityButtons(qty) {
        const buttons = qty.querySelectorAll('.ndev-quantity-selector__btn');
        buttons.forEach((btn) => {
          btn.disabled = this._isQuantityButtonAtLimit(qty, btn);
        });
      }

      _isQuantityButtonAtLimit(qty, btn) {
        const input = qty.querySelector('.ndev-quantity-selector__input');
        if (!input) return false;
        const value = parseInt(input.value, 10) || 0;
        const min = parseInt(qty.getAttribute('data-min'), 10);
        const max = parseInt(qty.getAttribute('data-max'), 10);
        if (btn.getAttribute('data-action') === 'decrease') {
          return !isNaN(min) && value <= min;
        }
        return !isNaN(max) && value >= max;
      }

      _handleCheckbox(card, checked) {
        if (card.classList.contains('is-disabled')) return;
        const variantId = card.getAttribute('data-variant-id');
        const price = parseInt(card.getAttribute('data-price')) || 0;

        if (checked) {
          const qtyInput = card.querySelector('.ndev-quantity-selector__input');
          let qty = qtyInput ? (parseInt(qtyInput.value) || 0) : 1;
          if (qty <= 0) {
            qty = 1;
            this._setQuantityValue(card, qty);
          }
          this._selected[variantId] = { variantId, price, quantity: qty };
          card.classList.add('is-selected');
        } else {
          this._setQuantityValue(card, 0);
          delete this._selected[variantId];
          card.classList.remove('is-selected');
        }
        this._emitSourceChange();
      }

      _handleQuantity(card, qty) {
        if (card.classList.contains('is-disabled')) return;
        const variantId = card.getAttribute('data-variant-id');
        const price = parseInt(card.getAttribute('data-price')) || 0;
        const chk = card.querySelector('.ndev-checkbox-input');

        if (qty > 0) {
          this._selected[variantId] = { variantId, price, quantity: qty };
          card.classList.add('is-selected');
          if (chk && !chk.checked) {
            chk.checked = true;
          }
        } else {
          delete this._selected[variantId];
          card.classList.remove('is-selected');
          if (chk && chk.checked) {
            chk.checked = false;
          }
        }
        this._emitSourceChange();
      }

      _emitSourceChange() {
        let total = 0;
        const items = [];
        const variantIds = Object.keys(this._selected);
        for (let i = 0; i < variantIds.length; i++) {
          const s = this._selected[variantIds[i]];
          total += s.price * s.quantity;
          items.push({
            variantId: s.variantId,
            quantity: s.quantity,
            properties: {}
          });
        }

        if (!this._root) return;
        this._root.dispatchEvent(new CustomEvent('product-buy-box:source-change', {
          bubbles: true,
          composed: true,
          detail: {
            source: 'accessories',
            total,
            items
          }
        }));
      }
    }
    customElements.define('product-buy-box-accessories', ProductBuyBoxAccessories);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_product-buy-box-benefits"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('product-buy-box-benefits')) {
    class ProductBuyBoxBenefits extends BaseElement {
      init() {
        this._root = this.closest('product-buy-box');
        this._onClick = (event) => this._handleTrigger(event);
        this._onKeydown = (event) => {
          if (event.key !== 'Enter' && event.key !== ' ') return;
          this._handleTrigger(event);
        };
        this.addEventListener('click', this._onClick);
        this.addEventListener('keydown', this._onKeydown);
      }

      dispose() {
        this.removeEventListener('click', this._onClick);
        this.removeEventListener('keydown', this._onKeydown);
        this._root = null;
      }

      _handleTrigger(event) {
        const trigger = event.target.closest('[data-benefit-key]');
        if (!trigger || !this.contains(trigger)) return;
        event.preventDefault();
        this._root?.dispatchEvent(new CustomEvent('product-buy-box:benefits-modal-open', {
          bubbles: true,
          composed: true,
          detail: {
            sourceId: this.id,
            benefitKey: trigger.getAttribute('data-benefit-key')
          }
        }));
      }
    }

    customElements.define('product-buy-box-benefits', ProductBuyBoxBenefits);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_product-buy-box-buy-buttons"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('product-buy-box-buy-buttons')) {
    class ProductBuyBoxBuyButtons extends BaseElement {
      init() {
        this._available = this.getAttribute('initial-available') === 'true';
        this._root = this.closest('product-buy-box');
        this._itemsEl = this.querySelector('.product-buy-box-buy-buttons__items');

        this._onVariantChange = (e) => {
          this._available = e.detail.available;
          this._renderState();
        };

        this._onKlaviyoClick = (e) => {
          const klaviyoEl = e.target.closest('[data-cta-klaviyo]');
          if (!klaviyoEl || this._available) return;
          e.preventDefault();
          e.stopPropagation();
          const eventName = klaviyoEl.getAttribute('data-cta-klaviyo-event');
          if (eventName && typeof $narwal !== 'undefined') {
            $narwal.emit(eventName);
          }
        };

        this._onCartCapture = (e) => {
          const button = e.target.closest('.ndev-button__btn[data-btn-purpose="cart"]');
          if (!button) return;

          const root = this._root;
          const cartItems = root && typeof root.getCartItems === 'function' ? root.getCartItems() : null;
          if (!cartItems || !cartItems.length) return;

          e.preventDefault();
          e.stopPropagation();

          const buyNow = button.getAttribute('data-cart-buy-now') === 'true';
          const addToCartBehavior = this.getAttribute('add-to-cart-behavior') || 'redirect_to_cart';
          const shouldRedirectToCart = !buyNow && addToCartBehavior === 'redirect_to_cart';
          const cartUrl = (window.Shopify?.routes?.root || '/') + 'cart';
          const onAddToCartSuccess = () => {
            if (shouldRedirectToCart) {
              window.location.href = cartUrl;
            }
          };

          if (typeof $360 !== 'undefined' && typeof $360.addToCartMultiple === 'function') {
            if (cartItems.length > 1) {
              $360.addToCartMultiple({
                products: cartItems,
                button
              }, onAddToCartSuccess, buyNow);
            } else if (typeof $360.addToCart === 'function') {
              const item = cartItems[0];
              $360.addToCart({
                qty: item.qty || 1,
                variantId: item.varId,
                properties: item.properties,
                sellingPlan: item.sellingPlan,
                button
              }, onAddToCartSuccess, e, buyNow);
            }
          }
        };

        this._root?.addEventListener('product-buy-box:variant-change', this._onVariantChange);
        this.addEventListener('click', this._onKlaviyoClick, true);
        this.addEventListener('click', this._onCartCapture, true);

        this._sortItems();
        this._renderState();
      }

      dispose() {
        this._root?.removeEventListener('product-buy-box:variant-change', this._onVariantChange);
        this.removeEventListener('click', this._onKlaviyoClick, true);
        this.removeEventListener('click', this._onCartCapture, true);
      }

      _sortItems() {
        if (!this._itemsEl) return;
        const items = [...this._itemsEl.children];
        items.sort(function (a, b) {
          const aOrder = parseInt(a.getAttribute('data-cta-order')) || 9999;
          const bOrder = parseInt(b.getAttribute('data-cta-order')) || 9999;
          return aOrder - bOrder;
        });
        items.forEach(function (item) {
          this._itemsEl.appendChild(item);
        }.bind(this));
      }

      _renderState() {
        if (!this._itemsEl) return;
        const wrappers = this._itemsEl.querySelectorAll('[data-cta-show-when]');
        wrappers.forEach(function (wrapper) {
          const showWhen = wrapper.getAttribute('data-cta-show-when');
          if (showWhen === 'available') {
            wrapper.hidden = !this._available;
          } else if (showWhen === 'unavailable') {
            wrapper.hidden = this._available;
          }
        }.bind(this));
      }
    }

    customElements.define('product-buy-box-buy-buttons', ProductBuyBoxBuyButtons);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_product-buy-box-description"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('product-buy-box-description')) {
    class ProductBuyBoxDescription extends BaseElement {
      init() {
        this._btn = this.querySelector('.product-buy-box__description-toggle');
        this._onClick = () => this._toggle();
        this._btn?.addEventListener('click', this._onClick);
      }

      dispose() {
        this._btn?.removeEventListener('click', this._onClick);
      }

      _toggle() {
        const isExpanded = this.classList.toggle('is-expanded');
        this._btn?.setAttribute('aria-expanded', isExpanded ? 'true' : 'false');
      }
    }
    customElements.define('product-buy-box-description', ProductBuyBoxDescription);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_product-buy-box-feature-item"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('product-buy-box-feature-item')) {
    class ProductBuyBoxFeatureItem extends BaseElement {
      init() {
        this._trigger = this.querySelector('.product-buy-box-feature-item__trigger');
        this._overlay = this.querySelector('.product-buy-box-feature-item__overlay');
        this._modal = this.querySelector('.product-buy-box-feature-item__modal');
        this._closeButton = this.querySelector('.product-buy-box-feature-item__close');

        this._onTriggerClick = () => this.open();
        this._onTriggerKeydown = (event) => {
          if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            this.open();
          }
        };
        this._onCloseClick = () => this.close();
        this._onKeydown = (event) => {
          if (!this.classList.contains('is-modal-open')) return;

          if (event.key === 'Escape') {
            event.preventDefault();
            this.close();
            return;
          }

          if (event.key !== 'Tab' || !this._modal) return;

          const focusable = this._focusableElements();
          if (!focusable.length) {
            event.preventDefault();
            this._modal.focus({ preventScroll: true });
            return;
          }

          const first = focusable[0];
          const last = focusable[focusable.length - 1];
          if (document.activeElement === this._modal) {
            event.preventDefault();
            (event.shiftKey ? last : first).focus({ preventScroll: true });
          } else if (event.shiftKey && document.activeElement === first) {
            event.preventDefault();
            last.focus({ preventScroll: true });
          } else if (!event.shiftKey && document.activeElement === last) {
            event.preventDefault();
            first.focus({ preventScroll: true });
          }
        };

        if (this._trigger && this._modal) {
          this._trigger.addEventListener('click', this._onTriggerClick);
          this._trigger.addEventListener('keydown', this._onTriggerKeydown);
        }
        if (this._overlay) this._overlay.addEventListener('click', this._onCloseClick);
        if (this._closeButton) this._closeButton.addEventListener('click', this._onCloseClick);
        document.addEventListener('keydown', this._onKeydown);
      }

      dispose() {
        if (this._trigger) {
          this._trigger.removeEventListener('click', this._onTriggerClick);
          this._trigger.removeEventListener('keydown', this._onTriggerKeydown);
        }
        if (this._overlay) this._overlay.removeEventListener('click', this._onCloseClick);
        if (this._closeButton) this._closeButton.removeEventListener('click', this._onCloseClick);
        document.removeEventListener('keydown', this._onKeydown);
      }

      open() {
        document.querySelectorAll('product-buy-box-feature-item.is-modal-open').forEach((item) => {
          if (item !== this && typeof item.close === 'function') item.close();
        });

        this._previousOverflow = document.body.style.overflow;
        document.body.style.overflow = 'hidden';
        this.classList.add('is-modal-open');
        if (this._modal) this._modal.focus({ preventScroll: true });
      }

      close() {
        this.classList.remove('is-modal-open');
        document.body.style.overflow = this._previousOverflow || '';
        if (this._trigger) this._trigger.focus({ preventScroll: true });
      }

      _focusableElements() {
        if (!this._modal) return [];
        return [...this._modal.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])')]
          .filter((el) => el.offsetParent !== null);
      }
    }

    customElements.define('product-buy-box-feature-item', ProductBuyBoxFeatureItem);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_product-buy-box-feature-list"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('product-buy-box-feature-list')) {
    class ProductBuyBoxFeatureList extends BaseElement {
      init() {
        this._items = Array.from(this.querySelectorAll('product-buy-box-feature-item'));
        this._actions = this.querySelector('.product-buy-box-feature-list__actions');
        this._moreButton = this.querySelector('.product-buy-box-feature-list__toggle--more');
        this._hideButton = this.querySelector('.product-buy-box-feature-list__toggle--hide');
        this._collapsedCount = parseInt(this.getAttribute('data-collapsed-count'), 10) || 4;

        this._onMoreClick = () => this.expand();
        this._onHideClick = () => this.collapse();

        if (this._moreButton) this._moreButton.addEventListener('click', this._onMoreClick);
        if (this._hideButton) this._hideButton.addEventListener('click', this._onHideClick);

        this._refresh();
      }

      dispose() {
        if (this._moreButton) this._moreButton.removeEventListener('click', this._onMoreClick);
        if (this._hideButton) this._hideButton.removeEventListener('click', this._onHideClick);
      }

      _refresh() {
        const shouldCollapse = this._items.length > this._collapsedCount;
        this.classList.toggle('is-collapsible', shouldCollapse);
        if (this._actions) this._actions.hidden = !shouldCollapse;

        this._items.forEach((item, index) => {
          item.classList.toggle('is-collapsed', shouldCollapse && index >= this._collapsedCount);
        });
      }

      expand() {
        this.classList.add('is-expanded');
        this._setExpandedState(true);
        if (this._hideButton) this._hideButton.hidden = false;
      }

      collapse() {
        this.classList.remove('is-expanded');
        this._setExpandedState(false);
        if (this._hideButton) this._hideButton.hidden = true;
        if (window.matchMedia('(max-width: 1023px)').matches) {
          const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          this.scrollIntoView({ behavior: reducedMotion ? 'auto' : 'smooth', block: 'nearest' });
        }
      }

      _setExpandedState(isExpanded) {
        const value = isExpanded ? 'true' : 'false';
        if (this._moreButton) this._moreButton.setAttribute('aria-expanded', value);
        if (this._hideButton) this._hideButton.setAttribute('aria-expanded', value);
      }
    }

    customElements.define('product-buy-box-feature-list', ProductBuyBoxFeatureList);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_product-buy-box-final-price"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('product-buy-box-final-price')) {
    class ProductBuyBoxFinalPrice extends BaseElement {
      init() {
        this._root = this.closest('product-buy-box');
        this._amountEl = this.querySelector('[data-price-amount]');
        this._onTotalUpdate = (e) => this._updatePrice(e.detail);
        this._root?.addEventListener('product-buy-box:total-update', this._onTotalUpdate);
      }

      dispose() {
        this._root?.removeEventListener('product-buy-box:total-update', this._onTotalUpdate);
      }

      _formatMoney(cents) {
        return $360.formatMoney(cents);
      }

      _updatePrice(detail) {
        if (!this._amountEl || !detail || detail.totalPrice == null) return;
        this._amountEl.textContent = this._formatMoney(detail.totalPrice);
      }
    }
    customElements.define('product-buy-box-final-price', ProductBuyBoxFinalPrice);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_product-buy-box-media-gallery"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('product-buy-box-media-gallery')) {
    class ProductBuyBoxMediaGallery extends BaseElement {
      init() {
        this._mapEl = this.querySelector('[data-product-buy-box-media-map]');
        this._mediaMap = this._mapEl ? JSON.parse(this._mapEl.textContent) : {};
        this._featuredMediaEl = this.querySelector('[data-product-buy-box-variant-featured-media]');
        this._featuredMediaByVariant = this._featuredMediaEl ? JSON.parse(this._featuredMediaEl.textContent) : {};
        this._variantGroupEl = this.querySelector('[data-product-buy-box-variant-group]');
        this._variantGroupByVariant = this._variantGroupEl ? JSON.parse(this._variantGroupEl.textContent) : {};
        this._swiperEls = [...this.querySelectorAll('.product-buy-box-media-gallery__swiper')];
        this._swiperEl = this.querySelector('.product-buy-box-media-gallery__swiper--image');
        this._mediaEls = [...this.querySelectorAll('[media-category]')];
        this._categoryButtons = [...this.querySelectorAll('[media-category-trigger]')];
        this._swipers = {};
        this._zoomLens = this.querySelector('.product-buy-box-media-gallery__zoom-lens');
        this._zoomLensArea = this.querySelector('.product-buy-box-media-gallery__zoom-lens-area');
        this._zoomImage = this.querySelector('.product-buy-box-media-gallery__zoom-image');
        this._zoomPanel = this.querySelector('.product-buy-box-media-gallery__zoom-panel');
        this._paginationEl = this.querySelector('.product-buy-box-media-gallery__pagination');
        this._counterEl = this.querySelector('[data-product-buy-box-media-counter]');
        this._counterCurrentEl = this.querySelector('[data-product-buy-box-media-counter-current]');
        this._counterTotalEl = this.querySelector('[data-product-buy-box-media-counter-total]');
        this._badgeEl = this.querySelector('[data-product-buy-box-media-badge]');
        this._badgeAmountEl = this.querySelector('[data-product-buy-box-media-badge-amount]');
        this._badgeLabelEl = this.querySelector('[data-product-buy-box-media-badge-label]');
        this._badgeOnlyFeaturedMedia = this._badgeEl?.dataset.onlyFeaturedMedia === 'true';
        this._activeBadgeText = this._badgeAmountEl?.textContent.trim() || '';
        this._hasGrouping = this.getAttribute('has-grouping') === 'true';
        this._groupOptionIndex = this._hasGrouping ? Number(this.getAttribute('group-option-index')) || 0 : -1;
        this._activeOptionValue = this._hasGrouping ? this.getAttribute('initial-option-value') || '' : '';
        if (this._hasGrouping) {
          this._swiperEl = this.querySelector(
            '.product-buy-box-media-gallery__swiper[data-category="' + this._activeOptionValue + ':image"]'
          );
          this._thumbs = [
            ...this.querySelectorAll(
              '.product-buy-box-media-gallery__pagination-track[data-option-value="' +
                this._activeOptionValue +
                '"] .product-buy-box-media-gallery__pagination-item'
            ),
          ];
          this._slides = this._swiperEl
            ? [...this._swiperEl.querySelectorAll('.product-buy-box-media-gallery__slide')]
            : [];
          this._setZoomLens(this._swiperEl);
        } else {
          this._thumbs = [...this.querySelectorAll('.product-buy-box-media-gallery__pagination-item')];
          this._slides = this._swiperEl
            ? [...this._swiperEl.querySelectorAll('.product-buy-box-media-gallery__slide')]
            : [];
        }
        this._initialSlide = Number(this.getAttribute('initial-slide')) || 0;
        this._initialVariantId = Number(this.getAttribute('initial-variant-id')) || null;
        this._activeVariantId = this._initialVariantId;
        this._activeCategory = this.getAttribute('active-category') || 'image';
        this._isDragging = false;
        this._hoverZoomEnabled = this.getAttribute('hover-zoom-enabled') === 'true';
        this._clickPreviewEnabled = this.getAttribute('click-preview-enabled') === 'true';
        this._autoDiscountBadge = this.getAttribute('auto-discount-badge') === 'true';
        this._canHoverZoom = window.matchMedia('(min-width: 1024px)');

        this._onVariantChange = (e) => {
          const detail = e.detail || {};
          this._activeVariantId = detail.variantId;
          this._setBadgeContent(detail);
          if (this._hasGrouping) {
            this._handleGroupedVariantChange(detail);
          } else {
            this._goToVariantImage(detail);
          }
        };
        this.closest('product-buy-box')?.addEventListener('product-buy-box:variant-change', this._onVariantChange);

        this._bindThumbnails();
        this._bindCategoryControls();
        this._bindNavControls();
        this._bindClickPreview();
        this._initPaginationDrag();
        this._initHoverZoom();
        this._initSwiper();
        this._syncCategoryAvailability();
      }

      dispose() {
        clearInterval(this._swiperWait);
        this.closest('product-buy-box')?.removeEventListener('product-buy-box:variant-change', this._onVariantChange);
        this._thumbs.forEach((thumb) => thumb.removeEventListener('click', thumb._pbbClick));
        if (this._paginationEl) {
          this._paginationEl.removeEventListener('mousedown', this._onPaginationDragStart);
          this._paginationEl.removeEventListener('mousemove', this._onPaginationDragMove);
          this._paginationEl.removeEventListener('mouseup', this._onPaginationDragEnd);
          this._paginationEl.removeEventListener('mouseleave', this._onPaginationDragEnd);
        }
        this._unbindImageSwiperEvents(this._swiperEl);
        this._categoryButtons.forEach((button) => button.removeEventListener('click', button._pbbClick));
        this.querySelector('.product-buy-box-media-gallery__nav--prev')?.removeEventListener(
          'click',
          this._onPrevClick
        );
        this.querySelector('.product-buy-box-media-gallery__nav--next')?.removeEventListener(
          'click',
          this._onNextClick
        );
        Object.values(this._swipers).forEach((swiper) => {
          swiper.destroy(true, true);
        });
        this._swipers = {};
        this._swiper = null;
        this._swiperEls.forEach((swiperEl) => {
          if (swiperEl?.swiper) swiperEl.swiper = null;
        });
      }

      _unbindImageSwiperEvents(el) {
        if (!el) return;
        el.removeEventListener('mouseenter', this._onZoomEnter);
        el.removeEventListener('mousemove', this._onZoomMove);
        el.removeEventListener('mouseleave', this._onZoomLeave);
        el.removeEventListener('pointerdown', this._onPreviewPointerDown);
        el.removeEventListener('click', this._onPreviewClick);
      }

      _setZoomLens(swiperEl) {
        this._zoomLens = swiperEl?.querySelector('.product-buy-box-media-gallery__zoom-lens') || null;
        this._zoomLensArea = swiperEl?.querySelector('.product-buy-box-media-gallery__zoom-lens-area') || null;
      }

      _bindCategoryControls() {
        this._categoryButtons.forEach((button) => {
          button._pbbClick = () => this._setActiveCategory(button.getAttribute('media-category-trigger'));
          button.addEventListener('click', button._pbbClick);
        });
      }

      _bindNavControls() {
        this.querySelector('.product-buy-box-media-gallery__nav--prev')?.addEventListener('click', this._onPrevClick);
        this.querySelector('.product-buy-box-media-gallery__nav--next')?.addEventListener('click', this._onNextClick);
      }

      _bindClickPreview() {
        if (!this._clickPreviewEnabled || !this._swiperEl) return;
        this.classList.add('product-buy-box-media-gallery--click-preview');
        this._swiperEl.addEventListener('pointerdown', this._onPreviewPointerDown);
        this._swiperEl.addEventListener('click', this._onPreviewClick);
      }

      _onPrevClick = () => {
        this._getSwiper()?.slidePrev();
      };

      _onNextClick = () => {
        this._getSwiper()?.slideNext();
      };

      _onPreviewPointerDown = (e) => {
        this._previewPointer = { x: e.clientX, y: e.clientY };
      };

      _onPreviewClick = (e) => {
        if (this._activeCategory !== 'image') return;
        if (e.target.closest('.product-buy-box-media-gallery__nav')) return;
        if (this._previewPointer) {
          const dx = Math.abs(e.clientX - this._previewPointer.x);
          const dy = Math.abs(e.clientY - this._previewPointer.y);
          if (dx > 5 || dy > 5) return;
        }

        const slide = this._getZoomSlide();
        const src = slide?.getAttribute('slide-src');
        if (!src) return;

        const img = slide.querySelector('.product-buy-box-media-gallery__slide-img');
        const wrapper = document.createElement('div');
        wrapper.className = 'product-buy-box-media-gallery__preview';

        const preview = document.createElement('img');
        preview.className = 'product-buy-box-media-gallery__preview-img';
        preview.src = src;
        preview.alt = img?.getAttribute('alt') || '';
        wrapper.appendChild(preview);

        this.closest('product-buy-box')?.dispatchEvent(
          new CustomEvent('product-buy-box:media-preview-open', {
            bubbles: true,
            composed: true,
            detail: {
              content: wrapper,
            },
          })
        );
      };

      _setActiveCategory(category) {
        if (!category || category === this._activeCategory) return;
        if (!this._hasMediaForCategory(category)) return;
        this._onZoomLeave();
        this._activeCategory = category;
        this.setAttribute('active-category', category);

        this._mediaEls.forEach((el) => {
          const catMatch = el.getAttribute('media-category') === category;
          if (this._hasGrouping && el.hasAttribute('data-option-value')) {
            el.classList.toggle(
              'is-active',
              catMatch && el.getAttribute('data-option-value') === this._activeOptionValue
            );
          } else {
            el.classList.toggle('is-active', catMatch);
          }
        });
        this._categoryButtons.forEach((button) => {
          button.classList.toggle('is-active', button.getAttribute('media-category-trigger') === category);
        });

        requestAnimationFrame(() => {
          const swiper = this._getSwiper(category);
          swiper?.update();
          this._syncCounter(swiper?.activeIndex || 0);
        });
      }

      _hasMediaForCategory(category) {
        if (!this._hasGrouping || category === 'model') {
          return this._mediaEls.some((el) => el.getAttribute('media-category') === category);
        }
        return this._mediaEls.some(
          (el) =>
            el.getAttribute('media-category') === category &&
            el.getAttribute('data-option-value') === this._activeOptionValue
        );
      }

      _syncCategoryAvailability() {
        this._categoryButtons.forEach((button) => {
          const category = button.getAttribute('media-category-trigger');
          button.hidden = !this._hasMediaForCategory(category);
        });
        if (!this._hasMediaForCategory(this._activeCategory)) {
          this._setActiveCategory('image');
        }
      }

      _syncActiveCategoryFromMediaId(mediaId) {
        if (!mediaId) return;
        const slide = this._slides.find((item) => String(item.getAttribute('media-id')) === String(mediaId));
        if (slide) {
          this._setActiveCategory('image');
        }
      }

      _initSwiper() {
        if (!this._swiperEls.length) return;

        if (window.Swiper) {
          this._createSwipers();
          return;
        }

        let tries = 0;
        this._swiperWait = setInterval(() => {
          tries += 1;
          if (window.Swiper) {
            clearInterval(this._swiperWait);
            this._createSwipers();
          } else if (tries > 100) {
            clearInterval(this._swiperWait);
          }
        }, 50);
      }

      _createSwipers() {
        this._swiperEls.forEach((swiperEl) => this._createSwiper(swiperEl));
        if (this._hasGrouping) {
          this._swiper = this._swipers[this._activeOptionValue + ':image'] || null;
        } else {
          this._swiper = this._swipers.image || null;
        }
      }

      _createSwiper(swiperEl) {
        if (!swiperEl) return;
        const category = swiperEl.getAttribute('data-category') || 'image';
        if (this._swipers[category]) return;
        if (swiperEl.swiper) {
          this._adoptSwiper(swiperEl, category);
          return;
        }
        const root = this;
        const mediaCategory = category.split(':').pop();

        this._swipers[category] = new window.Swiper(swiperEl, {
          slidesPerView: 1,
          spaceBetween: 1,
          initialSlide: mediaCategory === 'image' ? this._initialSlide : 0,
          observer: true,
          observeParents: true,
          noSwipingClass: 'swiper-no-swiping',
          on: {
            init(swiper) {
              if (
                mediaCategory === 'image' &&
                (!root._hasGrouping || category === root._activeOptionValue + ':image')
              ) {
                root._syncPagination(swiper.activeIndex);
                root._updateBadges();
              }
            },
            slideChange(swiper) {
              if (
                mediaCategory === 'image' &&
                (!root._hasGrouping || category === root._activeOptionValue + ':image')
              ) {
                root._syncPagination(swiper.activeIndex);
                root._updateBadges();
                root._syncZoomToActiveSlide();
                if (root.classList.contains('is-zooming') && root._lastZoomEvent) {
                  root._onZoomMove(root._lastZoomEvent);
                }
              }
            },
          },
        });
      }

      _adoptSwiper(swiperEl, category) {
        const swiper = swiperEl?.swiper;
        if (!swiper) return;

        this._swipers[category] = swiper;
        const root = this;
        const mediaCategory = category.split(':').pop();
        const isActiveImage = () =>
          mediaCategory === 'image' && (!root._hasGrouping || category === root._activeOptionValue + ':image');

        swiper.on('slideChange', () => {
          if (!isActiveImage()) return;
          root._syncPagination(swiper.activeIndex);
          root._updateBadges();
          root._syncZoomToActiveSlide();
          if (root.classList.contains('is-zooming') && root._lastZoomEvent) {
            root._onZoomMove(root._lastZoomEvent);
          }
        });

        if (isActiveImage()) {
          this._syncPagination(swiper.activeIndex);
          this._updateBadges();
        }
      }

      _getSwiper(category = this._activeCategory) {
        if (this._hasGrouping) {
          return this._swipers[this._activeOptionValue + ':' + category] || null;
        }
        return this._swipers[category] || null;
      }

      _goToSlide(index) {
        this._onZoomLeave();
        this._setActiveCategory('image');
        const swiper = this._getSwiper('image');
        if (swiper) {
          swiper.slideTo(index);
          this._syncPagination(index);
          this._updateBadges();
          return;
        }
        this._syncPagination(index);
        this._updateBadges();
      }

      _getFeaturedSlideIndex(mediaId) {
        if (!mediaId) return -1;
        return this._slides.findIndex((slide) =>
          String(slide.getAttribute('media-id')) === String(mediaId) ||
          String(slide.getAttribute('featured-media-id')) === String(mediaId)
        );
      }

      _updateBadges() {
        if (!this._badgeEl) return;

        const swiper = this._getSwiper('image');
        const slideIndex = swiper != null ? swiper.activeIndex : this._initialSlide;
        const activeVariantId = String(this._activeVariantId || this._initialVariantId || '');
        const hasBadge = Boolean(this._activeBadgeText);
        let show = hasBadge && this._activeCategory === 'image';

        if (show && this._badgeOnlyFeaturedMedia) {
          const featuredMediaId = this._getFeaturedMediaIdForVariant(activeVariantId);
          const featuredIndex = this._getFeaturedSlideIndex(featuredMediaId);
          show = featuredIndex >= 0 && slideIndex === featuredIndex;
        }

        this._badgeEl.hidden = !show;
      }

      _setBadgeContent(detail) {
        const badge = this._getBadge(detail);
        const amount = badge.amount || '';
        const label = badge.label || '';

        this._activeBadgeText = amount;

        if (this._badgeAmountEl) this._badgeAmountEl.textContent = amount;
        if (this._badgeLabelEl) {
          this._badgeLabelEl.textContent = label;
          this._badgeLabelEl.hidden = !label;
        }
        this._updateBadges();
      }

      _getBadge(detail) {
        const text =
          detail.imageTag ||
          detail.image_tag ||
          (this._autoDiscountBadge ? detail.autoDiscountTag || detail.auto_discount_tag : '') ||
          "";
        return this._parseBadgeText(text);
      }

      _parseBadgeText(text) {
        const raw = String(text || "").trim();

        return {
          amount: raw,
          label: raw ? "de réduction" : ""
        };
      }

      _getFeaturedMediaIdForVariant(variantId) {
        return this._featuredMediaByVariant?.[String(variantId)] || null;
      }

      _bindThumbnails() {
        this._thumbs.forEach((thumb) => {
          thumb._pbbClick = (e) => {
            if (this._isDragging) {
              e.preventDefault();
              e.stopPropagation();
              return;
            }
            this._goToSlide(Number(thumb.getAttribute('thumb-index')));
          };
          thumb.addEventListener('click', thumb._pbbClick);
        });
      }

      _syncPagination(index) {
        this._thumbs.forEach((thumb, i) => {
          thumb.classList.toggle('is-active', i === index);
        });
        this._syncCounter(index);
        this._scrollPaginationToCenter(index);
      }

      _syncCounter(index) {
        if (!this._counterEl) return;

        const show = this._activeCategory === 'image' && this._slides.length > 0;
        this._counterEl.hidden = !show;
        if (!show) return;

        const safeIndex = Math.max(0, Math.min(Number(index) || 0, this._slides.length - 1));
        if (this._counterCurrentEl) this._counterCurrentEl.textContent = String(safeIndex + 1);
        if (this._counterTotalEl) this._counterTotalEl.textContent = String(this._slides.length);
      }

      _scrollPaginationToCenter(index) {
        const container = this._paginationEl;
        const item = this._thumbs[index];
        if (!container || !item) return;

        const containerRect = container.getBoundingClientRect();
        const itemRect = item.getBoundingClientRect();
        const offset = itemRect.left - containerRect.left - (containerRect.width - itemRect.width) / 2;
        const nextLeft = container.scrollLeft + offset;
        const maxLeft = container.scrollWidth - container.clientWidth;
        const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

        container.scrollTo({
          left: Math.max(0, Math.min(nextLeft, maxLeft)),
          behavior: reducedMotion ? 'auto' : 'smooth',
        });
      }

      _initPaginationDrag() {
        if (!this._paginationEl) return;
        this._paginationEl.addEventListener('mousedown', this._onPaginationDragStart);
        this._paginationEl.addEventListener('mousemove', this._onPaginationDragMove);
        this._paginationEl.addEventListener('mouseup', this._onPaginationDragEnd);
        this._paginationEl.addEventListener('mouseleave', this._onPaginationDragEnd);
      }

      _initHoverZoom() {
        if (!this._hoverZoomEnabled || !this._swiperEl) return;
        this._swiperEl.addEventListener('mouseenter', this._onZoomEnter);
        this._swiperEl.addEventListener('mousemove', this._onZoomMove);
        this._swiperEl.addEventListener('mouseleave', this._onZoomLeave);
      }

      _getZoomSlide() {
        const swiper = this._getSwiper('image');
        if (swiper && this._slides[swiper.activeIndex]) {
          return this._slides[swiper.activeIndex];
        }

        return (
          this.querySelector('.swiper-slide-active.product-buy-box-media-gallery__slide') ||
          this._slides[this._initialSlide] ||
          this._slides[0] ||
          null
        );
      }

      _onZoomEnter = (e) => {
        if (!this._canHoverZoom.matches) return;
        if (!this._syncZoomToActiveSlide()) return;
        this.classList.add('is-zooming');
        this._onZoomMove(e);
      };

      _syncZoomToActiveSlide() {
        if (!this._hoverZoomEnabled || !this._zoomImage) return false;
        const slide = this._getZoomSlide();
        if (!slide) return false;

        const src = slide.getAttribute('slide-src');
        if (!src) return false;
        if (this._zoomSource !== src) {
          this._zoomSource = src;
          this._zoomImage.style.backgroundImage = `url(${src})`;
        }
        return true;
      }

      _onZoomMove = (e) => {
        if (!this.classList.contains('is-zooming')) return;
        if (!this._zoomLensArea || !this._zoomImage || !this._zoomPanel) return;
        this._lastZoomEvent = e;

        const rect = this._swiperEl.getBoundingClientRect();
        const panelSize = this._zoomPanel.offsetWidth || window.innerWidth * 0.38;
        const lensSize = Math.min(300, rect.width, rect.height);
        const scale = panelSize / lensSize;
        const lensX = Math.max(0, Math.min(e.clientX - rect.left - lensSize / 2, rect.width - lensSize));
        const lensY = Math.max(0, Math.min(e.clientY - rect.top - lensSize / 2, rect.height - lensSize));

        this._zoomLensArea.style.width = `${lensSize}px`;
        this._zoomLensArea.style.height = `${lensSize}px`;
        this._zoomLensArea.style.transform = `translate3d(${lensX}px, ${lensY}px, 0)`;
        this._zoomImage.style.width = `${rect.width * scale}px`;
        this._zoomImage.style.height = `${rect.height * scale}px`;
        this._zoomImage.style.transform = `translate3d(${-lensX * scale}px, ${-lensY * scale}px, 0)`;
      };

      _onZoomLeave = () => {
        if (this._zoomLensArea) this._zoomLensArea.style.transform = '';
        if (this._zoomImage) {
          this._zoomImage.style.backgroundImage = '';
          this._zoomImage.style.transform = '';
          this._zoomImage.style.width = '';
          this._zoomImage.style.height = '';
        }
        this._zoomSource = null;
        this._lastZoomEvent = null;
        this.classList.remove('is-zooming');
      };

      _onPaginationDragStart = (e) => {
        this._startX = e.pageX - this._paginationEl.offsetLeft;
        this._scrollLeftStart = this._paginationEl.scrollLeft;
        this._isDragging = false;
        this._isMouseDown = true;
        this._paginationEl.classList.add('is-dragging');
      };

      _onPaginationDragMove = (e) => {
        if (!this._isMouseDown) return;
        e.preventDefault();
        const x = e.pageX - this._paginationEl.offsetLeft;
        const walk = (x - this._startX) * 1.5;
        if (Math.abs(walk) > 5) {
          this._isDragging = true;
        }
        this._paginationEl.scrollLeft = this._scrollLeftStart - walk;
      };

      _onPaginationDragEnd = () => {
        this._isMouseDown = false;
        if (this._paginationEl) {
          this._paginationEl.classList.remove('is-dragging');
        }
        setTimeout(() => {
          this._isDragging = false;
        }, 50);
      };

      _normalizeSrc(src) {
        if (!src) return '';
        return src.split('?')[0];
      }

      _findSlideIndexBySrc(src) {
        const target = this._normalizeSrc(src);
        return this._slides.findIndex((slide) => this._normalizeSrc(slide.getAttribute('slide-src')) === target);
      }

      _goToVariantImage(detail) {
        const src = detail.image || this._mediaMap[String(detail.variantId)];
        let index = -1;

        if (src) {
          index = this._findSlideIndexBySrc(src);
        }

        if (index < 0 && detail.variantId) {
          const mediaId = this._getFeaturedMediaIdForVariant(detail.variantId);
          index = this._getFeaturedSlideIndex(mediaId);
        }

        if (index < 0) return;

        const swiper = this._getSwiper('image');
        if (swiper && swiper.activeIndex === index) {
          this._updateBadges();
          return;
        }

        this._goToSlide(index);
      }

      _handleGroupedVariantChange(detail) {
        const variantId = String(detail.variantId);
        const optionHandle = this._getVariantOptionValue(variantId);
        if (!optionHandle) {
          this._goToVariantImage(detail);
          return;
        }
        if (optionHandle !== this._activeOptionValue) {
          this._switchOptionGroup(optionHandle);
        }
        this._goToVariantImage(detail);
      }

      _getVariantOptionValue(variantId) {
        return this._variantGroupByVariant?.[String(variantId)] || null;
      }

      _switchOptionGroup(optionHandle) {
        this._onZoomLeave();
        const prevOptionValue = this._activeOptionValue;

        if (prevOptionValue) {
          const prevSwiperEl = this.querySelector(
            '.product-buy-box-media-gallery__swiper[data-category="' + prevOptionValue + ':image"]'
          );
          this._unbindImageSwiperEvents(prevSwiperEl);
        }

        this._activeOptionValue = optionHandle;
        this._syncCategoryAvailability();

        this._mediaEls.forEach((el) => {
          if (el.hasAttribute('data-option-value')) {
            const match = el.getAttribute('data-option-value') === optionHandle;
            el.classList.toggle('is-active', match && el.getAttribute('media-category') === this._activeCategory);
          }
        });

        if (this._paginationEl) {
          this._paginationEl
            .querySelectorAll('.product-buy-box-media-gallery__pagination-track[data-option-value]')
            .forEach((track) => {
              const match = track.getAttribute('data-option-value') === optionHandle;
              track.toggleAttribute('hidden', !match);
              track.classList.toggle('is-active', match);
            });
        }

        this._swiperEl = this.querySelector(
          '.product-buy-box-media-gallery__swiper[data-category="' + optionHandle + ':image"]'
        );
        this._slides = this._swiperEl
          ? [...this._swiperEl.querySelectorAll('.product-buy-box-media-gallery__slide')]
          : [];
        this._swiper = this._swipers[optionHandle + ':image'] || null;
        this._setZoomLens(this._swiperEl);

        this._thumbs.forEach((thumb) => thumb.removeEventListener('click', thumb._pbbClick));
        this._thumbs = [
          ...this.querySelectorAll(
            '.product-buy-box-media-gallery__pagination-track[data-option-value="' +
              optionHandle +
              '"] .product-buy-box-media-gallery__pagination-item'
          ),
        ];
        this._bindThumbnails();

        if (this._hoverZoomEnabled && this._swiperEl) {
          this._swiperEl.addEventListener('mouseenter', this._onZoomEnter);
          this._swiperEl.addEventListener('mousemove', this._onZoomMove);
          this._swiperEl.addEventListener('mouseleave', this._onZoomLeave);
        }
        if (this._clickPreviewEnabled && this._swiperEl) {
          this._swiperEl.addEventListener('pointerdown', this._onPreviewPointerDown);
          this._swiperEl.addEventListener('click', this._onPreviewClick);
        }

        requestAnimationFrame(() => {
          const swiper = this._getSwiper('image');
          if (swiper) {
            swiper.update();
            this._syncPagination(swiper.activeIndex);
          } else {
            this._syncCounter(0);
          }
        });
      }
    }

    customElements.define('product-buy-box-media-gallery', ProductBuyBoxMediaGallery);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_product-buy-box-promo"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('product-buy-box-promo')) {
    class ProductBuyBoxPromo extends BaseElement {
      init() {
        this._root = this.closest('product-buy-box');

        const jsonEl = this.querySelector('[data-promo-variants]');
        this._variantMap = jsonEl ? JSON.parse(jsonEl.textContent) : {};

        this._discountArea = this.querySelector('[data-promo-discount]');
        this._amountWrap = this.querySelector('[data-promo-amount-wrap]');
        this._amountEl = this.querySelector('[data-promo-amount]');
        this._codeEl = this.querySelector('[data-promo-code]');
        this._countdownEl = this.querySelector('ndev-countdown-timer');

        this._baseCode = this.getAttribute('base-code') || '';
        this._baseAmount = this.getAttribute('base-amount') || '';
        this._baseCountdown = this._countdownEl?.getAttribute('base-end-date') || '';
        this._baseRemaining = Number(this._countdownEl?.getAttribute('base-remaining') || 0);
        this._hydratedAt = performance.now();
        this._copySuccess = this.getAttribute('copy-success') || '';
        this._helpLabel = this.getAttribute('help-label') || '';

        this._copyBtn = this.querySelector('[data-promo-copy]');
        this._helpBtn = this.querySelector('[data-promo-help]');
        this._copyResetTimer = null;

        this._onVariantChange = (e) => this._handleVariantChange(e.detail);
        this._onCopyClick = () => this._handleCopy();
        this._onHilfeClick = () => this._handleHilfe();

        this._root?.addEventListener('product-buy-box:variant-change', this._onVariantChange);
        if (!this._root) {
          document.addEventListener('product-buy-box:variant-change', this._onVariantChange);
        }
        this._copyBtn?.addEventListener('click', this._onCopyClick);
        this._helpBtn?.addEventListener('click', this._onHilfeClick);

        this._applyInitial();
      }

      dispose() {
        this._clearCopyResetTimer();
        this._root?.removeEventListener('product-buy-box:variant-change', this._onVariantChange);
        document.removeEventListener('product-buy-box:variant-change', this._onVariantChange);
        this._copyBtn?.removeEventListener('click', this._onCopyClick);
        this._helpBtn?.removeEventListener('click', this._onHilfeClick);
        this._root = null;
      }

      _applyInitial() {
        const initialId = this._root?.getAttribute('data-ndev-product-variant-id');
        const info = initialId ? this._variantMap[initialId] : null;
        this._renderPromo(info);
      }

      _handleVariantChange(detail) {
        this._clearCopyResetTimer();
        const variantId = detail && detail.variantId ? String(detail.variantId) : '';
        const info = variantId ? this._variantMap[variantId] : null;
        this._renderPromo(info);
      }

      _renderPromo(info) {
        if (info?.hide) {
          this._setPromoHidden(true);
          this._setCountdown('');
          return;
        }

        const amount = info ? (info.discountText || '') : this._baseAmount;
        const code = info ? (info.code || '') : this._baseCode;
        const remaining = info ? (info.countdown ? Number(info.remaining || 0) : 0) : this._baseRemaining;
        const countdown = info ? (info.countdown || '') : this._baseCountdown;
        const hasPromoContent = Boolean(amount && code);

        this._setPromoHidden(!hasPromoContent);
        if (!hasPromoContent) {
          this._setCountdown('');
          return;
        }

        this._updateDiscount({ discountText: amount, code });
        this._setCountdown(countdown, remaining);
      }

      _setPromoHidden(hidden) {
        this.classList.toggle('pbb-promo__hidden', hidden);
        this.setAttribute('aria-hidden', hidden ? 'true' : 'false');
      }

      _setDiscountHidden(hidden) {
        if (!this._discountArea) return;
        this._discountArea.classList.toggle('pbb-promo__hidden', hidden);
        this._discountArea.setAttribute('aria-hidden', hidden ? 'true' : 'false');
      }

      _updateDiscount(info) {
        if (!this._discountArea) return;
        const hasAmount = Boolean(info.discountText);
        const hasCode = Boolean(info.code);
        this._setDiscountHidden(!hasAmount || !hasCode);

        if (this._amountEl && hasAmount) {
          this._amountEl.textContent = info.discountText;
          this._amountWrap?.removeAttribute('data-empty');
        } else if (this._amountEl) {
          this._amountEl.textContent = '';
          this._amountWrap?.setAttribute('data-empty', '');
        }
        if (this._codeEl) {
          this._codeEl.textContent = info.code || '';
        }
      }

      _setCountdown(endDate, remaining) {
        if (!this._countdownEl) return;
        const value = endDate || '';
        const adjustedRemaining = this._getAdjustedRemaining(remaining);
        this._countdownEl.setAttribute('end-date', value);
        this._countdownEl.setAttribute('remaining', String(adjustedRemaining));
      }

      _getAdjustedRemaining(remaining) {
        const seconds = Number(remaining || 0);
        if (!seconds) return 0;
        const elapsed = Math.floor((performance.now() - this._hydratedAt) / 1000);
        return Math.max(0, seconds - elapsed);
      }

      async _handleCopy() {
        const code = this._codeEl ? this._codeEl.textContent.trim() : '';
        if (!code) return;

        let copied = false;

        try {
          if (navigator.clipboard && navigator.clipboard.writeText) {
            await navigator.clipboard.writeText(code);
            copied = true;
          }
        } catch (_) {}

        if (!copied) {
          const input = document.createElement('INPUT');
          input.style.cssText = 'position: fixed; top: -100000px;';
          document.body.appendChild(input);
          input.value = code;
          input.focus();
          input.select();
          const range = document.createRange();
          range.selectNodeContents(input);
          const sel = window.getSelection();
          sel.removeAllRanges();
          sel.addRange(range);
          input.setSelectionRange(0, 9999);
          copied = document.execCommand('copy');
          input.blur();
          document.body.removeChild(input);
        }

        if (copied && this._codeEl && this._copySuccess) {
          this._clearCopyResetTimer();
          const original = this._codeEl.textContent;
          this._codeEl.textContent = this._copySuccess;
          this._copyResetTimer = setTimeout(() => {
            if (this._codeEl) this._codeEl.textContent = original;
            this._copyResetTimer = null;
          }, 2000);
        }
      }

      _clearCopyResetTimer() {
        if (!this._copyResetTimer) return;
        clearTimeout(this._copyResetTimer);
        this._copyResetTimer = null;
      }

      _handleHilfe() {
        if (!this._root) return;
        this._root.dispatchEvent(new CustomEvent('product-buy-box:promo-help-open', {
          bubbles: true
        }));
      }
    }

    customElements.define('product-buy-box-promo', ProductBuyBoxPromo);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_product-buy-box-retailer-links"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('product-buy-box-retailer-links')) {
    class ProductBuyBoxRetailerLinks extends BaseElement {
      init() {
        this._trigger = this.querySelector('.product-buy-box-retailer-links__trigger');
        this._list = this.querySelector('.product-buy-box-retailer-links__list');
        this._arrow = this.querySelector('.product-buy-box-retailer-links__arrow');
        this._onClick = () => this._toggle();
        this._trigger?.addEventListener('click', this._onClick);
      }

      dispose() {
        this._trigger?.removeEventListener('click', this._onClick);
      }

      _toggle() {
        if (!this._trigger || !this._list) return;
        const isExpanded = this._trigger.getAttribute('aria-expanded') === 'true';
        this._trigger.setAttribute('aria-expanded', String(!isExpanded));
        this._list.classList.toggle('is-hidden', isExpanded);
        this._arrow?.classList.toggle('product-buy-box-retailer-links__arrow--rotated', !isExpanded);
      }
    }

    customElements.define('product-buy-box-retailer-links', ProductBuyBoxRetailerLinks);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_product-buy-box-sales"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('product-buy-box-sales')) {
    class ProductBuyBoxSales extends BaseElement {
      init() {
        this._countdownEl = this.querySelector('[data-sales-countdown]');
        this._copyEl = this.querySelector('[data-sales-copy]');
        this._dayEl = this.querySelector('[data-sales-day]');
        this._hourEl = this.querySelector('[data-sales-hour]');
        this._minuteEl = this.querySelector('[data-sales-minute]');
        this._secondEl = this.querySelector('[data-sales-second]');
        this._timer = null;

        this._onCopyClick = () => this._copyDiscount();
        this._copyEl?.addEventListener('click', this._onCopyClick);
        this._startCountdown();
      }

      dispose() {
        this._copyEl?.removeEventListener('click', this._onCopyClick);
        if (this._timer) clearInterval(this._timer);
      }

      _startCountdown() {
        if (!this._countdownEl) return;
        const endDate = this.getAttribute('end-date');
        if (!endDate) return;

        const date = new Date(endDate);
        if (Number.isNaN(date.getTime())) return;

        const timeZone = Number(this.getAttribute('time-zone')) || 0;
        const nowSeconds = Number(this.getAttribute('now-seconds')) || Math.floor(Date.now() / 1000);
        date.setUTCSeconds(date.getUTCSeconds() + 60 * 60 * timeZone);
        this._remaining = date.getTime() - nowSeconds * 1000;
        if (this._remaining <= 0) {
          this._remaining = 0;
          this._formatTime();
          return;
        }

        this._formatTime();
        this._timer = setInterval(() => {
          this._remaining = Math.max(0, this._remaining - 1000);
          this._formatTime();
          if (this._remaining <= 0 && this._timer) {
            clearInterval(this._timer);
            this._timer = null;
          }
        }, 1000);
      }

      _formatTime() {
        const second = 1000;
        const minute = 60 * second;
        const hour = 60 * minute;
        const day = 24 * hour;
        const days = Math.max(0, Math.floor(this._remaining / day));
        const hours = Math.max(0, Math.floor((this._remaining % day) / hour));
        const minutes = Math.max(0, Math.floor((this._remaining % hour) / minute));
        const seconds = Math.max(0, Math.floor((this._remaining % minute) / second));
        if (this._dayEl) this._dayEl.value = this._doubleDigit(days);
        if (this._hourEl) this._hourEl.value = this._doubleDigit(hours);
        if (this._minuteEl) this._minuteEl.value = this._doubleDigit(minutes);
        if (this._secondEl) this._secondEl.value = this._doubleDigit(seconds);
      }

      _doubleDigit(value) {
        return value < 10 ? `0${value}` : String(value);
      }

      _copyDiscount() {
        if (!this._copyEl || this._copyEl.classList.contains('is-disabled')) return;
        const text = this.getAttribute('discount-code') || '';
        if (!text) return;
        const copySuccess = this.getAttribute('copy-success') || '';
        const copyText = this.getAttribute('copy-text') || '';

        const input = document.createElement('input');
        input.style.cssText = 'position: fixed; top: -100000px;';
        document.body.appendChild(input);
        input.value = text;
        input.focus();
        input.select();
        document.execCommand('copy');
        input.blur();
        document.body.removeChild(input);

        this._copyEl.textContent = copySuccess;
        this._copyEl.classList.add('is-disabled');
        setTimeout(() => {
          this._copyEl.textContent = copyText;
          this._copyEl.classList.remove('is-disabled');
        }, 2000);
      }
    }

    customElements.define('product-buy-box-sales', ProductBuyBoxSales);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_product-buy-box-sticky-bar"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('product-buy-box-sticky-total')) {
    class ProductBuyBoxStickyTotal extends BaseElement {
      init() {
        this._root = this.closest('product-buy-box');
        this._amountEl = this.querySelector('[data-price-amount]');
        this._compareAmountEl = this.querySelector('[data-compare-price-amount]');
        this._comparePriceDisplay = this.getAttribute('compare-price-display') || 'auto';
        this._initialVariantId = this.getAttribute('initial-variant-id');
        this._initialComparePrice = Number(this.getAttribute('initial-compare-price')) || 0;
        this._onTotalUpdate = (e) => {
          const detail = e.detail || {};
          const amount = this._amountEl;
          const compareAmount = this._compareAmountEl;

          if (amount && detail.totalPrice != null) {
            amount.textContent = $360.formatMoney(detail.totalPrice);
          }

          if (!compareAmount || detail.compareAtPrice == null) return;

          const forceHiddenClass = 'product-buy-box-sticky-bar__compare-amount--force-hidden';
          const hiddenClass = 'product-buy-box-sticky-bar__compare-amount--hidden';
          let comparePrice = Number(detail.compareAtPrice) || 0;
          if (comparePrice <= 0 && String(detail.variantId) === this._initialVariantId && this._initialComparePrice > 0) {
            comparePrice = this._initialComparePrice;
          }
          const price = Number(detail.variantPrice ?? detail.totalPrice) || 0;
          const shouldHide = compareAmount.classList.contains(forceHiddenClass) || (
            this._comparePriceDisplay === 'auto' && (comparePrice <= 0 || comparePrice <= price)
          );

          compareAmount.textContent = $360.formatMoney(comparePrice);
          compareAmount.classList.toggle(hiddenClass, shouldHide && !compareAmount.classList.contains(forceHiddenClass));
          compareAmount.hidden = shouldHide;
          compareAmount.setAttribute('aria-hidden', shouldHide ? 'true' : 'false');
        };
        this._root?.addEventListener('product-buy-box:total-update', this._onTotalUpdate);
      }

      dispose() {
        this._root?.removeEventListener('product-buy-box:total-update', this._onTotalUpdate);
      }
    }
    customElements.define('product-buy-box-sticky-total', ProductBuyBoxStickyTotal);
  }

  if (!customElements.get('product-buy-box-sticky-bar')) {
    class ProductBuyBoxStickyBar extends BaseElement {
      init() {
        this._root = this.closest('product-buy-box');
        this._stockLabel = this.querySelector('[data-stock-label]');
        this._onTotalUpdate = (e) => this._renderState(e.detail || {});
        this._root?.addEventListener('product-buy-box:total-update', this._onTotalUpdate);
      }

      dispose() {
        this._root?.removeEventListener('product-buy-box:total-update', this._onTotalUpdate);
      }

      _renderState(detail) {
        if (!this._stockLabel || detail.available == null) return;
        this._stockLabel.classList.toggle('is-hidden', Boolean(detail.available));
      }
    }

    customElements.define('product-buy-box-sticky-bar', ProductBuyBoxStickyBar);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_product-buy-box-subscription"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('product-buy-box-subscription-tracker')) {
    class ProductBuyBoxSubscriptionTracker extends HTMLElement {
      connectedCallback() {
        if (this._bound) return;
        this._bound = true;
        const eventName = this.getAttribute('data-submit-event');
        const popupEvent = this.getAttribute('data-popup-event');
        if (!eventName || typeof $narwal === 'undefined') return;

        $narwal.bind(eventName, (opt) => {
          if (typeof $narwal.report === 'function') {
            $narwal.report({
              event: 'subscribe',
              params: {
                page: 'self',
                method: 'email',
                btn: opt && opt.button
              }
            });
          }
          if (popupEvent) $narwal.emit(popupEvent);
        });
      }
    }

    customElements.define('product-buy-box-subscription-tracker', ProductBuyBoxSubscriptionTracker);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_product-buy-box-variant-picker"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('product-buy-box-variant-picker')) {
    class ProductBuyBoxVariantPicker extends BaseElement {
      init() {
        this._root = this.closest('product-buy-box');
        this._listEl = this._root?.querySelector('[data-variants]');
        if (!this._listEl) return;

        this._variants = JSON.parse(this._listEl.textContent);
        this._variantById = new Map(this._variants.map((variant) => [String(variant.id), variant]));
        this._selected = {};
        this._optionNames = this._getOptionNames();
        this._aggregateOptionName = this.getAttribute('aggregate-option-name') || '';
        const aggIdxRaw = parseInt(this.getAttribute('agg-idx'));
        this._aggregateOptionIndex = isNaN(aggIdxRaw) ? -1 : aggIdxRaw;
        const cardIdxRaw = parseInt(this.getAttribute('card-group-idx'));
        this._cardGroupIdx = isNaN(cardIdxRaw) ? -1 : cardIdxRaw;
        this._autoSelectFirst = this.getAttribute('auto-select-first-available') === 'true';
        this._autoDiscountBadge = this.getAttribute('auto-discount-badge') === 'true';

        this._statusEl = this.querySelector('[data-variant-picker-status]');
        this._cards = [...this.querySelectorAll('[data-pbb-card]')];
        this._defaultSelectionsByAggregate = this._buildDefaultSelectionsByAggregate();
        this._userSelectionsByAggregate = {};

        this._hydrate();
        this._applyOptionStyles();
        this._syncFromURL();
        this.addEventListener('keydown', this._onKeyDown);
      }

      dispose() {
        this.removeEventListener('keydown', this._onKeyDown);
        this.querySelectorAll('[data-pbb-btn]').forEach((btn) => {
          btn.removeEventListener('click', btn._pbbClick);
        });
        this.querySelectorAll('[data-pbb-card]').forEach((card) => {
          card.removeEventListener('click', card._cardClick);
          card.removeEventListener('keydown', card._cardKeyDown);
        });
      }

      _hydrate() {
        this.querySelectorAll('[data-pbb-btn]').forEach((btn) => {
          const idx = Number(btn.getAttribute('option-index'));
          const val = btn.getAttribute('option-value');
          btn._pbbClick = () => this._selectOption(idx, val);
          btn.addEventListener('click', btn._pbbClick);
        });

        this._cards.forEach((card) => {
          const hasNote = card.hasAttribute('data-has-note');

          card._cardClick = (e) => {
            if (e.target.closest('.variant-tag')) return;
            this._selectCard(card);
          };
          card.addEventListener('click', card._cardClick);

          card._cardKeyDown = (e) => {
            if (e.key === 'Enter' || e.key === ' ') {
              e.preventDefault();
              e.stopPropagation();
              card._cardClick(e);
            }
          };
          card.addEventListener('keydown', card._cardKeyDown);
        });
      }

      _applyOptionStyles() {
        const styleData = {};
        this.querySelectorAll('[data-product-buy-box-option-style]').forEach((el) => {
          try {
            const data = JSON.parse(el.textContent);
            const optionValue = el.dataset.optionValue || data.optionValue;
            if (!optionValue) return;

            styleData[optionValue] = {
              ...data,
              optionValue,
              label: el.dataset.optionLabel || data.label,
              swatchColor: el.dataset.optionSwatchColor || data.swatchColor
            };
          } catch (e) {}
        });

        if (Object.keys(styleData).length === 0) return;

        this.querySelectorAll('[data-pbb-btn][option-index="' + this._aggregateOptionIndex + '"]').forEach((btn) => {
          const val = btn.getAttribute('option-value');
          const style = styleData[val];
          if (!style) return;

          if (style.image) {
            let img = btn.querySelector('.product-buy-box-option-card__cover-img');
            if (img) {
              img.src = style.image;
              img.removeAttribute('srcset');
            } else {
              const cover = btn.querySelector('.product-buy-box-option-card__cover');
              if (cover) {
                img = document.createElement('img');
                img.className = 'product-buy-box-option-card__cover-img';
                img.src = style.image;
                img.alt = '';
                img.loading = 'lazy';
                cover.innerHTML = '';
                cover.appendChild(img);
              }
            }
          }

          if (style.label) {
            const labelEl = btn.querySelector('.product-buy-box-option-card__label-text');
            if (labelEl) labelEl.textContent = style.label;
            btn.setAttribute('aria-label', (this._aggregateOptionName || '') + ': ' + style.label);
          }

          if (style.swatchColor) {
            btn.style.setProperty('--pbb-swatch-color', style.swatchColor);
          }

          const badge = btn.querySelector('.product-buy-box-option-card__badge');
          if (badge && style.badgeText) {
            badge.textContent = style.badgeText;
            badge.hidden = false;
          }
        });

        this._cards.forEach((card) => {
          const val = card.getAttribute('data-option-value');
          const style = styleData[val];
          if (!style) return;

          if (style.label) {
            const title = card.querySelector('.title');
            if (title) title.textContent = style.label;
          }

          if (style.badgeText) {
            let badge = card.querySelector('[data-card-badge]');
            if (!badge) {
              badge = document.createElement('div');
              badge.className = 'variant-tag';
              badge.setAttribute('data-card-badge', '');
              const content = card.querySelector('.variant-content');
              if (content) content.appendChild(badge);
            }
            badge.textContent = style.badgeText;
            badge.setAttribute('data-card-badge-override', 'true');
          }
        });
      }

      _getOptionNames() {
        const names = [];
        for (let i = 1; this.getAttribute('option-' + i); i++) {
          names.push(this.getAttribute('option-' + i));
        }
        return names;
      }

      _hasAggregate() {
        return this._aggregateOptionIndex >= 0;
      }

      _findVariant(selected) {
        const sel = selected || this._selected;
        const hasFullSelection = this._optionNames.every((_, i) => sel[i] != null);

        if (hasFullSelection) {
          const exact = this._variants.find((v) =>
            v.options.every((opt, i) => opt === sel[i])
          );
          if (exact) return exact;
        }

        const partial = this._variants.filter((v) =>
          v.options.every((opt, i) => sel[i] == null || opt === sel[i])
        );
        return partial.find((v) => v.available) || partial[0] || null;
      }

      _findVariantById(id) {
        if (id == null) return null;
        return this._variantById.get(String(id)) || null;
      }

      _buildDefaultSelectionsByAggregate() {
        if (!this._hasAggregate()) return {};

        return this._variants.reduce((memo, variant) => {
          const aggVal = variant.options[this._aggregateOptionIndex];
          if (aggVal == null || memo[aggVal]) return memo;
          memo[aggVal] = this._getSelectionFromVariant(variant);
          return memo;
        }, {});
      }

      _getSelectionFromVariant(variant) {
        return variant.options.reduce((selected, opt, i) => {
          selected[i] = opt;
          return selected;
        }, {});
      }

      _rememberCurrentSelection() {
        if (!this._hasAggregate()) return;
        const aggVal = this._selected[this._aggregateOptionIndex];
        if (aggVal == null) return;
        this._userSelectionsByAggregate[aggVal] = { ...this._selected };
      }

      _isOptionValueAvailable(optionIndex, value) {
        const trial = { ...this._selected, [optionIndex]: value };
        return this._variants.some((v) =>
          v.available && v.options.every((opt, i) => trial[i] == null || opt === trial[i])
        );
      }

      _isOptionValuePresent(optionIndex, value) {
        const trial = { ...this._selected, [optionIndex]: value };
        return this._variants.some((v) =>
          v.options.every((opt, i) => trial[i] == null || opt === trial[i])
        );
      }

      _getVisibleVariants() {
        if (!this._hasAggregate()) return this._variants;
        const aggVal = this._selected[this._aggregateOptionIndex];
        if (aggVal == null) return this._variants;
        return this._variants.filter((v) => v.options[this._aggregateOptionIndex] === aggVal);
      }

      _normalizeAfterAggregateChange() {
        const visible = this._getVisibleVariants();
        const fallback = this._autoSelectFirst
          ? visible.find((v) => v.available) || visible[0]
          : visible[0];
        if (!fallback) return;

        const aggVal = this._selected[this._aggregateOptionIndex];
        const remembered = this._autoSelectFirst
          ? null
          : this._userSelectionsByAggregate[aggVal] || this._defaultSelectionsByAggregate[aggVal];
        const nextSelection = remembered || this._getSelectionFromVariant(fallback);

        this._selected = { ...nextSelection, [this._aggregateOptionIndex]: aggVal };

        if (!this._findVariant(this._selected)) {
          this._selected = this._getSelectionFromVariant(fallback);
        }
      }

      _findVariantForCard(card) {
        return this._findVariantById(card.getAttribute('data-variant-id'));
      }

      _syncCards() {
        if (!this._cards.length) return;

        this._cards.forEach((card) => {
          const variant = this._findVariantForCard(card);
          if (!variant) {
            card.classList.add('is-hidden');
            return;
          }

          for (let i = 0; i < this._optionNames.length; i++) {
            if (i === this._cardGroupIdx) continue;
            if (this._selected[i] != null && variant.options[i] !== this._selected[i]) {
              card.classList.add('is-hidden');
              return;
            }
          }

          card.classList.remove('is-hidden');
          this._syncCardBadge(card, variant);
        });
      }

      _syncCardBadge(card, variant) {
        let badge = card.querySelector('[data-card-badge]');
        if (badge && badge.getAttribute('data-card-badge-override') === 'true') return;

        const text = variant.tag || (this._autoDiscountBadge ? variant.auto_discount_tag : '') || '';
        if (!text) {
          if (badge) badge.remove();
          return;
        }

        if (!badge) {
          badge = document.createElement('div');
          badge.className = 'variant-tag';
          badge.setAttribute('data-card-badge', '');
          const content = card.querySelector('.variant-content');
          if (content) content.appendChild(badge);
        }
        badge.textContent = text;
      }

      _selectOption(index, value) {
        const isAggregate = this._hasAggregate() && index === this._aggregateOptionIndex;
        const prevAggVal = this._selected[this._aggregateOptionIndex];

        this._selected[index] = value;

        if (!isAggregate) {
          this._rememberCurrentSelection();
        }

        const optionName = this._optionNames[index] || '';

        this._dispatchOptionChange(index, optionName, value, isAggregate);

        if (isAggregate && prevAggVal !== value) {
          this._normalizeAfterAggregateChange();
          this._syncCards();
        }

        if (!isAggregate && index !== this._cardGroupIdx) {
          this._syncCards();
        }

        const variant = this._findVariant();
        this._updateUI(variant);
        this._dispatchListChange(variant);
        this._dispatchVariantChange(variant);

        if (variant) {
          this._updateURL(variant.id);
          this._announceStatus(variant);
        }
      }

      _selectCard(card) {
        const variant = this._findVariantForCard(card);
        if (!variant) return;

        this._selected = this._getSelectionFromVariant(variant);
        this._rememberCurrentSelection();

        const optionName = this._optionNames[this._cardGroupIdx] || '';
        const value = variant.options[this._cardGroupIdx];
        this._dispatchOptionChange(this._cardGroupIdx, optionName, value, false);
        this._syncCards();
        this._updateUI(variant);
        this._dispatchListChange(variant);
        this._dispatchVariantChange(variant);
        this._updateURL(variant.id);
        this._announceStatus(variant);
      }

      _updateUI(variant) {
        this.querySelectorAll('[data-pbb-btn]').forEach((btn) => {
          const i = Number(btn.getAttribute('option-index'));
          const val = btn.getAttribute('option-value');
          const isAgg = this._hasAggregate() && i === this._aggregateOptionIndex;
          const selected = this._selected[i] === val;
          const present = isAgg || this._isOptionValuePresent(i, val);
          const available = this._isOptionValueAvailable(i, val);

          btn.classList.toggle('is-selected', selected);
          btn.setAttribute('aria-checked', selected ? 'true' : 'false');

          if (!present) {
            btn.hidden = true;
            btn.disabled = true;
            btn.tabIndex = -1;
            return;
          }
          btn.hidden = false;
          btn.disabled = isAgg ? false : !available;
          btn.tabIndex = -1;
        });

        this._cards.forEach((card) => {
          const cardVariant = this._findVariantForCard(card);
          const selected = variant && cardVariant && String(variant.id) === String(cardVariant.id);
          const hasNote = card.hasAttribute('data-has-note');

          card.classList.toggle('is-unavailable', Boolean(cardVariant && !cardVariant.available));
          card.classList.toggle('is-selected', selected);
          card.classList.toggle('is-on', selected && hasNote);
          card.setAttribute('aria-checked', selected ? 'true' : 'false');
          card.tabIndex = selected && !card.classList.contains('is-hidden') ? 0 : -1;
        });

        this.querySelectorAll('.product-buy-box-option-group').forEach((group) => {
          const items = [...group.querySelectorAll('[data-pbb-btn]:not([hidden]), [data-pbb-card]:not(.is-hidden)')]
            .filter((item) => !item.disabled && item.getAttribute('aria-disabled') !== 'true');
          if (!items.length) return;

          const checked = items.find((item) => item.getAttribute('aria-checked') === 'true');
          (checked || items[0]).tabIndex = 0;
        });
      }

      _updateURL(variantId) {
        const url = new URL(window.location.href);
        url.searchParams.set('variant', variantId);
        window.history.replaceState(null, '', url);
      }

      _syncFromURL() {
        const id = new URL(window.location.href).searchParams.get('variant');
        const variant = id
          ? this._findVariantById(id)
          : this._variants.find((v) => v.available) || this._variants[0];

        if (!variant) return;

        variant.options.forEach((opt, i) => {
          this._selected[i] = opt;
        });
        this._syncCards();
        this._updateUI(variant);
        this._dispatchListChange(variant);
        this._dispatchVariantChange(variant);
      }

      _announceStatus(variant) {
        if (!this._statusEl) return;
        const optionLabels = variant.options.filter(Boolean).join(', ');
        const stock = variant.available ? 'En stock.' : 'Épuisé.';
        this._statusEl.textContent = 'Sélectionné ' + optionLabels + '. ' + stock;
      }

      _dispatchOptionChange(index, optionName, value, isAggregate) {
        const detail = {
          optionIndex: index,
          optionName: optionName,
          value: value,
          role: isAggregate ? 'aggregate' : 'regular',
          selectedOptions: this._optionNames.map((_, i) => this._selected[i] || null),
          optionMap: {},
          matchedVariantId: null,
          source: 'variant-picker'
        };

        this._optionNames.forEach((n, i) => {
          if (this._selected[i] != null) detail.optionMap[n] = this._selected[i];
        });

        const variant = this._findVariant();
        if (variant) detail.matchedVariantId = variant.id;

        this._root.dispatchEvent(new CustomEvent('product-buy-box:option-change', {
          bubbles: true, composed: true, detail: detail
        }));
      }

      _dispatchListChange(variant) {
        const visible = this._getVisibleVariants();
        const available = visible.filter((v) => v.available);
        const detail = {
          aggregateOptionName: this._hasAggregate() ? this._optionNames[this._aggregateOptionIndex] : null,
          aggregateOptionIndex: this._aggregateOptionIndex,
          aggregateValue: this._hasAggregate() ? this._selected[this._aggregateOptionIndex] : null,
          selectedOptions: this._optionNames.map((_, i) => this._selected[i] || null),
          visibleVariantIds: visible.map((v) => v.id),
          availableVariantIds: available.map((v) => v.id),
          activeVariantId: variant ? variant.id : null,
          source: 'variant-picker'
        };

        this._root.dispatchEvent(new CustomEvent('product-buy-box:variant-list-change', {
          bubbles: true, composed: true, detail: detail
        }));
      }

      _dispatchVariantChange(variant) {
        if (!variant) return;

        const optionMap = {};
        this._optionNames.forEach((n, i) => {
          if (variant.options[i] != null) optionMap[n] = variant.options[i];
        });

        this._root.dispatchEvent(new CustomEvent('product-buy-box:variant-change', {
          bubbles: true, composed: true,
          detail: {
            variantId: variant.id,
            available: variant.available,
            price: variant.price,
            compareAtPrice: variant.compare_at_price || 0,
            image: variant.featured_image,
            featuredMediaId: variant.featured_media_id,
            title: variant.title,
            tag: variant.tag || null,
            imageTag: variant.image_tag || null,
            autoDiscountTag: variant.auto_discount_tag || null,
            options: variant.options,
            optionMap: optionMap,
            sku: variant.sku,
            source: 'variant-picker'
          }
        }));
      }

      _onKeyDown = (e) => {
        const target = e.target.closest('[data-pbb-btn], [data-pbb-card]');
        if (!target) return;

        const group = target.closest('.product-buy-box-option-group');
        if (!group) return;

        const buttons = [...group.querySelectorAll('[data-pbb-btn]:not([hidden]), [data-pbb-card]:not(.is-hidden)')]
          .filter((item) => !item.disabled && item.getAttribute('aria-disabled') !== 'true');
        const idx = buttons.indexOf(target);
        if (idx < 0) return;

        let nextIdx = idx;

        switch (e.key) {
          case 'ArrowLeft':
          case 'ArrowUp':
            e.preventDefault();
            nextIdx = idx > 0 ? idx - 1 : buttons.length - 1;
            break;
          case 'ArrowRight':
          case 'ArrowDown':
            e.preventDefault();
            nextIdx = idx < buttons.length - 1 ? idx + 1 : 0;
            break;
          case 'Enter':
          case ' ':
            e.preventDefault();
            target.click();
            return;
          default:
            return;
        }

        const next = buttons[nextIdx];
        if (next && !next.disabled) {
          next.click();
          next.focus();
        }
      }
    }
    customElements.define('product-buy-box-variant-picker', ProductBuyBoxVariantPicker);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_product-buy-box-warranty-modal"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('product-buy-box-modal')) {
    class ProductBuyBoxModal extends BaseElement {
      init() {
        this._modalRole = this.getAttribute('modal-role') || '';
        this._dialog = this.querySelector('[role="dialog"]');
        this._onOpen = (e) => this._handleOpen(e.detail || {});
        this._onCloseClick = (e) => {
          if (e.target.matches('[data-modal-close]')) this.close();
        };
        this._onKeyDown = (e) => this._handleKeyDown(e);
        this.closest('product-buy-box')?.addEventListener('product-buy-box:modal-open', this._onOpen);
        this.addEventListener('click', this._onCloseClick);
      }

      dispose() {
        this.closest('product-buy-box')?.removeEventListener('product-buy-box:modal-open', this._onOpen);
        this.removeEventListener('click', this._onCloseClick);
        document.removeEventListener('keydown', this._onKeyDown);
      }

      _handleOpen(detail) {
        if (detail.modalRole !== this._modalRole) return;
        this._previousActiveElement = document.activeElement instanceof HTMLElement ? document.activeElement : null;
        this.hidden = false;
        document.addEventListener('keydown', this._onKeyDown);
        this._focusFirstElement();
      }

      close() {
        if (this.hidden) return;
        this.hidden = true;
        document.removeEventListener('keydown', this._onKeyDown);
        if (this._previousActiveElement?.isConnected) this._previousActiveElement.focus();
        this._previousActiveElement = null;
      }

      _focusableElements() {
        return [...this.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])')]
          .filter((el) => el.offsetParent !== null);
      }

      _focusFirstElement() {
        this._dialog?.focus();
      }

      _handleKeyDown(e) {
        if (this.hidden) return;
        if (e.key === 'Escape') {
          e.preventDefault();
          this.close();
          return;
        }
        if (e.key !== 'Tab') return;

        const focusable = this._focusableElements();
        if (!focusable.length) {
          e.preventDefault();
          this._dialog?.focus();
          return;
        }

        const first = focusable[0];
        const last = focusable[focusable.length - 1];
        if (document.activeElement === this._dialog) {
          e.preventDefault();
          (e.shiftKey ? last : first).focus();
        } else if (e.shiftKey && document.activeElement === first) {
          e.preventDefault();
          last.focus();
        } else if (!e.shiftKey && document.activeElement === last) {
          e.preventDefault();
          first.focus();
        }
      }
    }
    customElements.define('product-buy-box-modal', ProductBuyBoxModal);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_product-buy-box-warranty"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('product-buy-box-warranty')) {
    class ProductBuyBoxWarranty extends BaseElement {
      init() {
        this._root = this.closest('product-buy-box');
        this._selected = null;
        this._helpBtn = this.querySelector('[data-warranty-help]');
        this._collapsedCount = parseInt(this.getAttribute('collapsed-count'), 10) || 1;
        this._toggleRow = this.querySelector('[data-warranty-toggle-row]');
        this._toggleBtn = this.querySelector('[data-warranty-toggle]');
        this._toggleText = this.querySelector('[data-warranty-toggle-text]');

        this._onRootVariantChange = (e) => {
          if (e.detail.available) {
            this._restoreCards();
          } else {
            this._disableAllCards();
          }
        };

        this._onCheckboxChange = (e) => {
          const detail = e.detail || {};
          const target = detail.element || e.target;
          const card = target.closest('.product-buy-box-warranty__card');
          if (!card || !this.contains(card)) return;
          this._handleCheckbox(card, target.checked);
        };

        this._onCardClick = (e) => {
          const card = e.target.closest('.product-buy-box-warranty__card');
          if (!card || !this.contains(card)) return;
          if (card.classList.contains('is-disabled')) return;
          if (e.target.closest('.ndev-checkbox-wrapper, [data-warranty-toggle-row]')) return;

          const chk = card.querySelector('.ndev-checkbox-input');
          if (chk && !chk.disabled) {
            chk.checked = !chk.checked;
            chk.dispatchEvent(new Event('change', { bubbles: true }));
          }
        };
        this._onHelpClick = () => this._handleHelp();
        this._onToggleClick = (e) => this._toggleExpanded(e);

        this.addEventListener('click', this._onCardClick);
        this.addEventListener('checkbox:change', this._onCheckboxChange);
        this._root?.addEventListener('product-buy-box:variant-change', this._onRootVariantChange);
        this._helpBtn?.addEventListener('click', this._onHelpClick);
        this._toggleBtn?.addEventListener('click', this._onToggleClick);

        const rootAvailable = this.getAttribute('data-root-variant-available');
        if (rootAvailable === 'false') {
          this._disableAllCards();
        }

        this._initMoreToggle();
        this._emitSourceChange();
      }

      dispose() {
        this.removeEventListener('click', this._onCardClick);
        this.removeEventListener('checkbox:change', this._onCheckboxChange);
        this._root?.removeEventListener('product-buy-box:variant-change', this._onRootVariantChange);
        this._helpBtn?.removeEventListener('click', this._onHelpClick);
        this._toggleBtn?.removeEventListener('click', this._onToggleClick);
      }

      _initMoreToggle() {
        if (!this._toggleBtn) return;
        const cards = this.querySelectorAll('[data-warranty-card]');
        cards.forEach((card, index) => {
          card.classList.toggle('is-collapsed-hidden', index >= this._collapsedCount);
        });
        const shouldShowToggle = cards.length > this._collapsedCount;
        if (this._toggleRow) this._toggleRow.hidden = !shouldShowToggle;
        this.classList.remove('is-expanded');
        this._syncToggleState();
      }

      _toggleExpanded(event) {
        event?.preventDefault();
        event?.stopPropagation();
        this.classList.toggle('is-expanded');
        this._syncToggleState();
      }

      _syncToggleState() {
        if (!this._toggleBtn) return;
        const expanded = this.classList.contains('is-expanded');
        this._toggleBtn.setAttribute('aria-expanded', String(expanded));
        this._moveToggleRow(expanded);
        if (!this._toggleText) return;
        this._toggleText.textContent = expanded
          ? (this._toggleBtn.getAttribute('data-less-text') || 'Voir moins')
          : (this._toggleBtn.getAttribute('data-more-text') || 'Voir plus');
      }

      _moveToggleRow(expanded) {
        if (!this._toggleRow || this._toggleRow.hidden) return;
        const cards = Array.from(this.querySelectorAll('[data-warranty-card]'));
        if (!cards.length) return;

        cards.forEach((card) => card.classList.remove('is-last-visible'));
        const visibleCards = expanded ? cards : cards.slice(0, this._collapsedCount);
        const targetCard = visibleCards[visibleCards.length - 1] || cards[0];
        targetCard.classList.add('is-last-visible');
        targetCard.appendChild(this._toggleRow);
      }

      _disableAllCards() {
        this.classList.add('is-root-disabled');
        this.classList.remove('has-selected');
        const cards = this.querySelectorAll('.product-buy-box-warranty__card');
        cards.forEach((card) => {
          card.classList.add('is-disabled');
          card.classList.remove('is-selected');
          const chk = card.querySelector('.ndev-checkbox-input');
          if (chk) {
            chk.checked = false;
            chk.disabled = true;
          }
          this._setCheckboxDisabled(card, true);
        });
        this._selected = null;
        this._emitSourceChange();
      }

      _restoreCards() {
        this.classList.remove('is-root-disabled');
        const cards = this.querySelectorAll('.product-buy-box-warranty__card');
        cards.forEach((card) => {
          const cardAvailable = card.getAttribute('data-available');
          if (cardAvailable !== 'false') {
            card.classList.remove('is-disabled');
            const chk = card.querySelector('.ndev-checkbox-input');
            if (chk) chk.disabled = false;
            this._setCheckboxDisabled(card, false);
          } else {
            card.classList.add('is-disabled');
            card.classList.remove('is-selected');
            const chk = card.querySelector('.ndev-checkbox-input');
            if (chk) {
              chk.checked = false;
              chk.disabled = true;
            }
            this._setCheckboxDisabled(card, true);
          }
        });
      }

      _setCheckboxDisabled(card, disabled) {
        const wrapper = card.querySelector('.ndev-checkbox-wrapper');
        if (wrapper) wrapper.classList.toggle('is-disabled', disabled);
      }

      _handleCheckbox(card, checked) {
        if (card.classList.contains('is-disabled')) return;

        const cards = this.querySelectorAll('.product-buy-box-warranty__card');
        cards.forEach((item) => {
          if (item === card) return;
          item.classList.remove('is-selected');
          const chk = item.querySelector('.ndev-checkbox-input');
          if (chk) chk.checked = false;
        });

        if (checked) {
          const variantId = card.getAttribute('data-variant-id');
          const price = parseInt(card.getAttribute('data-price')) || 0;
          this._selected = { variantId, price, quantity: 1 };
          card.classList.add('is-selected');
        } else {
          this._selected = null;
          card.classList.remove('is-selected');
        }

        this.classList.toggle('has-selected', !!this._selected);
        this._emitSourceChange();
      }

      _emitSourceChange() {
        const items = [];
        let total = 0;

        if (this._selected) {
          total = this._selected.price;
          items.push({
            variantId: this._selected.variantId,
            quantity: 1,
            properties: {}
          });
        }

        if (!this._root) return;
        this._root.dispatchEvent(new CustomEvent('product-buy-box:source-change', {
          bubbles: true,
          composed: true,
          detail: {
            source: 'warranty',
            total,
            items
          }
        }));
      }

      _handleHelp() {
        if (!this._root) return;
        this._root.dispatchEvent(new CustomEvent('product-buy-box:modal-open', {
          bubbles: true,
          detail: {
            modalRole: 'warranty'
          }
        }));
      }
    }
    customElements.define('product-buy-box-warranty', ProductBuyBoxWarranty);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["ndev-button"] && !Shopify.designMode) return;
  try {
    (function () {
    'use strict';

    const NS = 'ndev-button';
    const ROOT_SELECTOR = '[data-ndev-button]';
    const INIT_ATTR = 'data-' + NS + '-initialized';

    const registryKey = '__ndevBlockControllers__';
    if (!window[registryKey]) window[registryKey] = {};
    if (!window[registryKey][NS]) window[registryKey][NS] = new WeakMap();
    const controllers = window[registryKey][NS];

    function trimAttr(value) {
      if (value == null) return '';
      const s = String(value).trim();
      return s;
    }

    function resolveVariantIdFromAncestors(el) {
      const blockRoot = el.closest('[data-ndev-button]');
      const start =
        blockRoot && blockRoot.parentElement ? blockRoot.parentElement : el.parentElement;
      if (!start) return '';
      const ndev = start.closest('[data-ndev-product-variant-id]');
      if (ndev) {
        const id = trimAttr(ndev.getAttribute('data-ndev-product-variant-id'));
        if (id) return id;
      }
      const legacy = start.closest('[data-variant-id]');
      if (legacy) {
        const id = trimAttr(legacy.getAttribute('data-variant-id'));
        if (id) return id;
      }
      return '';
    }

    function resolveCartPayload(el) {
      // 严格顺序：1–3（data-cart-variant-id）→ 4 祖先 dataset → 5（data-cart-variant-fallback-id）
      let variantId = trimAttr(el.getAttribute('data-cart-variant-id'));
      if (!variantId) {
        variantId = resolveVariantIdFromAncestors(el);
      }
      if (!variantId) {
        variantId = trimAttr(el.getAttribute('data-cart-variant-fallback-id'));
      }

      let variantPrice = trimAttr(el.getAttribute('data-cart-variant-price'));
      if (!variantPrice) {
        const ndevP = el.closest('[data-ndev-product-variant-price]');
        if (ndevP) variantPrice = trimAttr(ndevP.getAttribute('data-ndev-product-variant-price'));
      }
      if (!variantPrice) {
        const vp = el.closest('[data-variant-price]');
        if (vp) variantPrice = trimAttr(vp.getAttribute('data-variant-price'));
      }
      if (!variantPrice) variantPrice = '0';

      let variantTitle = trimAttr(el.getAttribute('data-cart-variant-title'));
      if (!variantTitle) {
        const ndevT = el.closest('[data-ndev-product-variant-title]');
        if (ndevT) variantTitle = trimAttr(ndevT.getAttribute('data-ndev-product-variant-title'));
      }
      if (!variantTitle) {
        const vt = el.closest('[data-variant-title]');
        if (vt) variantTitle = trimAttr(vt.getAttribute('data-variant-title'));
      }
      if (!variantTitle) variantTitle = 'default';

      return { variantId, variantPrice, variantTitle };
    }

    function destroyOne(root) {
      const controller = root ? controllers.get(root) : null;
      if (controller && typeof controller.destroy === 'function') controller.destroy();
      if (root) controllers.delete(root);
    }

    function initOne(root) {
      if (!root) return;

      destroyOne(root);
      root.setAttribute(INIT_ATTR, '1');

      const button = root.querySelector('.ndev-button__btn');
      if (!button) return;

      const purpose = button.getAttribute('data-btn-purpose');
      const isCart = purpose === 'cart';
      const isScroll = purpose === 'scroll';
      const cartIcon = button.querySelector('.ndev-button__cart-icon');
      let hiddenButton = null;
      let observer = null;

      // 购物车功能
      if (isCart && typeof $360 !== 'undefined' && typeof $360.addToCart === 'function') {
        hiddenButton = document.createElement('button');
        hiddenButton.style.display = 'none';
        document.body.appendChild(hiddenButton);

        observer = new MutationObserver(function (mutations) {
          mutations.forEach(function (mutation) {
            if (mutation.type === 'attributes' && mutation.attributeName === 'disabled') {
              if (hiddenButton.disabled) {
                button.classList.add('ndev-button__btn--loading');
                button.disabled = true;
                button.setAttribute('aria-busy', 'true');
              } else {
                button.classList.remove('ndev-button__btn--loading');
                button.disabled = false;
                button.removeAttribute('aria-busy');
              }
            }
          });
        });

        observer.observe(hiddenButton, {
          attributes: true,
          attributeFilter: ['disabled'],
        });

        const addToCart = function (options, event, buyNow) {
          const qty = options.qty;
          const variantId = options.variantId;
          const properties = options.properties;

          return $360.addToCart(
            {
              qty: qty,
              variantId: variantId,
              button: hiddenButton,
              properties: properties,
            },
            null,
            event,
            buyNow
          );
        };

        const cartData = {
          quantity: 1,
          buyNow: button.getAttribute('data-cart-buy-now') === 'true',
        };

        // 购物车图标点击（固定为加入购物车）
        if (cartIcon) {
          const handleCartIconClick = function (e) {
            e.preventDefault();
            e.stopPropagation();

            if (button.classList.contains('ndev-button__btn--disabled') || button.disabled) {
              return;
            }

            const resolved = resolveCartPayload(button);
            if (!resolved.variantId) {
              console.error('[ndev-button][NB-CART-01]');
              return;
            }

            if (typeof $narwal !== 'undefined' && typeof $narwal.report === 'function') {
              $narwal.report(e);
            }

            addToCart(
              {
                qty: cartData.quantity,
                variantId: resolved.variantId,
              },
              e,
              false
            );
          };

          cartIcon.addEventListener('click', handleCartIconClick);
          button._handleCartIconClick = handleCartIconClick;
        }

        // 按钮主体点击
        const handleMainClick = function (e) {
          if (cartIcon && e.target.closest('.ndev-button__cart-icon')) {
            return;
          }

          if (button.classList.contains('ndev-button__btn--disabled') || button.disabled) {
            e.preventDefault();
            e.stopPropagation();
            return;
          }

          if (typeof $narwal !== 'undefined' && typeof $narwal.report === 'function') {
            $narwal.report(e);
          }

          e.preventDefault();
          e.stopPropagation();

          const resolved = resolveCartPayload(button);
          if (!resolved.variantId) {
            console.error('[ndev-button][NB-CART-01]');
            return;
          }

          addToCart(
            {
              qty: cartData.quantity,
              variantId: resolved.variantId,
            },
            e,
            cartData.buyNow
          );
        };

        button.addEventListener('click', handleMainClick);
        button._handleMainClick = handleMainClick;
      }

      // 页面定位功能 (scroll 模式)
      if (isScroll) {
        const scrollType = button.getAttribute('data-scroll-type');
        const scrollOffset = button.getAttribute('data-scroll-offset');

        const handleScrollClick = function (e) {
          e.preventDefault();
          e.stopPropagation();

          let targetEl = null;

          if (scrollType === 'section_scroll') {
            const sectionIndex = parseInt(button.getAttribute('data-scroll-section-index')) || 1;
            const allSections = document.querySelectorAll('#main-content .shopify-section');
            if (allSections[sectionIndex - 1]) {
              targetEl = allSections[sectionIndex - 1];
            } else {
              console.warn('[ndev-button][NB-SCR-01]');
              return;
            }
          } else if (scrollType === 'anchor') {
            const selector = button.getAttribute('data-scroll-anchor');
            if (selector) {
              try {
                targetEl = document.querySelector(selector);
              } catch (err) {
                console.warn('[ndev-button][NB-SCR-02]');
                return;
              }
            }
            if (!targetEl) {
              console.warn('[ndev-button][NB-SCR-02]');
              return;
            }
          }

          if (!targetEl) {
            console.warn('[ndev-button][NB-SCR-03]');
            return;
          }

          const box = targetEl.getBoundingClientRect();
          const scrollTop = window.scrollY || document.documentElement.scrollTop;
          const targetTop = box.top + scrollTop;

          let offset = 0;
          if (scrollOffset) {
            offset = parseInt(scrollOffset);
          } else {
            const header = document.querySelector('#site-header');
            if (header) offset = header.offsetHeight;
            offset += 64;
          }

          const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          window.scrollTo({
            top: targetTop - offset,
            behavior: reducedMotion ? 'auto' : 'smooth',
          });

          if (typeof $narwal !== 'undefined' && typeof $narwal.report === 'function') {
            $narwal.report(e);
          }
        };

        button.addEventListener('click', handleScrollClick);
        button._handleScrollClick = handleScrollClick;
      }

      controllers.set(root, {
        root: root,
        destroy: function () {
          if (button._handleCartIconClick && cartIcon) {
            cartIcon.removeEventListener('click', button._handleCartIconClick);
          }
          if (button._handleMainClick) {
            button.removeEventListener('click', button._handleMainClick);
          }
          if (button._handleScrollClick) {
            button.removeEventListener('click', button._handleScrollClick);
          }
          if (observer) {
            observer.disconnect();
          }
          if (hiddenButton && hiddenButton.parentNode) {
            hiddenButton.parentNode.removeChild(hiddenButton);
          }
          try { root.removeAttribute(INIT_ATTR); } catch (e) {}
        }
      });
    }

    function initAll(scope) {
      const base = (scope && scope.querySelectorAll) ? scope : document;
      const list = base.querySelectorAll(ROOT_SELECTOR);
      for (let i = 0; i < list.length; i++) initOne(list[i]);
    }

    function destroyAll(scope) {
      const base = (scope && scope.querySelectorAll) ? scope : document;
      const list = base.querySelectorAll(ROOT_SELECTOR);
      for (let i = 0; i < list.length; i++) destroyOne(list[i]);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { initAll(); });
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', function (event) {
      initAll(event && event.target ? event.target : null);
    });

    document.addEventListener('shopify:section:unload', function (event) {
      destroyAll(event && event.target ? event.target : null);
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["ndev-capsule-tabs"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('ndev-capsule-tabs')) {
    class NdevCapsuleTabs extends BaseElement {
      init() {
        this.dispose();

        this.grid = this.querySelector('.ndev-capsule-tabs__grid');
        if (!this.grid) return;

        this.items = Array.from(this.grid.children)
          .filter((child) => child.classList.contains('ndev-tab'))
          .map((item) => ({
            tab: item.querySelector(':scope > .ndev-tab__title'),
            panel: item.querySelector(':scope > .ndev-tab__panel'),
          }))
          .filter((item) => item.tab && item.panel);
        this.tabs = this.items.map((item) => item.tab);
        this.panels = this.items.map((item) => item.panel);
        this.boundListeners = [];

        if (!this.tabs.length) return;
        this.updateGridColumns();

        this.tabs.forEach((tab, index) => {
          tab.classList.toggle('is-first', index === 0);
          tab.classList.toggle('is-last', index === this.tabs.length - 1);

          const clickHandler = () => this.activate(index, true);
          const keyHandler = (event) => this.handleKeydown(event, index);

          tab.addEventListener('click', clickHandler);
          tab.addEventListener('keydown', keyHandler);
          this.boundListeners.push([tab, 'click', clickHandler], [tab, 'keydown', keyHandler]);
        });

        const initialIndex = this.getInitialIndex();
        this.activate(initialIndex, false);
        this.classList.add('is-ready');
      }

      dispose() {
        if (this.boundListeners) {
          this.boundListeners.forEach(([target, eventName, handler]) => {
            target.removeEventListener(eventName, handler);
          });
        }
        this.boundListeners = [];
        this.classList.remove('is-ready');
        this.style.removeProperty('--capsule-tabs-grid-columns');
      }

      updateGridColumns() {
        const count = Math.max(this.tabs.length, 1);
        const tabTracks = `repeat(${count}, max-content)`;
        const align = this.getAttribute('tabs-align');
        let columns = `minmax(0, 1fr) ${tabTracks} minmax(0, 1fr)`;

        if (align === 'flex-start') {
          columns = `0 ${tabTracks} minmax(0, 1fr)`;
        } else if (align === 'flex-end') {
          columns = `minmax(0, 1fr) ${tabTracks} 0`;
        }

        this.style.setProperty('--capsule-tabs-grid-columns', columns);
      }

      getInitialIndex() {
        const expandedIndex = this.tabs.findIndex((tab) => tab.getAttribute('aria-expanded') === 'true');
        if (expandedIndex >= 0) return expandedIndex;

        const activePanelIndex = this.panels.findIndex((panel) => panel.classList.contains('active') || !panel.hasAttribute('hidden'));
        if (activePanelIndex >= 0) return activePanelIndex;

        return 0;
      }

      activate(index, focusTab) {
        if (!this.tabs.length) return;

        const normalizedIndex = (index + this.tabs.length) % this.tabs.length;

        this.tabs.forEach((tab, tabIndex) => {
          const isActive = tabIndex === normalizedIndex;
          tab.classList.toggle('is-active', isActive);
          tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
          tab.setAttribute('aria-expanded', isActive ? 'true' : 'false');
          tab.setAttribute('tabindex', isActive ? '0' : '-1');
          if (isActive && focusTab) tab.focus();
        });

        this.panels.forEach((panel, panelIndex) => {
          const isActive = panelIndex === normalizedIndex;
          panel.classList.toggle('active', isActive);
          panel.toggleAttribute('hidden', !isActive);
        });
      }

      handleKeydown(event, index) {
        let nextIndex = null;

        if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') {
          nextIndex = index - 1;
        } else if (event.key === 'ArrowRight' || event.key === 'ArrowDown') {
          nextIndex = index + 1;
        } else if (event.key === 'Home') {
          nextIndex = 0;
        } else if (event.key === 'End') {
          nextIndex = this.tabs.length - 1;
        }

        if (nextIndex == null) return;

        event.preventDefault();
        this.activate(nextIndex, true);
      }
    }

    customElements.define('ndev-capsule-tabs', NdevCapsuleTabs);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["ndev-card-group"] && !Shopify.designMode) return;
  try {
    (() => {
    'use strict';

    const ROOT_SELECTOR = '[data-ndev-card-group]';
    const INIT_ATTR = 'data-ndev-card-group-init';

    const registry = new WeakMap();

    function checkNavButtons(itemsEl, navEl, swiper) {
      if (!itemsEl || !navEl || !swiper) return;
      const needsScroll = itemsEl.scrollWidth > itemsEl.parentElement.offsetWidth + 1;
      if (needsScroll) {
        navEl.classList.add('show');
      } else {
        navEl.classList.remove('show');
      }
    }

    function formatPageNum(num) {
      return num < 10 ? '0' + num : '' + num;
    }

    function shouldUseSwiper(root) {
      const layout = root.dataset.layout || 'flex';
      const layoutMobile = root.dataset.layoutMobile || layout;
      const isMobile = window.innerWidth < 1024;
      return isMobile ? layoutMobile === 'swiper' : layout === 'swiper';
    }

    function initOne(root) {
      if (!root || root.getAttribute(INIT_ATTR) === '1') return;
      if (typeof window.Swiper === 'undefined') return;

      const itemsEl = root.querySelector('[data-card-group-items]');
      if (!itemsEl) return;

      const wrapper = root.closest('.ndev-card-group-wrapper') || root.parentElement;
      const navEl = wrapper ? wrapper.querySelector('[data-card-group-nav]') : null;
      const paginationEl = wrapper ? wrapper.querySelector('[data-card-group-pagination]') : null;

      let swiper = null;
      let resizeTimer = null;
      let lastWasMobile = window.innerWidth < 1024;
      let paginationClickHandler = null;

      function applySwiperDOM() {
        itemsEl.classList.add('swiper-wrapper');
        let count = 0;
        for (const child of itemsEl.children) {
          if (child.nodeType !== 1 || child.tagName === 'STYLE' || child.tagName === 'SCRIPT') continue;
          child.classList.add('swiper-slide');
          count++;
        }
        root.style.setProperty('--card-count', String(count));
      }

      function removeSwiperDOM() {
        itemsEl.classList.remove('swiper-wrapper');
        for (const child of itemsEl.children) {
          if (child.nodeType !== 1 || child.tagName === 'STYLE' || child.tagName === 'SCRIPT') continue;
          child.classList.remove('swiper-slide');
        }
      }

      function initSwiper() {
        if (swiper) return;
        applySwiperDOM();

        const config = {
          slidesPerView: 'auto',
          spaceBetween: 0,
          loop: false,
          grabCursor: true,
          watchSlidesProgress: true,
        };

        if (navEl) {
          const prevBtn = navEl.querySelector('.ndev-card-group__nav-btn--prev');
          const nextBtn = navEl.querySelector('.ndev-card-group__nav-btn--next');
          if (prevBtn && nextBtn) {
            config.navigation = {
              prevEl: prevBtn,
              nextEl: nextBtn,
              disabledClass: 'swiper-button-disabled',
            };
          }
        }

        if (paginationEl && root.dataset.showPagination === 'true') {
          const paginationType = root.dataset.paginationType;
          if (paginationType === 'numbered') {
            config.pagination = {
              el: paginationEl,
              type: 'custom',
              renderCustom: function (swiperInstance, current, total) {
                return (
                  '<div class="ndev-card-group__pagination-info">' +
                  '<span class="ndev-card-group__pagination-current">' +
                  formatPageNum(current) +
                  '</span>' +
                  '<span class="ndev-card-group__pagination-total">/' +
                  formatPageNum(total) +
                  '</span>' +
                  '</div>' +
                  '<div class="ndev-card-group__pagination-buttons">' +
                  '<button class="ndev-card-group__pagination-button ndev-card-group__pagination-button--prev" type="button" aria-label="Previous slide">' +
                  '<svg width="20" height="20" viewBox="0 0 20 20" fill="none"><path d="M12.5 15L7.5 10L12.5 5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>' +
                  '</button>' +
                  '<button class="ndev-card-group__pagination-button ndev-card-group__pagination-button--next" type="button" aria-label="Next slide">' +
                  '<svg width="20" height="20" viewBox="0 0 20 20" fill="none"><path d="M7.5 15L12.5 10L7.5 5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>' +
                  '</button>' +
                  '</div>'
                );
              },
            };
          } else {
            config.pagination = {
              el: paginationEl,
              type: 'bullets',
              clickable: true,
            };
          }
        }

        config.on = {
          init() {
            setTimeout(() => {
              updateCentering();
              if (navEl) checkNavButtons(itemsEl, navEl, swiper);
            }, 100);
          },
          resize() {
            updateCentering();
            if (navEl) checkNavButtons(itemsEl, navEl, swiper);
          },
        };

        swiper = new window.Swiper(root, config);

        if (paginationEl && root.dataset.showPagination === 'true' && root.dataset.paginationType === 'numbered') {
          paginationEl.classList.add('ndev-card-group__pagination--numbered');
          paginationClickHandler = function (e) {
            if (!swiper) return;
            let target = e.target;
            while (target && target !== paginationEl) {
              if (target.classList && target.classList.contains('ndev-card-group__pagination-button--prev')) {
                swiper.slidePrev();
                return;
              }
              if (target.classList && target.classList.contains('ndev-card-group__pagination-button--next')) {
                swiper.slideNext();
                return;
              }
              target = target.parentElement;
            }
          };
          paginationEl.addEventListener('click', paginationClickHandler);
        }
      }

      function destroySwiper() {
        if (!swiper) return;
        if (paginationClickHandler && paginationEl) {
          paginationEl.removeEventListener('click', paginationClickHandler);
          paginationClickHandler = null;
        }
        if (paginationEl) {
          paginationEl.classList.remove('ndev-card-group__pagination--numbered');
        }
        swiper.destroy(true, true);
        swiper = null;
        removeSwiperDOM();
        root.style.removeProperty('--ndev-group-justify');
      }

      function updateCentering() {
        if (!itemsEl.classList.contains('swiper-wrapper')) return;
        const containerWidth = root.offsetWidth;
        let totalSlideWidth = 0;
        for (const child of itemsEl.children) {
          if (child.nodeType !== 1 || child.tagName === 'STYLE' || child.tagName === 'SCRIPT') continue;
          const style = window.getComputedStyle(child);
          totalSlideWidth += child.offsetWidth + (parseFloat(style.marginRight) || 0);
        }
        if (totalSlideWidth <= containerWidth + 1) {
          root.style.setProperty('--ndev-group-justify', 'center');
        } else {
          root.style.setProperty('--ndev-group-justify', 'flex-start');
        }
      }

      function handleSwiperState() {
        if (shouldUseSwiper(root)) {
          initSwiper();
        } else {
          destroySwiper();
        }
      }

      handleSwiperState();

      const onResize = () => {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(() => {
          const isMobile = window.innerWidth < 1024;
          if (isMobile !== lastWasMobile) {
            lastWasMobile = isMobile;
            handleSwiperState();
          }
          if (swiper) {
            swiper.update();
            updateCentering();
            if (navEl) checkNavButtons(itemsEl, navEl, swiper);
          }
        }, 250);
      };

      window.addEventListener('resize', onResize);

      root.setAttribute(INIT_ATTR, '1');
      registry.set(root, {
        destroy() {
          window.removeEventListener('resize', onResize);
          clearTimeout(resizeTimer);
          destroySwiper();
          root.removeAttribute(INIT_ATTR);
        },
      });
    }

    function destroyOne(root) {
      const ctrl = registry.get(root);
      if (ctrl) ctrl.destroy();
      registry.delete(root);
    }

    function initAll(scope) {
      const base = scope && scope.querySelectorAll ? scope : document;
      base.querySelectorAll(ROOT_SELECTOR).forEach(initOne);
    }

    function destroyAll(scope) {
      const base = scope && scope.querySelectorAll ? scope : document;
      base.querySelectorAll(ROOT_SELECTOR).forEach(destroyOne);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initAll());
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', (e) => {
      initAll(e.target);
    });

    document.addEventListener('shopify:section:unload', (e) => {
      destroyAll(e.target);
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["ndev-countdown-timer"] && !Shopify.designMode) return;
  try {
    class NdevCountdownTimer extends BaseElement {
    createdCallback() {}

    init() {
      const initialRemaining = parseInt(this.getAttribute('remaining'), 10);
      this._lastAccessibleLabel = '';
      this._cacheElements();

      if (!initialRemaining || initialRemaining <= 0) {
        this._setUnitValues(0, 0, 0, 0);
        this._updateAccessibleLabel(0, 0, 0, 0);
        this._setExpired(true);
        this._syncExpiryVisibility();
        return;
      }

      this._startTime = performance.now();
      this._initialRemaining = initialRemaining;

      this.removeAttribute('hidden');
      this._setExpired(false);
      this._tick();
      this._interval = setInterval(() => this._tick(), 200);
    }

    dispose() {
      clearInterval(this._interval);
      this._daysEl = this._hoursEl = this._minutesEl = this._secondsEl = this._els = null;
    }

    _tick() {
      const elapsed = (performance.now() - this._startTime) / 1000;
      const remaining = Math.max(0, this._initialRemaining - elapsed);

      if (remaining <= 0) {
        this._setUnitValues(0, 0, 0, 0);
        this._updateAccessibleLabel(0, 0, 0, 0);
        this._setExpired(true);
        this._syncExpiryVisibility();
        this.dispose();
        return;
      }

      const days = Math.floor(remaining / 86400);
      const hours = Math.floor((remaining % 86400) / 3600);
      const minutes = Math.floor((remaining % 3600) / 60);
      const seconds = Math.floor(remaining % 60);

      this._maybeUpdate('days', days);
      this._maybeUpdate('hours', hours);
      this._maybeUpdate('minutes', minutes);
      this._maybeUpdate('seconds', seconds);
      this._updateAccessibleLabel(days, hours, minutes, seconds);
    }

    _cacheElements() {
      this._daysEl = this.querySelector('[data-unit="days"] .ndev-countdown-timer__num-current');
      this._hoursEl = this.querySelector('[data-unit="hours"] .ndev-countdown-timer__num-current');
      this._minutesEl = this.querySelector('[data-unit="minutes"] .ndev-countdown-timer__num-current');
      this._secondsEl = this.querySelector('[data-unit="seconds"] .ndev-countdown-timer__num-current');
      this._els = { days: this._daysEl, hours: this._hoursEl, minutes: this._minutesEl, seconds: this._secondsEl };
    }

    _setUnitValues(days, hours, minutes, seconds) {
      const values = { days, hours, minutes, seconds };
      Object.entries(values).forEach(([unit, value]) => {
        const el = this._els && this._els[unit];
        if (!el) return;
        el.textContent = String(value).padStart(2, '0');
      });
    }

    _updateAccessibleLabel(days, hours, minutes, seconds) {
      const label = [
        this.getAttribute('a11y-label') || 'Offer ends in',
        String(days).padStart(2, '0'),
        this.getAttribute('day-label') || 'days',
        String(hours).padStart(2, '0'),
        this.getAttribute('hour-label') || 'hours',
        String(minutes).padStart(2, '0'),
        this.getAttribute('minute-label') || 'minutes',
        String(seconds).padStart(2, '0'),
        this.getAttribute('second-label') || 'seconds'
      ].join(' ');

      if (this._lastAccessibleLabel === label) return;
      this._lastAccessibleLabel = label;
      this.setAttribute('aria-label', label);
    }

    _setExpired(isExpired) {
      if (isExpired) {
        if (this.hasAttribute('expired')) return;
        this.setAttribute('expired', '');
        this.dispatchEvent(new CustomEvent('ndev:countdown-expired', { bubbles: true }));
        return;
      }

      this.removeAttribute('expired');
    }

    _shouldAutoHide() {
      return this.getAttribute('auto-hide-on-expire') === 'true';
    }

    _syncExpiryVisibility() {
      if (this.hasAttribute('expired') && this._shouldAutoHide()) {
        this.setAttribute('hidden', '');
        return;
      }

      this.removeAttribute('hidden');
    }

    _maybeUpdate(unit, value) {
      const el = this._els[unit];
      if (!el) return;

      const formatted = String(value).padStart(2, '0');
      if (el.textContent.trim() === formatted) return;

      el.classList.add('animating', 'slide-out');

      const onSlideOutEnd = () => {
        el.removeEventListener('transitionend', onSlideOutEnd);

        el.classList.remove('animating', 'slide-out');
        void el.offsetWidth;

        el.textContent = formatted;
        el.classList.add('slide-in');
        void el.offsetWidth;

        el.classList.add('animating');

        requestAnimationFrame(() => {
          el.classList.remove('slide-in');

          const onSlideInEnd = () => {
            el.removeEventListener('transitionend', onSlideInEnd);
            el.classList.remove('animating');
          };
          el.addEventListener('transitionend', onSlideInEnd);
        });
      };

      el.addEventListener('transitionend', onSlideOutEnd);
    }

    static get observedAttributes() {
      return ['remaining', 'a11y-label', 'day-label', 'hour-label', 'minute-label', 'second-label', 'auto-hide-on-expire'];
    }

    attributeChangedCallback(name, oldValue, newValue) {
      if (oldValue === newValue) return;

      if (name === 'remaining') {
        this.dispose();
        this.init();
        return;
      }

      if (name === 'auto-hide-on-expire') {
        this._syncExpiryVisibility();
        return;
      }

      this._syncAccessibleLabelFromDom();
    }

    _syncAccessibleLabelFromDom() {
      const readValue = (unit) => {
        const el = this.querySelector(`[data-unit="${unit}"] .ndev-countdown-timer__num-current`);
        const value = Number.parseInt(el ? el.textContent : '0', 10);
        return Number.isFinite(value) ? value : 0;
      };

      this._updateAccessibleLabel(
        readValue('days'),
        readValue('hours'),
        readValue('minutes'),
        readValue('seconds')
      );
    }
  }

  if (!customElements.get('ndev-countdown-timer')) {
    customElements.define('ndev-countdown-timer', NdevCountdownTimer);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["ndev-klaviyo"] && !Shopify.designMode) return;
  try {
    (function () {
    'use strict';

    var NS = 'ndev-klaviyo';
    var ROOT_SELECTOR = '[data-ndev-klaviyo]';
    var INIT_ATTR = 'data-' + NS + '-initialized';

    var registryKey = '__ndevBlockControllers__';
    if (!window[registryKey]) window[registryKey] = {};
    if (!window[registryKey][NS]) window[registryKey][NS] = new WeakMap();
    var controllers = window[registryKey][NS];

    function destroyOne(root) {
      var controller = root ? controllers.get(root) : null;
      if (controller && typeof controller.destroy === 'function') controller.destroy();
      if (root) controllers.delete(root);
    }

    function initOne(root) {
      if (!root) return;

      destroyOne(root);
      root.setAttribute(INIT_ATTR, '1');

      var form = root.querySelector('[data-form]');
      var emailInput = root.querySelector('input[type="email"]');
      var submitBtn = root.querySelector('[data-submit-btn]');
      var agreeCheckbox = root.querySelector('[data-agree-checkbox]');
      var agreementError = root.querySelector('[data-agreement-error]');
      var errorMessage = root.querySelector('[data-error-message]');
      var successMessage = root.querySelector('[data-success-message]');

      // 从 data 属性读取配置
      var apiKey = root.dataset.klaviyoApiKey || '';
      var listId = root.dataset.klaviyoListId || '';
      var requireAgreement = root.dataset.requireAgreement === 'true';
      var successMsg = root.dataset.successMessage || '';
      var errorMsg = root.dataset.errorMessage || '';
      var emailEmptyMsg = root.dataset.emailEmptyMessage || '';
      var emailInvalidMsg = root.dataset.emailInvalidMessage || '';
      var alreadyMsg = root.dataset.emailAlreadyRegisteredMessage || '';
      var enableFbq = root.dataset.enableFbq || false;

      function showError(msg) {
        if (errorMessage) {
          errorMessage.textContent = msg;
          errorMessage.hidden = false;
        }
        if (successMessage) {
          successMessage.hidden = true;
        }
      }

      function showSuccess(msg) {
        if (successMessage) {
          successMessage.textContent = msg;
          successMessage.hidden = false;
        }
        if (errorMessage) {
          errorMessage.hidden = true;
        }
        if (agreementError) {
          agreementError.hidden = true;
        }
      }

      function hideMessages() {
        if (errorMessage) errorMessage.hidden = true;
        if (successMessage) successMessage.hidden = true;
        if (agreementError) agreementError.hidden = true;
      }

      function setLoading(loading) {
        if (submitBtn) {
          submitBtn.disabled = loading;
          submitBtn.textContent = loading ? '...' : submitBtn.dataset.originalText;
        }
      }

      // 保存按钮原始文案
      if (submitBtn) {
        submitBtn.dataset.originalText = submitBtn.textContent.trim();
      }

      function handleSubmit(event) {
        event.preventDefault();
        hideMessages();

        var email = emailInput ? emailInput.value.trim() : '';
        var agreed = !requireAgreement || (agreeCheckbox && agreeCheckbox.checked);

        // 验证邮箱
        if (!email) {
          showError(emailEmptyMsg || errorMsg || 'Please enter your email address.');
          return;
        }
        if (!window.$klaviyo || !window.$klaviyo.validateEmail(email)) {
          showError(emailInvalidMsg || errorMsg || 'This email is invalid.');
          return;
        }

        // 验证协议勾选
        if (!agreed) {
          if (agreementError) agreementError.hidden = false;
          return;
        }

        setLoading(true);

        // 调用 Klaviyo API
        if (window.$klaviyo && window.$klaviyo.subscribe) {
          window.$klaviyo.subscribe({
            email: email,
            apiKey: apiKey,
            listId: listId,
            ga4: {
              module: root.dataset.ga4Module || '',
              btn: root.dataset.ga4Btn || 'subscribe'
            }
          }).then(function (result) {
            setLoading(false);

            if (result.success) {
              showSuccess(successMsg || 'Thank you for subscribing!');
              if (emailInput) emailInput.value = '';
              if (agreeCheckbox) agreeCheckbox.checked = false;
              if (enableFbq) fbq?.('track', 'Lead');
            } else {
              // 解析错误信息
              var msg = result.error || errorMsg || 'Subscription failed. Please try again.';
              var errorMsgLower = (msg || '').toLowerCase();

              if (errorMsgLower.indexOf('already') !== -1 || errorMsgLower.indexOf('exists') !== -1) {
                showError(alreadyMsg || 'This email is already registered.');
              } else {
                showError(msg);
              }
            }
          }).catch(function () {
            setLoading(false);
            showError(errorMsg || 'Subscription failed. Please try again.');
          });
        } else {
          setLoading(false);
          showError('Klaviyo API not loaded.');
        }
      }

      // 绑定事件
      if (form) {
        form.addEventListener('submit', handleSubmit);
      }

      // 输入时清除错误
      if (emailInput) {
        emailInput.addEventListener('input', hideMessages);
      }
      if (agreeCheckbox) {
        agreeCheckbox.addEventListener('change', hideMessages);
      }

      controllers.set(root, {
        root: root,
        destroy: function () {
          if (form) form.removeEventListener('submit', handleSubmit);
          if (emailInput) emailInput.removeEventListener('input', hideMessages);
          if (agreeCheckbox) agreeCheckbox.removeEventListener('change', hideMessages);
          try { root.removeAttribute(INIT_ATTR); } catch (e) {}
        }
      });
    }

    function initAll(scope) {
      var base = (scope && scope.querySelectorAll) ? scope : document;
      var list = base.querySelectorAll(ROOT_SELECTOR);
      for (var i = 0; i < list.length; i++) initOne(list[i]);
    }

    function destroyAll(scope) {
      var base = (scope && scope.querySelectorAll) ? scope : document;
      var list = base.querySelectorAll(ROOT_SELECTOR);
      for (var i = 0; i < list.length; i++) destroyOne(list[i]);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { initAll(); });
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', function (event) {
      initAll(event && event.target ? event.target : null);
    });

    document.addEventListener('shopify:section:unload', function (event) {
      destroyAll(event && event.target ? event.target : null);
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["ndev-ksp-card"] && !Shopify.designMode) return;
  try {
    (function () {
    'use strict';

    if (customElements.get('ndev-ksp-card')) return;

    class NdevKspCard extends BaseElement {
      init() {
        this.dispose();
        if (!this.querySelector('.ndev-ksp-card__icon')) return;

        this.handleClick = (event) => {
          if (event.target.closest('a, button, input, select, textarea, summary, video')) return;
          const pos = parseInt(this.getAttribute('position'), 10);
          if (!pos) return;

          const sections = document.querySelectorAll('#main-content .shopify-section');
          const section = sections[pos - 1];
          if (section) {
            section.scrollIntoView({ behavior: 'smooth', block: 'start' });
          }
        };

        this.handleKeydown = (event) => {
          if (event.target !== this) return;
          if (event.key !== 'Enter' && event.key !== ' ') return;
          event.preventDefault();
          this.handleClick(event);
        };

        this.addEventListener('click', this.handleClick);
        this.addEventListener('keydown', this.handleKeydown);
      }

      dispose() {
        if (this.handleClick) {
          this.removeEventListener('click', this.handleClick);
          this.handleClick = null;
        }
        if (this.handleKeydown) {
          this.removeEventListener('keydown', this.handleKeydown);
          this.handleKeydown = null;
        }
      }
    }

    customElements.define('ndev-ksp-card', NdevKspCard);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["ndev-product-price"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('product-buy-box-product-price')) {
    class ProductBuyBoxProductPrice extends BaseElement {
      init() {
        this._root = this.closest('product-buy-box');
        this._onVariantChange = (e) => this._update(e.detail || {});
        this._root?.addEventListener('product-buy-box:variant-change', this._onVariantChange);
        const paypalMessage = this._root?.querySelector('[data-paypal-message]');
        if (paypalMessage) this._updatePayPalMessage(paypalMessage.getAttribute('data-amount'));
      }

      dispose() {
        this._root?.removeEventListener('product-buy-box:variant-change', this._onVariantChange);
      }

      _formatMoney(cents) {
        return $360.formatMoney(cents);
      }

      _splitMoney(cents) {
        const full = this._formatMoney(cents);
        const decimalSeparator = this.getAttribute('decimal-separator') || ',';
        const withoutCurrency = full.replace(/[^\d,.]/g, '').trim();
        const currencySymbol = full.replace(withoutCurrency, '').trim();
        const parts = withoutCurrency.split(decimalSeparator);

        return {
          currencySymbol,
          integer: parts[0] || '0',
          decimal: parts[1] || '00',
          decimalSeparator
        };
      }

      _updateInstallments(price) {
        this._updateKlarnaPlacement(price);
        this._updatePayPalMessage(price);
      }

      _updateKlarnaPlacement(amountCents) {
        try {
          const cents = Number(amountCents);
          if (!Number.isFinite(cents) || cents <= 0) return;

          const placement = this._root?.querySelector('klarna-placement');
          if (!placement) return;

          placement.setAttribute('data-purchase-amount', String(cents));
          window.KlarnaOnsiteService?.push({ eventName: 'refresh-placements' });
        } catch (e) {}
      }

      _updatePayPalMessage(amountCents) {
        try {
          if (typeof PayPalSDK === 'undefined' || !PayPalSDK || typeof PayPalSDK.Messages !== 'function') return;

          const cents = Number(amountCents);
          if (!Number.isFinite(cents) || cents <= 0) return;

          const container = this._root?.querySelector('[data-paypal-message]');
          if (!container) return;

          container.setAttribute('data-amount', String(cents));
          container.innerHTML = '';

          PayPalSDK.Messages({
            amount: cents / 100,
            placement: 'product',
            buyerCountry: this.getAttribute('paypal-buyer-country') || ''
          }).render(container);
        } catch (e) {}
      }

      _update(detail) {
        const price = Number(detail.price);
        if (!Number.isFinite(price) || price <= 0) return;

        const compare = Number(detail.compareAtPrice) || 0;
        const showComparePrice = this.getAttribute('show-compare-price') !== 'false';
        const showDiscount = this.getAttribute('show-discount') !== 'false';
        const hasCompare = showComparePrice && compare > price;
        const compareRow = this.querySelector('[data-price-compare-row]');
        const discount = this.querySelector('[data-price-discount]');
        const compareEl = this.querySelector('[data-price-compare]');
        const integerEl = this.querySelector('[data-price-integer]');
        const decimalEl = this.querySelector('[data-price-decimal]');
        const currencyEl = this.querySelector('[data-price-currency]');

        if (compareRow) compareRow.hidden = !hasCompare;
        if (compareEl && hasCompare) compareEl.textContent = this._formatMoney(compare);
        if (discount) {
          discount.hidden = !showDiscount;
          if (hasCompare && showDiscount) {
            const discountPercentage = Math.round(((compare - price) * 100) / compare);
            discount.textContent = `-${discountPercentage}%`;
          }
        }

        const splitPrice = this._splitMoney(price);
        const symbolOnEnd = this.getAttribute('decimal-symbol-on-end') === 'true';
        if (integerEl) {
          integerEl.textContent = `${symbolOnEnd ? '' : splitPrice.currencySymbol}${splitPrice.integer}${splitPrice.decimalSeparator}`;
        }
        if (decimalEl) decimalEl.textContent = splitPrice.decimal;
        if (currencyEl) currencyEl.textContent = symbolOnEnd ? splitPrice.currencySymbol : '';

        this._updateInstallments(price);
      }
    }
    customElements.define('product-buy-box-product-price', ProductBuyBoxProductPrice);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["ndev-spin"] && !Shopify.designMode) return;
  try {
    (function () {
    'use strict';

    const ROOT_SELECTOR = '[data-ndev-spin]';
    const INIT_ATTR = 'data-ndev-spin-initialized';
    const HEIGHT_BUFFER = 1;
    const SYNC_DEBOUNCE_MS = 300;
    const LAZY_ROOT_MARGIN = '200px 0px';
    const DESKTOP_MQ = window.matchMedia('(min-width: 1024px)');

    function isCacheEnabled(root) {
      return root.getAttribute('data-ndev-spin-cache') !== 'false';
    }

    function isLazyEnabled(root) {
      return root.getAttribute('data-ndev-spin-lazy') === 'true';
    }

    function getStorageKey(embed) {
      const dataId = embed.getAttribute('data-id');
      if (!dataId) return null;
      return 'ndev-spin-h:' + dataId + (DESKTOP_MQ.matches ? ':pc' : ':mb');
    }

    function applyCachedHeight(embed, root) {
      if (!isCacheEnabled(root)) return;

      try {
        const key = getStorageKey(embed);
        if (!key) return;

        const cached = parseInt(localStorage.getItem(key), 10);
        if (!cached || cached <= 0) return;

        embed.style.height = cached + 'px';
        embed.style.minHeight = cached + 'px';
      } catch (e) {}
    }

    function saveCachedHeight(embed, root, height) {
      if (!isCacheEnabled(root)) return;

      try {
        const key = getStorageKey(embed);
        if (!key || !height || height <= 0) return;
        localStorage.setItem(key, String(height));
      } catch (e) {}
    }

    function clearCachedHeight(embed, root) {
      if (!isCacheEnabled(root)) return;

      try {
        const key = getStorageKey(embed);
        if (key) localStorage.removeItem(key);
      } catch (e) {}
    }

    function hasEmbedContent(embed) {
      if (!embed) return false;

      for (let i = 0; i < embed.childNodes.length; i++) {
        const node = embed.childNodes[i];
        if (node.nodeType === 1) return true;
        if (node.nodeType === 3 && node.textContent.trim()) return true;
      }

      return false;
    }

    function resetEmbedShell(embed) {
      embed.style.height = '';
      embed.style.minHeight = '';
      embed.style.overflow = '';
    }

    function clearEmbedHeight(embed, root) {
      embed.style.height = '0';
      embed.style.minHeight = '0';
      embed.style.overflow = 'hidden';

      const container = embed.querySelector('#crazyrocket-iframe-container');
      if (container) {
        container.style.height = '0';
      }

      const iframe = embed.querySelector('iframe');
      if (iframe) iframe.style.height = '0';

      clearCachedHeight(embed, root);
    }

    const controllers = new WeakMap();
    const embedStates = new WeakMap();

    function prepareMeasurementShell(embed, iframe, shellHeight) {
      const height = Math.max(Math.ceil(shellHeight), 1);
      const container = embed.querySelector('#crazyrocket-iframe-container');

      embed.style.height = height + 'px';
      embed.style.minHeight = height + 'px';
      if (container) container.style.height = height + 'px';
      iframe.style.height = height + 'px';
    }

    function measureRequiredHeight(doc) {
      const body = doc.body;
      if (!body) return 0;

      const view = doc.defaultView;
      const origin = body.getBoundingClientRect().top;
      let maxBottom = body.offsetHeight || 0;

      body.querySelectorAll('*').forEach(function (el) {
        const style = view.getComputedStyle(el);
        if (style.display === 'none' || style.visibility === 'hidden') return;

        const rect = el.getBoundingClientRect();
        if (rect.width === 0 && rect.height === 0) return;

        if (style.position === 'fixed') {
          // fixed 相对 iframe 视口；不参与 body scrollHeight，但会决定可见区域需求
          maxBottom = Math.max(maxBottom, rect.bottom);
          return;
        }

        maxBottom = Math.max(maxBottom, rect.bottom - origin);
      });

      return Math.ceil(maxBottom);
    }

    function measureIframeContent(embed, iframe, shellHeight) {
      try {
        const doc = iframe.contentDocument || iframe.contentWindow?.document;
        if (!doc?.body) return 0;

        prepareMeasurementShell(embed, iframe, shellHeight);
        return measureRequiredHeight(doc);
      } catch (e) {
        return 0;
      }
    }

    function lockIframeDocument(iframe) {
      try {
        const doc = iframe.contentDocument || iframe.contentWindow?.document;
        if (!doc) return;

        if (doc.documentElement) {
          doc.documentElement.style.overflow = 'hidden';
        }
        if (doc.body) {
          doc.body.style.overflow = 'hidden';
        }
      } catch (e) {}
    }

    function applyOuterHeight(embed, iframe, nextHeight) {
      embed.style.height = nextHeight + 'px';
      embed.style.minHeight = nextHeight + 'px';

      const container = embed.querySelector('#crazyrocket-iframe-container');
      if (container) {
        container.style.height = nextHeight + 'px';
      }

      iframe.style.height = nextHeight + 'px';
      lockIframeDocument(iframe);
      return nextHeight;
    }

    function readPlaceholderHeight(embed) {
      const parsed = parseFloat(getComputedStyle(embed).height);
      return Number.isFinite(parsed) && parsed > 0 ? Math.ceil(parsed) : 0;
    }

    function bindIframe(root, embed, iframe) {
      let syncTimer = 0;
      let isSyncing = false;
      let domObserver = null;
      let lastApplied = readPlaceholderHeight(embed);

      resetEmbedShell(embed);

      const teardown = function () {
        clearTimeout(syncTimer);
        if (domObserver) {
          domObserver.disconnect();
          domObserver = null;
        }
      };

      const applyHeight = function (rawHeight) {
        const next = Math.ceil(rawHeight) + HEIGHT_BUFFER;
        if (Math.abs(next - lastApplied) <= 1) return false;
        lastApplied = applyOuterHeight(embed, iframe, next);
        return true;
      };

      const sync = function () {
        if (isSyncing) return;

        if (!hasEmbedContent(embed) || !embed.contains(iframe)) {
          teardown();
          controllers.delete(root);
          clearEmbedHeight(embed, root);
          return;
        }

        isSyncing = true;

        try {
          const height = measureIframeContent(embed, iframe, lastApplied);
          if (height <= 0) return;

          if (applyHeight(height)) {
            saveCachedHeight(embed, root, lastApplied);
          }
        } finally {
          isSyncing = false;
        }
      };

      const scheduleSync = function () {
        clearTimeout(syncTimer);
        syncTimer = setTimeout(sync, SYNC_DEBOUNCE_MS);
      };

      const observeDomChanges = function () {
        try {
          const doc = iframe.contentDocument || iframe.contentWindow?.document;
          if (!doc?.body || domObserver) return;

          domObserver = new MutationObserver(scheduleSync);
          domObserver.observe(doc.body, {
            childList: true,
            subtree: true,
            attributes: true,
            attributeFilter: ['class', 'style', 'hidden', 'aria-hidden'],
          });
        } catch (e) {}
      };

      const onLoad = function () {
        sync();
        observeDomChanges();
      };

      controllers.set(root, {
        sync: scheduleSync,
        teardown: teardown,
        embed: embed,
      });

      if (iframe.contentDocument?.readyState === 'complete') {
        onLoad();
      } else {
        iframe.addEventListener('load', onLoad, { once: true });
      }

      window.addEventListener('resize', scheduleSync);
    }

    function handleEmbedState(root, embed) {
      const state = embedStates.get(embed) || { hadContent: false };
      embedStates.set(embed, state);

      const iframe = embed.querySelector('iframe');

      if (!hasEmbedContent(embed)) {
        if (!state.hadContent) return;

        const controller = controllers.get(root);
        if (controller?.teardown) controller.teardown();
        controllers.delete(root);
        clearEmbedHeight(embed, root);
        state.hadContent = false;
        return;
      }

      state.hadContent = true;
      resetEmbedShell(embed);

      if (!iframe) return;

      if (!controllers.has(root)) {
        bindIframe(root, embed, iframe);
        return;
      }

      controllers.get(root).sync();
    }

    function watchEmbed(root) {
      const embed =
        root.querySelector('#crazyrocket-embed') ||
        root.querySelector('[id*="crazyrocket"]');

      if (!embed) return;

      embedStates.set(embed, { hadContent: false });

      let embedStateTimer = 0;

      const scheduleEmbedState = function () {
        clearTimeout(embedStateTimer);
        embedStateTimer = setTimeout(function () {
          handleEmbedState(root, embed);
        }, SYNC_DEBOUNCE_MS);
      };

      applyCachedHeight(embed, root);
      handleEmbedState(root, embed);

      const embedMo = new MutationObserver(scheduleEmbedState);
      embedMo.observe(embed, { childList: true, subtree: true });
    }

    function startWatching(root) {
      watchEmbed(root);

      if (!isCacheEnabled(root)) return;

      const embed =
        root.querySelector('#crazyrocket-embed') ||
        root.querySelector('[id*="crazyrocket"]');
      if (!embed) return;

      const onBreakpointChange = function () {
        applyCachedHeight(embed, root);
        const controller = controllers.get(root);
        if (controller) controller.sync();
      };

      DESKTOP_MQ.addEventListener('change', onBreakpointChange);
    }

    function initRoot(root) {
      if (!root || root.getAttribute(INIT_ATTR) === 'true') return;
      root.setAttribute(INIT_ATTR, 'true');

      const embed =
        root.querySelector('#crazyrocket-embed') ||
        root.querySelector('[id*="crazyrocket"]');
      if (embed) applyCachedHeight(embed, root);

      if (isLazyEnabled(root) && 'IntersectionObserver' in window) {
        const io = new IntersectionObserver(
          function (entries) {
            if (!entries.some(function (entry) {
              return entry.isIntersecting;
            })) {
              return;
            }
            io.disconnect();
            startWatching(root);
          },
          { rootMargin: LAZY_ROOT_MARGIN }
        );
        io.observe(root);
        return;
      }

      startWatching(root);
    }

    function initAll() {
      document.querySelectorAll(ROOT_SELECTOR).forEach(initRoot);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', initAll);
    document.addEventListener('shopify:block:select', initAll);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["ndev-swiper-list"] && !Shopify.designMode) return;
  try {
    (function () {
    'use strict';

    var NS = 'ndev-swiper-list';
    var ROOT_SELECTOR = '[data-ndev-swiper-list]';
    var INIT_ATTR = 'data-' + NS + '-initialized';

    var registryKey = '__ndevBlockControllers__';
    if (!window[registryKey]) window[registryKey] = {};
    if (!window[registryKey][NS]) window[registryKey][NS] = new WeakMap();
    var controllers = window[registryKey][NS];

    /** 子 block 的 style 标签会紧跟根节点输出，不能算作一页 */
    var SLIDE_SKIP_TAGS = { STYLE: 1, SCRIPT: 1, LINK: 1, NOSCRIPT: 1, TEMPLATE: 1 };

    function queryItems(track) {
      if (!track || !track.children) return [];
      var out = [];
      for (var k = 0; k < track.children.length; k++) {
        var el = track.children[k];
        if (!el || el.nodeType !== 1) continue;
        if (SLIDE_SKIP_TAGS[el.tagName]) continue;
        out.push(el);
      }
      return out;
    }

    function formatPageNum(num) {
      return num < 10 ? '0' + num : '' + num;
    }

    /** 与 CSS stroke-dasharray 一致：r=18 时周长约 113.1 */
    var PROGRESS_RING_LENGTH = 113.1;

    function readTrackTranslateX(track) {
      try {
        var s = window.getComputedStyle(track).transform;
        if (!s || s === 'none') return 0;
        var m = new DOMMatrixReadOnly(s);
        return m.m41;
      } catch (eTx) {
        return 0;
      }
    }

    function getFrameContentBox(frame) {
      var fr = frame.getBoundingClientRect();
      var st = window.getComputedStyle(frame);
      var bl = parseFloat(st.borderLeftWidth) || 0;
      var br = parseFloat(st.borderRightWidth) || 0;
      var pl = parseFloat(st.paddingLeft) || 0;
      var pr = parseFloat(st.paddingRight) || 0;
      var W = frame.clientWidth;
      if (W <= 0 && fr.width > 0) {
        W = Math.max(0, fr.width - bl - br - pl - pr);
      }
      var left = fr.left + bl + pl;
      return { left: left, width: W, right: left + W, mid: left + W / 2 };
    }

    function computeTrackTranslateX(frame, track, item) {
      var box = getFrameContentBox(frame);
      var W = box.width;
      if (W <= 0) return 0;
      var cr = item.getBoundingClientRect();
      var tr = track.getBoundingClientRect();
      var T = track.offsetWidth;
      var txCur = readTrackTranslateX(track);

      var d = box.mid - (cr.left + cr.width / 2);

      var dCardLo = box.left - cr.left;
      var dCardHi = box.right - cr.right;
      d = Math.max(dCardLo, Math.min(d, dCardHi));

      if (T > W + 0.5) {
        var dTrackLo = box.right - tr.right;
        var dTrackHi = box.left - tr.left;
        d = Math.max(dTrackLo, Math.min(dTrackHi, d));
      }

      return txCur + d;
    }

    function destroyOne(root) {
      var controller = root ? controllers.get(root) : null;
      if (controller && typeof controller.destroy === 'function') controller.destroy();
      if (root) controllers.delete(root);
    }

    function initOne(root) {
      if (!root) return;

      destroyOne(root);

      var frame = root.querySelector('[data-ndev-swiper-list-frame]');
      var track = root.querySelector('[data-ndev-swiper-list-track]');
      if (!frame || !track) return;

      var items = queryItems(track);
      if (!items.length) return;

      var paginationEl = root.querySelector('[data-ndev-swiper-list-pagination]');
      var paginationCurrentEl = paginationEl
        ? paginationEl.querySelector('[data-ndev-swiper-list-pagination-current]')
        : null;
      var paginationTotalEl = paginationEl
        ? paginationEl.querySelector('[data-ndev-swiper-list-pagination-total]')
        : null;
      var paginationPrevBtn = paginationEl
        ? paginationEl.querySelector('.ndev-swiper-list__pagination-button--prev')
        : null;
      var paginationNextBtn = paginationEl
        ? paginationEl.querySelector('.ndev-swiper-list__pagination-button--next')
        : null;
      var ringHost = paginationNextBtn
        ? paginationNextBtn.querySelector('[data-ndev-swiper-list-ring-host]')
        : null;
      var hidePaginationOnePage = root.getAttribute('data-hide-pagination-one-page') !== 'false';

      root.setAttribute(INIT_ATTR, '1');

      var index = 0;
      var timer = null;
      var ro = null;
      var io = null;
      var reducedMotion = false;
      var resumeTimer = null;
      var inViewKickTimer = null;
      var ringRafId = null;

      try {
        reducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      } catch (e) {}

      var autoplayOn = root.getAttribute('data-autoplay') === 'true' && !reducedMotion;
      var autoplayMs = parseInt(root.getAttribute('data-autoplay-speed'), 10) || 3000;
      var autoplayInView = (root.getAttribute('data-autoplay-start') || 'immediate').trim() === 'in_view';

      if (autoplayOn && ringHost) {
        while (ringHost.firstChild) {
          ringHost.removeChild(ringHost.firstChild);
        }
        var ringSvg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
        ringSvg.setAttribute('class', 'ndev-swiper-list__progress-ring-svg');
        ringSvg.setAttribute('viewBox', '0 0 40 40');
        var ringCircle = document.createElementNS('http://www.w3.org/2000/svg', 'circle');
        ringCircle.setAttribute('class', 'ndev-swiper-list__progress-ring');
        ringCircle.setAttribute('cx', '20');
        ringCircle.setAttribute('cy', '20');
        ringCircle.setAttribute('r', '18');
        ringSvg.appendChild(ringCircle);
        ringHost.appendChild(ringSvg);
      }

      function getProgressRing() {
        return paginationEl ? paginationEl.querySelector('.ndev-swiper-list__progress-ring') : null;
      }

      function stopProgressRingAnim() {
        if (ringRafId !== null) {
          cancelAnimationFrame(ringRafId);
          ringRafId = null;
        }
      }

      function setRingDashOffset(ring, value) {
        if (!ring || !ring.style) return;
        ring.style.strokeDashoffset = String(value);
      }

      function resetProgressRingIdle(ring) {
        if (!ring) return;
        stopProgressRingAnim();
        setRingDashOffset(ring, PROGRESS_RING_LENGTH);
      }

      function startProgressRingAnim(ring) {
        if (!ring || !autoplayOn) return;
        stopProgressRingAnim();
        var duration = autoplayMs;
        if (duration <= 0) return;
        setRingDashOffset(ring, PROGRESS_RING_LENGTH);
        var t0 = typeof performance !== 'undefined' && performance.now ? performance.now() : Date.now();
        function step() {
          var t1 = typeof performance !== 'undefined' && performance.now ? performance.now() : Date.now();
          var elapsed = t1 - t0;
          if (elapsed >= duration) {
            setRingDashOffset(ring, 0);
            ringRafId = null;
            return;
          }
          setRingDashOffset(ring, PROGRESS_RING_LENGTH * (1 - elapsed / duration));
          ringRafId = requestAnimationFrame(step);
        }
        ringRafId = requestAnimationFrame(step);
      }

      function refreshPaginationVisibility() {
        if (!paginationEl) return;
        var lock = hidePaginationOnePage && items.length <= 1;
        paginationEl.classList.toggle('ndev-swiper-list__pagination--lock', lock);
        try {
          paginationEl.setAttribute('aria-hidden', lock ? 'true' : 'false');
        } catch (eRing) {}
      }

      function updatePaginationNumbers() {
        if (!paginationCurrentEl || !paginationTotalEl) return;
        paginationCurrentEl.textContent = formatPageNum(index + 1);
        paginationTotalEl.textContent = '/' + formatPageNum(items.length);
      }

      function updatePaginationDisabled() {
        if (!paginationPrevBtn || !paginationNextBtn) return;
        var lock = items.length <= 1;
        paginationPrevBtn.disabled = lock;
        paginationNextBtn.disabled = lock;
      }

      function setClasses(n) {
        var prevIdx = index;
        index = n;
        for (var c = 0; c < items.length; c++) {
          items[c].classList.toggle('actived', c === n);
        }
        updatePaginationNumbers();
        updatePaginationDisabled();
        if (autoplayOn && prevIdx !== n) {
          startProgressRingAnim(getProgressRing());
        }
      }

      function scrollToItem(n, smooth) {
        var item = items[n];
        if (!item) return;
        var tx = computeTrackTranslateX(frame, track, item);
        var useMotion = smooth && !reducedMotion;
        if (useMotion) {
          track.classList.remove('ndev-swiper-list__track--instant');
        } else {
          track.classList.add('ndev-swiper-list__track--instant');
        }
        track.style.transform = 'translate3d(' + tx + 'px,0,0)';
        if (!useMotion) {
          void track.offsetWidth;
          track.classList.remove('ndev-swiper-list__track--instant');
        }
      }

      function setActive(i, instant) {
        if (!items.length) return;
        var n = ((i % items.length) + items.length) % items.length;
        setClasses(n);
        scrollToItem(n, !instant);
      }

      function next() {
        setActive(index + 1);
      }

      function stopTimer() {
        if (timer) {
          clearInterval(timer);
          timer = null;
        }
      }

      function startTimer() {
        stopTimer();
        if (!autoplayOn || items.length < 2) return;
        timer = setInterval(next, autoplayMs);
        startProgressRingAnim(getProgressRing());
      }

      function inViewport() {
        var r = root.getBoundingClientRect();
        var vh = window.innerHeight || document.documentElement.clientHeight || 0;
        var vw = window.innerWidth || document.documentElement.clientWidth || 0;
        return r.bottom > 0 && r.top < vh && r.right > 0 && r.left < vw;
      }

      function pauseInteraction() {
        stopTimer();
        if (resumeTimer) {
          clearTimeout(resumeTimer);
          resumeTimer = null;
        }
        resetProgressRingIdle(getProgressRing());
      }

      function scheduleResume() {
        if (!autoplayOn) return;
        resumeTimer = setTimeout(function () {
          resumeTimer = null;
          if (autoplayInView && !inViewport()) return;
          startTimer();
        }, 2200);
      }

      function bindResize() {
        if (typeof ResizeObserver === 'undefined') {
          window.addEventListener('resize', relayout);
          return;
        }
        ro = new ResizeObserver(relayout);
        ro.observe(frame);
      }

      function unbindResize() {
        if (ro) {
          ro.disconnect();
          ro = null;
        }
        window.removeEventListener('resize', relayout);
      }

      function relayout() {
        scrollToItem(index, false);
      }

      bindResize();

      function setupAutoplay() {
        if (!autoplayOn) return;
        root.addEventListener('touchstart', pauseInteraction, { passive: true });
        root.addEventListener('touchend', scheduleResume, { passive: true });
        if (autoplayInView && typeof IntersectionObserver !== 'undefined') {
          io = new IntersectionObserver(
            function (entries) {
              var ok = entries.some(function (en) {
                return en.isIntersecting;
              });
              if (ok) {
                startTimer();
              } else {
                stopTimer();
                resetProgressRingIdle(getProgressRing());
              }
            },
            { root: null, threshold: 0 }
          );
          io.observe(root);
          inViewKickTimer = setTimeout(function () {
            inViewKickTimer = null;
            if (inViewport()) startTimer();
          }, 50);
        } else {
          startTimer();
        }
      }

      function onItemClick(e) {
        var node = e.target;
        while (node && node !== track) {
          if (node.parentElement === track) {
            for (var i = 0; i < items.length; i++) {
              if (items[i] === node) {
                setActive(i);
                startTimer();
                return;
              }
            }
          }
          node = node.parentElement;
        }
      }

      function onPaginationClick(e) {
        if (!paginationEl) return;
        var target = e.target;
        while (target && target !== paginationEl) {
          if (target.classList && target.classList.contains('ndev-swiper-list__pagination-button--prev')) {
            pauseInteraction();
            setActive(index - 1);
            scheduleResume();
            return;
          }
          if (target.classList && target.classList.contains('ndev-swiper-list__pagination-button--next')) {
            pauseInteraction();
            setActive(index + 1);
            scheduleResume();
            return;
          }
          target = target.parentElement;
        }
      }

      refreshPaginationVisibility();
      updatePaginationNumbers();
      updatePaginationDisabled();
      track.addEventListener('click', onItemClick);
      if (paginationEl) {
        paginationEl.addEventListener('click', onPaginationClick);
      }

      function kick() {
        setActive(0, true);
        setupAutoplay();
      }

      if (typeof requestAnimationFrame === 'function') {
        requestAnimationFrame(kick);
      } else {
        kick();
      }

      controllers.set(root, {
        root: root,
        destroy: function () {
          stopTimer();
          stopProgressRingAnim();
          if (resumeTimer) clearTimeout(resumeTimer);
          if (inViewKickTimer) clearTimeout(inViewKickTimer);
          unbindResize();
          track.removeEventListener('click', onItemClick);
          if (paginationEl) {
            paginationEl.removeEventListener('click', onPaginationClick);
          }
          if (autoplayOn) {
            root.removeEventListener('touchstart', pauseInteraction);
            root.removeEventListener('touchend', scheduleResume);
          }
          try {
            track.classList.add('ndev-swiper-list__track--instant');
            track.style.transform = '';
            track.classList.remove('ndev-swiper-list__track--instant');
          } catch (eTrack) {}
          if (io) {
            io.disconnect();
            io = null;
          }
          try {
            root.removeAttribute(INIT_ATTR);
          } catch (e2) {}
        },
      });
    }

    function initAll(scope) {
      var base = scope && scope.querySelectorAll ? scope : document;
      var list = base.querySelectorAll(ROOT_SELECTOR);
      for (var i = 0; i < list.length; i++) initOne(list[i]);
    }

    function destroyAll(scope) {
      var base = scope && scope.querySelectorAll ? scope : document;
      var list = base.querySelectorAll(ROOT_SELECTOR);
      for (var j = 0; j < list.length; j++) destroyOne(list[j]);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        initAll();
      });
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', function (event) {
      initAll(event && event.target ? event.target : null);
    });

    document.addEventListener('shopify:section:unload', function (event) {
      destroyAll(event && event.target ? event.target : null);
    });

    document.addEventListener('shopify:section:load', function (event) {
      initAll(event && event.target ? event.target : null);
    });

    document.addEventListener('shopify:section:unload', function (event) {
      destroyAll(event && event.target ? event.target : null);
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["ndev-swiper"] && !Shopify.designMode) return;
  try {
    (function () {
    'use strict';

    const NS = 'ndev-swiper';
    const ROOT_SELECTOR = '[data-ndev-swiper]';
    const INIT_ATTR = 'data-' + NS + '-initialized';

    const registryKey = '__ndevBlockControllers__';
    if (!window[registryKey]) window[registryKey] = {};
    if (!window[registryKey][NS]) window[registryKey][NS] = new WeakMap();
    const controllers = window[registryKey][NS];

    function formatPageNum(num) {
      return num < 10 ? '0' + num : '' + num;
    }

    function restartProgressRingAnim(ring) {
      if (!ring || !ring.classList) return;
      ring.classList.remove('ndev-swiper__progress-ring--anim');
      void ring.offsetWidth;
      ring.classList.add('ndev-swiper__progress-ring--anim');
    }

    function renderPagination(swiper, current, total, progressRingHtml) {
      return (
        '<div class="ndev-swiper__pagination-info">' +
        '<span class="ndev-swiper__pagination-current">' +
        formatPageNum(current) +
        '</span>' +
        '<span class="ndev-swiper__pagination-total">/' +
        formatPageNum(total) +
        '</span>' +
        '</div>' +
        '<div class="ndev-swiper__pagination-buttons">' +
        '<button class="ndev-swiper__pagination-button ndev-swiper__pagination-button--prev" type="button" aria-label="Previous slide">' +
        '<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">' +
        '<path d="M12.5 15L7.5 10L12.5 5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>' +
        '</svg>' +
        '</button>' +
        '<button class="ndev-swiper__pagination-button ndev-swiper__pagination-button--next" type="button" aria-label="Next slide">' +
        (progressRingHtml || '') +
        '<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">' +
        '<path d="M7.5 15L12.5 10L7.5 5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>' +
        '</svg>' +
        '</button>' +
        '</div>'
      );
    }

    function checkNavigationButtons(swiperEl, navButtons, swiper) {
      if (!swiperEl || !navButtons || !swiper) return;
      const wrapper = swiperEl.querySelector('.swiper-wrapper');
      if (!wrapper) return;

      const containerWidth = swiperEl.offsetWidth;
      const contentWidth = wrapper.scrollWidth;

      if (contentWidth > containerWidth) {
        navButtons.classList.add('show');
        navButtons.setAttribute('aria-hidden', 'false');
      } else {
        navButtons.classList.remove('show');
        navButtons.setAttribute('aria-hidden', 'true');
      }
    }

    function destroyOne(root) {
      const controller = root ? controllers.get(root) : null;
      if (controller && typeof controller.destroy === 'function') controller.destroy();
      if (root) controllers.delete(root);
    }

    function initOne(root) {
      if (!root || root.getAttribute(INIT_ATTR) === '1') return;
      if (typeof window.Swiper === 'undefined') return;

      const swiperEl = root.querySelector('.ndev-swiper__swiper');
      const navButtons = root.querySelector('.ndev-swiper__nav-buttons');
      const paginationEl = root.querySelector('.ndev-swiper__pagination');
      if (!swiperEl) return;

      // 检查是否启用移动端纵向布局
      var mbVerticalLayout = root.getAttribute('data-mb-vertical-layout') === 'true';
      var isMobile = window.innerWidth < 1024;

      // 移动端纵向布局模式下跳过 Swiper 初始化，但允许 PC 端切换时重新初始化
      if (mbVerticalLayout && isMobile) {
        let mbVerticalResizeTimeout = 0;
        const onMbVerticalResize = () => {
          if (mbVerticalResizeTimeout) window.clearTimeout(mbVerticalResizeTimeout);
          mbVerticalResizeTimeout = window.setTimeout(() => {
            if (window.innerWidth >= 1024) {
              window.removeEventListener('resize', onMbVerticalResize);
              initOne(root);
            }
          }, 250);
        };
        window.addEventListener('resize', onMbVerticalResize);
        controllers.set(root, {
          root: root,
          destroy: function () {
            window.removeEventListener('resize', onMbVerticalResize);
            if (mbVerticalResizeTimeout) window.clearTimeout(mbVerticalResizeTimeout);
          }
        });
        return;
      }

      // 检查是否启用侧边导航和底部翻页器（通过元素是否存在判断）
      var enableSideNavigation = !!navButtons;
      var enableBottomPagination = !!paginationEl;
      // 读取自动轮播配置
      var autoplayEnabled = root.getAttribute('data-autoplay') === 'true';
      var autoplaySpeed = parseInt(root.getAttribute('data-autoplay-speed'), 10) || 3000;
      var autoplayStart = (root.getAttribute('data-autoplay-start') || 'immediate').trim();
      var autoplayWhenInView = autoplayStart === 'in_view';

      // 检查是否有 slides，如果没有则延迟初始化（等待子 blocks 渲染）
      var slides = swiperEl.querySelectorAll('.swiper-slide');
      if (!slides || slides.length === 0) {
        window.setTimeout(function () {
          initOne(root);
        }, 50);
        return;
      }

      const totalSlides = slides.length;

      // 读取配置
      var slidesPerViewPc = parseInt(root.getAttribute('data-slides-per-view-pc'), 10) || 0;
      var slidesPerViewMb = parseInt(root.getAttribute('data-slides-per-view-mb'), 10) || 0;
      // 读取间距配置（从 CSS 变量获取）
      var cardGapPc = parseInt(getComputedStyle(root).getPropertyValue('--card-gap').trim(), 10) || 0;
      var cardGapMb = parseInt(getComputedStyle(root).getPropertyValue('--card-gap').trim(), 10) || 0;
      // 读取是否只有一页时隐藏翻页器
      var hidePaginationWhenOnePage = root.getAttribute('data-hide-pagination-one-page') !== 'false';

      // 根据开关获取对应的导航元素
      var navNextEl = null;
      var navPrevEl = null;
      if (enableSideNavigation) {
        navNextEl = root.querySelector('.ndev-swiper__nav-button--next');
        navPrevEl = root.querySelector('.ndev-swiper__nav-button--prev');
      }

      var progressRingHtml = '';
      if (autoplayEnabled && enableBottomPagination) {
        // in_view：初始不带 --anim，避免离屏时 CSS 动画已跑；入屏后由 JS 触发 restart
        var ringCircleClass = 'ndev-swiper__progress-ring';
        if (!autoplayWhenInView) {
          ringCircleClass += ' ndev-swiper__progress-ring--anim';
        }
        progressRingHtml =
          '<svg class="ndev-swiper__progress-ring-svg" viewBox="0 0 40 40" xmlns="http://www.w3.org/2000/svg">' +
          '<circle class="' +
          ringCircleClass +
          '" cx="20" cy="20" r="18" />' +
          '</svg>';
      }

      // 构建 Swiper 配置
      var swiperConfig = {
        slidesPerView: slidesPerViewMb === 0 ? 'auto' : slidesPerViewMb,
        spaceBetween: cardGapMb,
        loop: false,
        grabCursor: true,
        snapToSlideEdge: true,
        breakpoints: {
          1024: {
            slidesPerView: slidesPerViewPc === 0 ? 'auto' : slidesPerViewPc,
            spaceBetween: cardGapPc
          }
        }
      };

      if (autoplayEnabled) {
        swiperConfig.autoplay = {
          delay: autoplaySpeed,
          disableOnInteraction: false
        };
      }

      if (navNextEl && navPrevEl) {
        swiperConfig.navigation = {
          nextEl: navNextEl,
          prevEl: navPrevEl,
          disabledClass: 'swiper-button-disabled'
        };
      }

      if (enableBottomPagination && paginationEl) {
        swiperConfig.pagination = {
          el: paginationEl,
          type: 'custom',
          renderCustom: function (s, current, total) {
            // 只有一页且启用隐藏时，返回空字符串
            if (hidePaginationWhenOnePage && total === 1) {
              return '';
            }
            return renderPagination(s, current, total, progressRingHtml);
          }
        };
      }

      swiperConfig.on = {
        init: function () {
          if (enableSideNavigation) {
            window.setTimeout(() => checkNavigationButtons(swiperEl, navButtons, swiper), 100);
          }
        },
        autoplayPause: function () {
          // 暂停时移除动画类
          if (enableBottomPagination && paginationEl) {
            var ring = paginationEl.querySelector('.ndev-swiper__progress-ring');
            if (ring) ring.classList.remove('ndev-swiper__progress-ring--anim');
          }
        },
        autoplayResume: function () {
          // 恢复时重触发动画（仅加 class 可能无法从中间态重启 keyframes）
          if (enableBottomPagination && paginationEl) {
            var ring = paginationEl.querySelector('.ndev-swiper__progress-ring');
            restartProgressRingAnim(ring);
          }
        },
        paginationRender: function () {
          if (!autoplayWhenInView || !autoplayEnabled || !enableBottomPagination || !paginationEl) return;
          var inst = this;
          if (!isRootInViewport()) return;
          if (!inst.autoplay || !inst.autoplay.running) return;
          var ring = paginationEl.querySelector('.ndev-swiper__progress-ring');
          restartProgressRingAnim(ring);
        }
      };

      const swiper = new window.Swiper(swiperEl, swiperConfig);

      var autoplayVisibilityIo = null;
      function isRootInViewport() {
        var r = root.getBoundingClientRect();
        var vh = window.innerHeight || document.documentElement.clientHeight;
        var vw = window.innerWidth || document.documentElement.clientWidth;
        var inViewport = r.bottom > 0 && r.right > 0 && r.left < vw && r.top < vh;
        // 检查元素是否真正可见（不仅是在视口内）
        return inViewport && root.checkVisibility();
      }
      function setAutoplayByVisibility(visible) {
        if (!autoplayEnabled || !swiper.autoplay) return;
        if (visible) {
          swiper.autoplay.start();
          if (autoplayWhenInView && enableBottomPagination && paginationEl) {
            window.requestAnimationFrame(function () {
              window.requestAnimationFrame(function () {
                if (!swiper.autoplay || !swiper.autoplay.running) return;
                var ring = paginationEl.querySelector('.ndev-swiper__progress-ring');
                restartProgressRingAnim(ring);
              });
            });
          }
        } else {
          swiper.autoplay.stop();
          if (enableBottomPagination && paginationEl) {
            var ringOff = paginationEl.querySelector('.ndev-swiper__progress-ring');
            if (ringOff) ringOff.classList.remove('ndev-swiper__progress-ring--anim');
          }
        }
      }
      if (autoplayEnabled && autoplayWhenInView) {
        setAutoplayByVisibility(isRootInViewport());
        if (typeof IntersectionObserver !== 'undefined') {
          autoplayVisibilityIo = new IntersectionObserver(
            function (entries) {
              for (var e = 0; e < entries.length; e++) {
                if (entries[e].target === root) {
                  // 检查元素是否在视口内且真正可见
                  var isVisible = entries[e].isIntersecting && root.checkVisibility();
                  setAutoplayByVisibility(isVisible);
                  break;
                }
              }
            },
            { root: null, rootMargin: '0px', threshold: 0 }
          );
          autoplayVisibilityIo.observe(root);
        }
      }

      // 底部翻页器按钮事件委托（由 renderCustom 渲染）
      var handlePaginationClick = function (e) {
        if (!enableBottomPagination) return;
        var target = e.target;
        // 向上查找是否是按钮
        while (target && target !== paginationEl) {
          if (target.classList && target.classList.contains('ndev-swiper__pagination-button--prev')) {
            swiper.slidePrev();
            return;
          }
          if (target.classList && target.classList.contains('ndev-swiper__pagination-button--next')) {
            swiper.slideNext();
            return;
          }
          target = target.parentElement;
        }
      };
      if (enableBottomPagination && paginationEl) {
        paginationEl.addEventListener('click', handlePaginationClick);
      }

      // resize 时检测窗口宽度变化，处理移动端纵向布局切换
      let resizeTimeout = 0;
      let lastIsMobile = isMobile;
      const onResize = () => {
        if (resizeTimeout) window.clearTimeout(resizeTimeout);
        resizeTimeout = window.setTimeout(() => {
          const currentIsMobile = window.innerWidth < 1024;
          // PC → 移动端，且启用了纵向布局：销毁 Swiper，切换为纵向布局模式
          if (!lastIsMobile && currentIsMobile && mbVerticalLayout) {
            destroyOne(root);
            initOne(root);
            return;
          }
          // 移动端（纵向布局）→ PC：销毁纵向布局控制器，重新初始化 Swiper
          if (lastIsMobile && !currentIsMobile && mbVerticalLayout) {
            destroyOne(root);
            initOne(root);
            return;
          }
          lastIsMobile = currentIsMobile;
          if (enableSideNavigation) {
            checkNavigationButtons(swiperEl, navButtons, swiper);
          }
          swiper.update();
        }, 250);
      };
      window.addEventListener('resize', onResize);

      root.setAttribute(INIT_ATTR, '1');
      controllers.set(root, {
        root: root,
        destroy: function () {
          window.removeEventListener('resize', onResize);
          if (resizeTimeout) window.clearTimeout(resizeTimeout);
          if (autoplayVisibilityIo) {
            try {
              autoplayVisibilityIo.disconnect();
            } catch (_) {}
            autoplayVisibilityIo = null;
          }
          // 移除分页器按钮事件监听
          if (paginationEl) paginationEl.removeEventListener('click', handlePaginationClick);
          try {
            swiper.destroy(true, true);
          } catch (_) {}
          root.removeAttribute(INIT_ATTR);
        },
      });
    }

    function initAll(scope) {
      const base = scope && scope.querySelectorAll ? scope : document;
      const list = base.querySelectorAll(ROOT_SELECTOR);
      for (var i = 0; i < list.length; i++) initOne(list[i]);
    }

    function destroyAll(scope) {
      const base = scope && scope.querySelectorAll ? scope : document;
      const list = base.querySelectorAll(ROOT_SELECTOR);
      for (var i = 0; i < list.length; i++) destroyOne(list[i]);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        initAll();
      });
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', function (event) {
      initAll(event && event.target ? event.target : null);
    });

    document.addEventListener('shopify:section:unload', function (event) {
      destroyAll(event && event.target ? event.target : null);
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
